
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("forzB", function(module, exports) {

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $jD5no = parcelRequire("jD5no");

var $2cigx = parcelRequire("2cigx");

var $jsLXn = parcelRequire("jsLXn");

var $6SC3U = parcelRequire("6SC3U");

var $9F6Ii = parcelRequire("9F6Ii");
(0, $2cigx.provideHealthcheck)();
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $9e8101c1be28bf43$var$container = document.createElement('div');
$9e8101c1be28bf43$var$container.id = 'profilecard-app';
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
document.body && document.body.appendChild($9e8101c1be28bf43$var$container);
(0, $7nsd3.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9F6Ii.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsLXn.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
    id: "profilecard-next"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6SC3U.ProfileCardLegacy), null)))), $9e8101c1be28bf43$var$container);

});
parcelRegister("2cigx", function(module, exports) {

$parcel$export(module.exports, "provideHealthcheck", () => $eec8e8449eafd9c1$export$90dcee7ddb8a0c0c);
const $eec8e8449eafd9c1$var$globalObj = window || $parcel$global;
const $eec8e8449eafd9c1$var$defaultHealthcheck = (callback)=>callback({
        isSuccess: true
    });
const $eec8e8449eafd9c1$export$90dcee7ddb8a0c0c = (healthcheck = $eec8e8449eafd9c1$var$defaultHealthcheck)=>{
    $eec8e8449eafd9c1$var$globalObj.performHealthcheck = healthcheck;
};

});

parcelRegister("6SC3U", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLegacy", () => $041ceaf6ad56ccb8$export$dd0591e04a6e8ce6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $5y0F0 = parcelRequire("5y0F0");

var $koVbs = parcelRequire("koVbs");

var $90yGq = parcelRequire("90yGq");


var $f5xXn = parcelRequire("f5xXn");

var $7I2zi = parcelRequire("7I2zi");

var $7kyNN = parcelRequire("7kyNN");
const $041ceaf6ad56ccb8$export$dd0591e04a6e8ce6 = ({ externalProfileClient: externalProfileClient, actions: actions })=>{
    const intl = (0, $koVbs.default)();
    const currentUserAccountId = (0, $90yGq.useAccountId)();
    const onLoadError = (error, analyticsEvent)=>{
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${analyticsEvent.payload.actionSubject} ${analyticsEvent.payload.action}`, `${analyticsEvent.payload.actionSubject}${analyticsEvent.payload.action}`, {
            error: error
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: (0, $e6a2e0952e4731b8$export$50632e21ea714398)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5xXn.ProfileCardWrapper), {
        externalProfileClient: externalProfileClient,
        onLoadError: onLoadError
    }, currentUserAccountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($041ceaf6ad56ccb8$var$LegacyProfileCardStyled, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7kyNN.ProfileCardLegacyView), {
            onGetActions: (accountId, onActionCleanup)=>(0, $7I2zi.getSpaActions)(accountId, intl, push, actions, onActionCleanup),
            onProfileClick: (profileAccountId)=>push(`/jira/people/${profileAccountId}`)
        }))) : null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $041ceaf6ad56ccb8$var$LegacyProfileCardStyled = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1pbyb4wl",
            __cmplp.className
        ])
    });
});

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("90yGq", function(module, exports) {

$parcel$export(module.exports, "useAccountId", () => $903db0de2618ef6c$export$e72033e0f5baa3e);

var $9OXo1 = parcelRequire("9OXo1");
const $903db0de2618ef6c$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});

const $e6a2e0952e4731b8$export$81319ffa9c0d18d7 = 'profileCardNext';
const $e6a2e0952e4731b8$export$50632e21ea714398 = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $e6a2e0952e4731b8$export$23cedd3261bd8015 = 'viewProfile';
const $e6a2e0952e4731b8$export$6bef782d14a92db8 = 'assignedIssues';
const $e6a2e0952e4731b8$export$6b36f20db7a18a86 = 'reportedIssues';
const $e6a2e0952e4731b8$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("f5xXn", function(module, exports) {

$parcel$export(module.exports, "ProfileCardWrapper", () => $05053b3a38034fd2$export$59abd6feb7dc8540);

var $5uXOq = parcelRequire("5uXOq");

var $koeKL = parcelRequire("koeKL");

var $90yGq = parcelRequire("90yGq");

var $4oO9d = parcelRequire("4oO9d");

var $gLmUz = parcelRequire("gLmUz");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $9l5Jv = parcelRequire("9l5Jv");
const $05053b3a38034fd2$var$ProfileCardWrapperWithoutOrgId = ({ externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const accountId = (0, $90yGq.useAccountId)();
    const fabricPfDirUrl = (0, $gLmUz.useFabricProfileDirectoryUrl)();
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9l5Jv.ProfileClientContainer), {
        fabricPfDirUrl: fabricPfDirUrl,
        profileClient: externalProfileClient || null,
        onLoadError: onLoadError,
        cloudId: cloudId,
        // Only use the global store when no external client is provided
        isGlobal: (0, $4R6GH.fg)('empanada_fix_profilecard_missing_client_store') ? !externalProfileClient : true
    }, children);
    // When there is no tenantContext, this will cause the child
    // component of <ProfileCard> to render without being wrapped by
    // a profile card and it will do nothing on hover
    return children;
};
const $05053b3a38034fd2$var$ProfileCardWrapperWithOrgId = ({ externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const accountId = (0, $90yGq.useAccountId)();
    const fabricPfDirUrl = (0, $gLmUz.useFabricProfileDirectoryUrl)();
    const orgId = (0, $4oO9d.useOrgId)();
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9l5Jv.ProfileClientContainer), {
        fabricPfDirUrl: fabricPfDirUrl,
        profileClient: externalProfileClient || null,
        onLoadError: onLoadError,
        cloudId: cloudId,
        // Only use the global store when no external client is provided
        isGlobal: (0, $4R6GH.fg)('empanada_fix_profilecard_missing_client_store') ? !externalProfileClient : true,
        orgId: orgId
    }, children);
    // When there is no tenantContext, this will cause the child
    // component of <ProfileCard> to render without being wrapped by
    // a profile card and it will do nothing on hover
    return children;
};
const $05053b3a38034fd2$export$59abd6feb7dc8540 = (0, $cSD7y.componentWithFG)('issue_view_prevent_unnecessary_orgid_query', $05053b3a38034fd2$var$ProfileCardWrapperWithOrgId, $05053b3a38034fd2$var$ProfileCardWrapperWithoutOrgId);

});
parcelRegister("koeKL", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $559e3c14e9652b55$export$9da0f7c65f28ed16);

var $9OXo1 = parcelRequire("9OXo1");
const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("4oO9d", function(module, exports) {

$parcel$export(module.exports, "useOrgId", () => $554c0ec604398cd6$export$52a03a3207af3687);

var $9OXo1 = parcelRequire("9OXo1");
const $554c0ec604398cd6$export$52a03a3207af3687 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.orgId;
};

});

parcelRegister("gLmUz", function(module, exports) {

$parcel$export(module.exports, "useFabricProfileDirectoryUrl", () => $53e785fb2e37b84f$export$cb9379d435214a54);

var $9OXo1 = parcelRequire("9OXo1");
const $53e785fb2e37b84f$export$cb9379d435214a54 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.fabricPfDirUrl || '';
};

});

parcelRegister("9l5Jv", function(module, exports) {

$parcel$export(module.exports, "createUserProfileCardClient", () => $85b7b963f4e84597$export$c4393c51e6d104c3);
$parcel$export(module.exports, "ProfileClientContainer", () => $85b7b963f4e84597$export$d816ba2709570028);
$parcel$export(module.exports, "useProfileClient", () => $85b7b963f4e84597$export$d43dc22a8337ee9f);

var $juq2W = parcelRequire("juq2W");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $58UyI = parcelRequire("58UyI");
const $85b7b963f4e84597$var$GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
const $85b7b963f4e84597$var$createUserProfileCardClientWithoutOrgId = (fabricPfDirUrl, onLoadError, gatewayGraphqlUrl, cloudId, _orgId)=>{
    const userClient = new (0, $58UyI.CustomUserProfileClient)(fabricPfDirUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $juq2W.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId
    }, {
        userClient: userClient
    });
};
const $85b7b963f4e84597$var$createUserProfileCardClientWithOrgId = (fabricPfDirUrl, onLoadError, gatewayGraphqlUrl, cloudId, orgId)=>{
    const userClient = new (0, $58UyI.CustomUserProfileClient)(fabricPfDirUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $juq2W.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId,
        orgId: orgId
    }, {
        userClient: userClient
    });
};
const $85b7b963f4e84597$export$c4393c51e6d104c3 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('issue_view_prevent_unnecessary_orgid_query'), $85b7b963f4e84597$var$createUserProfileCardClientWithOrgId, $85b7b963f4e84597$var$createUserProfileCardClientWithoutOrgId);
const $85b7b963f4e84597$export$e324594224ef24da = {
    bootstrap: ()=>({ setState: setState }, { fabricPfDirUrl: fabricPfDirUrl, profileClient: profileClient, onLoadError: onLoadError, cloudId: cloudId, orgId: orgId })=>{
            if ((0, $4R6GH.fg)('issue_view_prevent_unnecessary_orgid_query')) {
                const finalProfileClient = profileClient || $85b7b963f4e84597$var$createUserProfileCardClientWithOrgId(fabricPfDirUrl ?? '', onLoadError, $85b7b963f4e84597$var$GATEWAY_GRAPHQL_URL, cloudId, orgId);
                setState({
                    profileClient: finalProfileClient
                });
            } else {
                const finalProfileClient = profileClient || $85b7b963f4e84597$var$createUserProfileCardClientWithoutOrgId(fabricPfDirUrl ?? '', onLoadError, $85b7b963f4e84597$var$GATEWAY_GRAPHQL_URL, cloudId);
                setState({
                    profileClient: finalProfileClient
                });
            }
        }
};
const $85b7b963f4e84597$export$d816ba2709570028 = (0, $gg7kZ.createContainer)({
    displayName: 'ProfileClientContainer'
});
const $85b7b963f4e84597$export$d4c72bab9d6cc13a = {
    profileClient: null
};
const $85b7b963f4e84597$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'ProfileClientStore',
    initialState: $85b7b963f4e84597$export$d4c72bab9d6cc13a,
    actions: $85b7b963f4e84597$export$e324594224ef24da,
    containedBy: $85b7b963f4e84597$export$d816ba2709570028,
    handlers: {
        onInit: ()=>({ dispatch: dispatch })=>dispatch($85b7b963f4e84597$export$e324594224ef24da.bootstrap())
    }
});
const $85b7b963f4e84597$export$d43dc22a8337ee9f = (0, $3sQ5x.createStateHook)($85b7b963f4e84597$export$6f57813fe9f31bf9);

});
parcelRegister("juq2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $23792da22668dcfb$export$2e2bcd8739ae039);

var $2ys8y = parcelRequire("2ys8y");
var $b4PzF = parcelRequire("b4PzF");

var $kAPet = parcelRequire("kAPet");

var $652W8 = parcelRequire("652W8");

var $hJRFB = parcelRequire("hJRFB");

var $cdyCC = parcelRequire("cdyCC");
const $23792da22668dcfb$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $23792da22668dcfb$var$ProfileCardClient {
    constructor(config, clients){
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$23792da22668dcfb$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $23792da22668dcfb$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $cdyCC.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $hJRFB.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $kAPet.default)(withDefaultConfig);
        this.tcClient = $23792da22668dcfb$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    async getTeamCentralBaseUrl(teamCentralScopes) {
        if (this.tcClient === undefined) return Promise.resolve(undefined);
        const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
        if (!isGlobalExperienceWorkspace) return Promise.resolve((0, $2ys8y.getATLContextUrl)('team'));
        let suffix = '';
        if (teamCentralScopes !== undefined) {
            const orgId = await this.tcClient.getOrgId();
            if (orgId === null) return Promise.resolve(undefined);
            suffix += `/o/${orgId}`;
            if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
        }
        return Promise.resolve(`${(0, $2ys8y.getATLContextUrl)('home')}${suffix}`);
    }
    async shouldShowGiveKudos() {
        if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    getRovoAgentPermissions(id, fireAnalytics) {
        return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
}
function $23792da22668dcfb$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $b4PzF.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = config.teamCentralDisabled !== true;
    return teamCentralEnabled ? new (0, $652W8.default)({
        ...config
    }) : undefined;
}
var $23792da22668dcfb$export$2e2bcd8739ae039 = $23792da22668dcfb$var$ProfileCardClient;

});
parcelRegister("kAPet", function(module, exports) {

$parcel$export(module.exports, "default", () => $af582d71804b9dd0$export$2e2bcd8739ae039);

var $jQ0hK = parcelRequire("jQ0hK");

var $1P8ZX = parcelRequire("1P8ZX");

var $c4uSJ = parcelRequire("c4uSJ");

var $j92Xk = parcelRequire("j92Xk");
const $af582d71804b9dd0$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $af582d71804b9dd0$export$2e2bcd8739ae039 extends (0, $c4uSJ.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(id, cloudId) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $af582d71804b9dd0$var$createHeaders(product, this.options.cloudId);
        if (id.type === 'identity') return fetch(new Request(`/gateway/api/assist/agents/v1/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        return fetch(new Request(`/gateway/api/assist/agents/v1/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1P8ZX.getPageTime)();
            if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('succeeded', 'request', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('failed', 'request', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    ...(0, $j92Xk.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1P8ZX.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('triggered'));
            const headers = $af582d71804b9dd0$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('failed', 'deleteAgent', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    ...(0, $j92Xk.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $1P8ZX.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('triggered', 'actionSubjectId'));
            const headers = $af582d71804b9dd0$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('succeeded', actionSubjectId, {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('failed', actionSubjectId, {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    ...(0, $j92Xk.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1P8ZX.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics((0, $jQ0hK.agentRequestAnalytics)('triggered'));
            const headers = $af582d71804b9dd0$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics((0, $jQ0hK.agentRequestAnalytics)('succeeded', 'getAgentPermissions', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics((0, $jQ0hK.agentRequestAnalytics)('failed', 'getAgentPermissions', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    ...(0, $j92Xk.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("jQ0hK", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $85e2a5a074f627a8$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $85e2a5a074f627a8$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $85e2a5a074f627a8$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $85e2a5a074f627a8$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $85e2a5a074f627a8$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $85e2a5a074f627a8$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $85e2a5a074f627a8$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $85e2a5a074f627a8$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $85e2a5a074f627a8$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $85e2a5a074f627a8$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $85e2a5a074f627a8$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $85e2a5a074f627a8$export$a9f8c9f412cf5664);

var $1P8ZX = parcelRequire("1P8ZX");
/** Below lines are copied from teams common analytics */ const $85e2a5a074f627a8$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $85e2a5a074f627a8$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $85e2a5a074f627a8$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $85e2a5a074f627a8$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($85e2a5a074f627a8$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $85e2a5a074f627a8$var$TEAM_SUBJECT = 'teamProfileCard';
const $85e2a5a074f627a8$var$USER_SUBJECT = 'profilecard';
const $85e2a5a074f627a8$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $85e2a5a074f627a8$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $1P8ZX.getPageTime)())
        }
    });
const $85e2a5a074f627a8$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $85e2a5a074f627a8$var$USER_SUBJECT;
        case 'team':
            return $85e2a5a074f627a8$var$TEAM_SUBJECT;
        case 'agent':
            return $85e2a5a074f627a8$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $85e2a5a074f627a8$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $85e2a5a074f627a8$var$createEvent('ui', 'triggered', $85e2a5a074f627a8$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $85e2a5a074f627a8$export$c9b0e37b229a297b = (action, attributes)=>$85e2a5a074f627a8$var$createEvent('operational', action, $85e2a5a074f627a8$var$TEAM_SUBJECT, 'request', attributes);
const $85e2a5a074f627a8$export$12dae48763368ac9 = (action, attributes)=>$85e2a5a074f627a8$var$createEvent('operational', action, $85e2a5a074f627a8$var$USER_SUBJECT, 'request', attributes);
const $85e2a5a074f627a8$export$41816a317479160b = (type, actionSubjectId, attributes)=>$85e2a5a074f627a8$var$createEvent('ui', 'rendered', $85e2a5a074f627a8$var$getActionSubject(type), actionSubjectId, attributes);
const $85e2a5a074f627a8$export$fdcd134fbeb1f921 = (type, attributes)=>$85e2a5a074f627a8$var$createEvent('ui', 'clicked', $85e2a5a074f627a8$var$getActionSubject(type), 'action', attributes);
const $85e2a5a074f627a8$export$93260987012593be = (attributes)=>$85e2a5a074f627a8$var$createEvent('ui', 'clicked', $85e2a5a074f627a8$var$USER_SUBJECT, 'reportingLines', attributes);
const $85e2a5a074f627a8$export$79befd155063a6a7 = (type, attributes)=>$85e2a5a074f627a8$var$createEvent('ui', 'clicked', $85e2a5a074f627a8$var$getActionSubject(type), 'moreActions', attributes);
const $85e2a5a074f627a8$export$2703289b35687fde = (attributes)=>$85e2a5a074f627a8$var$createEvent('ui', 'clicked', $85e2a5a074f627a8$var$TEAM_SUBJECT, 'avatar', attributes);
const $85e2a5a074f627a8$export$b4411a7661cf2d3f = (attributes)=>$85e2a5a074f627a8$var$createEvent('ui', 'clicked', $85e2a5a074f627a8$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $85e2a5a074f627a8$export$c86679da702d560e = (attributes)=>$85e2a5a074f627a8$var$createEvent('ui', 'clicked', $85e2a5a074f627a8$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $85e2a5a074f627a8$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$85e2a5a074f627a8$var$createEvent('operational', action, $85e2a5a074f627a8$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("1P8ZX", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $0389323ef0b3cb79$export$e9faea7c41053334);
const $0389323ef0b3cb79$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $0389323ef0b3cb79$var$performanceAvailable = $0389323ef0b3cb79$var$isPerformanceAvailable();
const $0389323ef0b3cb79$var$initialPageTime = Date.now();
const $0389323ef0b3cb79$export$e9faea7c41053334 = ()=>{
    if ($0389323ef0b3cb79$var$performanceAvailable) return performance.now();
    return Date.now() - $0389323ef0b3cb79$var$initialPageTime;
};

});


parcelRegister("c4uSJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $abe00b516f07df56$export$2e2bcd8739ae039);

var $iwKVT = parcelRequire("iwKVT");
class $abe00b516f07df56$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $iwKVT.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});
parcelRegister("iwKVT", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("j92Xk", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $92bc5beb125c9446$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $92bc5beb125c9446$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $92bc5beb125c9446$export$d9ad65d422ee3f8c);

var $c3s8O = parcelRequire("c3s8O");
const $92bc5beb125c9446$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $92bc5beb125c9446$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $92bc5beb125c9446$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $92bc5beb125c9446$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $c3s8O.DirectoryGraphQLError)) return !!error && $92bc5beb125c9446$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $c3s8O.AGGError)) return !!error.errorType && $92bc5beb125c9446$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $92bc5beb125c9446$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $92bc5beb125c9446$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $c3s8O.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($92bc5beb125c9446$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($92bc5beb125c9446$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $c3s8O.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$92bc5beb125c9446$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $c3s8O.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($92bc5beb125c9446$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($92bc5beb125c9446$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $c3s8O.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$92bc5beb125c9446$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $c3s8O.DirectoryGraphQLErrors) || causeError instanceof (0, $c3s8O.AGGErrors)) return $92bc5beb125c9446$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $92bc5beb125c9446$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $c3s8O.DirectoryGraphQLErrors)(errors, traceId);
};
const $92bc5beb125c9446$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $c3s8O.AGGErrors)(errors, traceId);
};

});
parcelRegister("c3s8O", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $ad258c62b481cd08$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $ad258c62b481cd08$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $ad258c62b481cd08$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $ad258c62b481cd08$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $ad258c62b481cd08$export$60d8267243755b9c);
class $ad258c62b481cd08$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $ad258c62b481cd08$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $ad258c62b481cd08$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $ad258c62b481cd08$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $ad258c62b481cd08$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $ad258c62b481cd08$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $ad258c62b481cd08$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});



parcelRegister("652W8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ca23c04f5ff6beb$export$2e2bcd8739ae039);

var $fHpHg = parcelRequire("fHpHg");

var $c4uSJ = parcelRequire("c4uSJ");

var $h5xeR = parcelRequire("h5xeR");

var $lhuAF = parcelRequire("lhuAF");
const $9ca23c04f5ff6beb$var$UNSHARDED_PREFIX = '/gateway/api/watermelon';
const $9ca23c04f5ff6beb$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $9ca23c04f5ff6beb$var$orgContainsAnyWorkspacePromiseCache = new Map();
const $9ca23c04f5ff6beb$var$orgIdPromiseCache = new Map();
const $9ca23c04f5ff6beb$var$workspaceExistsWithTypePromiseCache = new Map();
class $9ca23c04f5ff6beb$var$TeamCentralCardClient extends (0, $c4uSJ.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.orgContainsAnyWorkspacePromise = this.createOrgContainsAnyWorkspacePromise(options);
        this.workspaceExistsWithTypePromise = this.preloadWorkspaceExistsWithType(options.cloudId);
        this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    }
    createOrgContainsAnyWorkspacePromise(config) {
        if (config.cloudId) {
            let promise = $9ca23c04f5ff6beb$var$orgContainsAnyWorkspacePromiseCache.get(config.cloudId);
            if (!promise) {
                promise = this.getOrgContainsAnyWorkspace(config.cloudId);
                $9ca23c04f5ff6beb$var$orgContainsAnyWorkspacePromiseCache.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.orgContainsAnyWorkspacePromise.then((orgContainsAnyWorkspace)=>{
            if (orgContainsAnyWorkspace) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
	 * `public` so that mock client can override it; do not use it otherwise!
	 */ async makeRequest(userId) {
        if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
        const query = $9ca23c04f5ff6beb$export$1862ef0c3880ca8d(userId);
        const response = await (0, $lhuAF.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
        return response.reportingLines;
    }
    async checkWorkspaceExists() {
        const workspaceExistsPromise = (0, $fHpHg.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? this.workspaceExistsWithTypePromise.then((workspaceExistsWithType)=>workspaceExistsWithType !== undefined) : this.orgContainsAnyWorkspacePromise;
        return workspaceExistsPromise.then((workspaceExistsWithType)=>{
            if (workspaceExistsWithType) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    async getIsGlobalExperienceWorkspace() {
        return await this.workspaceExistsWithTypePromise === 'GLOBAL_EXPERIENCE';
    }
    getOrgId() {
        return this.orgIdPromise;
    }
    preloadWorkspaceExistsWithType(cloudId) {
        if (cloudId === undefined) return Promise.resolve(undefined);
        const maybeWorkspaceExistsWithTypePromise = $9ca23c04f5ff6beb$var$workspaceExistsWithTypePromiseCache.get(cloudId);
        if (maybeWorkspaceExistsWithTypePromise !== undefined) return maybeWorkspaceExistsWithTypePromise;
        const workspaceExistsWithTypePromise = this.getWorkspaceExistsWithType(cloudId);
        $9ca23c04f5ff6beb$var$workspaceExistsWithTypePromiseCache.set(cloudId, workspaceExistsWithTypePromise);
        return workspaceExistsWithTypePromise;
    }
    getOrgContainsAnyWorkspace(cloudId) {
        if (cloudId) return fetch(((0, $fHpHg.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $9ca23c04f5ff6beb$var$UNSHARDED_PREFIX : this.getShardedApiPath(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`).then((res)=>{
            return !res || res && res.ok;
        });
        else return Promise.resolve(false);
    }
    async getWorkspaceExistsWithType(cloudId) {
        try {
            const response = await fetch(`${this.getShardedApiPath(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return Promise.resolve(workspaceType);
            }
        } catch (err) {
            return Promise.resolve(undefined);
        }
    }
    preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
        if (cloudId === undefined) return Promise.resolve(null);
        if (orgId !== undefined) return Promise.resolve(orgId);
        const maybeOrgIdForCloudIdPromise = $9ca23c04f5ff6beb$var$orgIdPromiseCache.get(cloudId);
        if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
        const orgIdForCloudIdPromise = (0, $h5xeR.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
        $9ca23c04f5ff6beb$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
        return orgIdForCloudIdPromise;
    }
    getShardedApiPath(cloudId) {
        return `/gateway/api/townsquare/s/${cloudId}`;
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $9ca23c04f5ff6beb$export$2e2bcd8739ae039 = $9ca23c04f5ff6beb$var$TeamCentralCardClient;

});
parcelRegister("h5xeR", function(module, exports) {

$parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", () => $e20bc15584b69ecf$export$d38a536fd806c68f);

var $lhuAF = parcelRequire("lhuAF");
const $e20bc15584b69ecf$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
const $e20bc15584b69ecf$var$addHeaders = (headers)=>{
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $e20bc15584b69ecf$export$d38a536fd806c68f(url, cloudId) {
    const query = {
        query: $e20bc15584b69ecf$var$ORG_ID_FROM_CLOUD_ID_QUERY,
        variables: {
            cloudId: cloudId
        }
    };
    try {
        const { tenantContexts: tenantContexts } = await (0, $lhuAF.AGGQuery)(url, query, $e20bc15584b69ecf$var$addHeaders);
        if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
        return tenantContexts[0].orgId;
    } catch (err) {
        // don't bubble up the error, and let consumers handle it as if the cloud ID
        // doesn't resolve to an org ID
        return null;
    }
}

});
parcelRegister("lhuAF", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $98ef723f563477ce$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $98ef723f563477ce$export$a14afb5f82fe705);

var $c3s8O = parcelRequire("c3s8O");

var $j92Xk = parcelRequire("j92Xk");
const $98ef723f563477ce$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $98ef723f563477ce$var$id = (headers)=>headers;
async function $98ef723f563477ce$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $98ef723f563477ce$var$id) {
    return $98ef723f563477ce$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $j92Xk.handleDirectoryGraphQLErrors));
}
async function $98ef723f563477ce$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $98ef723f563477ce$var$id) {
    return $98ef723f563477ce$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $j92Xk.handleAGGErrors));
}
async function $98ef723f563477ce$var$graphQLQuery(serviceUrl, query, processHeaders = $98ef723f563477ce$var$id, handleErrors) {
    const headers = processHeaders($98ef723f563477ce$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $c3s8O.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});



parcelRegister("hJRFB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b669385e624e94cd$export$2e2bcd8739ae039);

var $jQ0hK = parcelRequire("jQ0hK");

var $1P8ZX = parcelRequire("1P8ZX");

var $c4uSJ = parcelRequire("c4uSJ");

var $j92Xk = parcelRequire("j92Xk");

var $cfNQo = parcelRequire("cfNQo");
class $b669385e624e94cd$export$2e2bcd8739ae039 extends (0, $c4uSJ.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $cfNQo.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1P8ZX.getPageTime)();
            if (analytics) analytics((0, $jQ0hK.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $jQ0hK.teamRequestAnalytics)('succeeded', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $jQ0hK.teamRequestAnalytics)('failed', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    ...(0, $j92Xk.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("cfNQo", function(module, exports) {

$parcel$export(module.exports, "getTeamFromAGG", () => $e3c376581486e934$export$26a8aad0c7182dd6);

var $fHpHg = parcelRequire("fHpHg");

var $lhuAF = parcelRequire("lhuAF");
const $e3c376581486e934$var$ARI_PREFIX = 'ari:cloud:identity::team/';
const $e3c376581486e934$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $e3c376581486e934$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $e3c376581486e934$export$7878e28c136af76 = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($e3c376581486e934$var$ARI_PREFIX) ? teamIdOrTeamAri : $e3c376581486e934$export$681597d03c8a0fd2(teamIdOrTeamAri);
const $e3c376581486e934$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $e3c376581486e934$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $e3c376581486e934$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
	  isVerified
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $e3c376581486e934$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$e3c376581486e934$var$TEAM_FRAGMENT}
    }
  }
}`;
const $e3c376581486e934$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $e3c376581486e934$export$4968f4e0119a5d9c,
        variables: {
            teamId: (0, $fHpHg.fg)('team_id_to_ari_safe') ? $e3c376581486e934$export$7878e28c136af76(teamId) : $e3c376581486e934$export$681597d03c8a0fd2(teamId),
            siteId: siteId || 'None'
        }
    });
const $e3c376581486e934$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $e3c376581486e934$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $e3c376581486e934$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $lhuAF.AGGQuery)(url, query, $e3c376581486e934$export$1229c72526c01df2);
    return $e3c376581486e934$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("cdyCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b59270c19cd0c881$export$2e2bcd8739ae039);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");

var $fHpHg = parcelRequire("fHpHg");

var $jQ0hK = parcelRequire("jQ0hK");

var $a4E5y = parcelRequire("a4E5y");

var $1P8ZX = parcelRequire("1P8ZX");

var $c4uSJ = parcelRequire("c4uSJ");

var $j92Xk = parcelRequire("j92Xk");

var $lhuAF = parcelRequire("lhuAF");
const $b59270c19cd0c881$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $b59270c19cd0c881$var$aggUserQuery = (0, $5cllN.default)`
	query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`;
const $b59270c19cd0c881$var$aggUserQueryString = `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`;
const $b59270c19cd0c881$export$8230f28f7ae567ea = (userId)=>({
        query: (0, $fHpHg.fg)('platform_agg_user_query_doc_change') ? (0, $1c8Um.print)($b59270c19cd0c881$var$aggUserQuery) : $b59270c19cd0c881$var$aggUserQueryString,
        variables: {
            userId: userId
        }
    });
const $b59270c19cd0c881$var$queryAGGUser = async (url, userId)=>{
    const query = $b59270c19cd0c881$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $lhuAF.AGGQuery)(url, query);
    return user;
};
class $b59270c19cd0c881$export$2e2bcd8739ae039 extends (0, $c4uSJ.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
        const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
        const userQueryPromise = $b59270c19cd0c881$var$queryAGGUser(urlWithOperationName, userId);
        const user = await userQueryPromise;
        let timestring;
        const localWeekdayIndex = new Date().getDay().toString();
        if (user.zoneinfo) {
            if ((0, $a4E5y.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $a4E5y.localTime)(user.zoneinfo, 'h:mmbbb') || undefined;
            else timestring = (0, $a4E5y.localTime)(user.zoneinfo, 'eee h:mmbbb') || undefined;
        }
        return {
            ...user,
            isBot: user.__typename === 'AppUser',
            isAgent: user.appType === 'agent',
            status: user.accountStatus,
            statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
            avatarUrl: user.picture,
            email: user.email,
            fullName: user.name,
            location: user.extendedProfile?.location,
            meta: user.extendedProfile?.jobTitle,
            nickname: user.nickname,
            companyName: user.extendedProfile?.organization,
            timestring: timestring
        };
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1P8ZX.getPageTime)();
            if (analytics) analytics((0, $jQ0hK.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $jQ0hK.userRequestAnalytics)('succeeded', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $jQ0hK.userRequestAnalytics)('failed', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    ...(0, $j92Xk.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("a4E5y", function(module, exports) {

$parcel$export(module.exports, "localTime", () => $4fc1717a9ed01087$export$f0dfd716e7b023cd);
parcelRequire("bvXiK");
var $cjVx1 = parcelRequire("cjVx1");
const $4fc1717a9ed01087$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $cjVx1.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("bvXiK", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("cjVx1")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $cjVx1 = parcelRequire("cjVx1");





});
parcelRegister("cjVx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f83e2f603f04f8b$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $kWAFD = parcelRequire("kWAFD");

var $bzFEY = parcelRequire("bzFEY");
function $8f83e2f603f04f8b$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $kWAFD.default)((0, $bzFEY.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("kWAFD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f5ab696079cf9e$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $a0AoV = parcelRequire("a0AoV");

var $hPb5g = parcelRequire("hPb5g");
var $f3f5ab696079cf9e$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $f3f5ab696079cf9e$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($f3f5ab696079cf9e$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $hPb5g.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $a0AoV.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("a0AoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $749623fa41b373b0$export$2e2bcd8739ae039);

var $4HQad = parcelRequire("4HQad");

var $dJe12 = parcelRequire("dJe12");
var $749623fa41b373b0$var$MILLISECONDS_IN_MINUTE = 60000;
var $749623fa41b373b0$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $749623fa41b373b0$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $749623fa41b373b0$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $749623fa41b373b0$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $749623fa41b373b0$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $749623fa41b373b0$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $749623fa41b373b0$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $749623fa41b373b0$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $749623fa41b373b0$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $749623fa41b373b0$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $749623fa41b373b0$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $749623fa41b373b0$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $4HQad.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $4HQad.default)('long', date, options);
        }
    }
};
function $749623fa41b373b0$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $dJe12.default)(timeZone, originalDate, true) / $749623fa41b373b0$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $749623fa41b373b0$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $749623fa41b373b0$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $749623fa41b373b0$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $749623fa41b373b0$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $749623fa41b373b0$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $749623fa41b373b0$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $749623fa41b373b0$var$formatTimezone(offset, dirtyDelimeter);
}
function $749623fa41b373b0$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $749623fa41b373b0$var$addLeadingZeros(minutes, 2);
}
var $749623fa41b373b0$export$2e2bcd8739ae039 = $749623fa41b373b0$var$formatters;

});
parcelRegister("4HQad", function(module, exports) {

$parcel$export(module.exports, "default", () => $36d3a43c0eedc11e$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $36d3a43c0eedc11e$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $36d3a43c0eedc11e$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $36d3a43c0eedc11e$var$partsTimeZone(dtf, date) : $36d3a43c0eedc11e$var$hackyTimeZone(dtf, date);
}
function $36d3a43c0eedc11e$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $36d3a43c0eedc11e$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $36d3a43c0eedc11e$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("dJe12", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fea598d71cce197$export$2e2bcd8739ae039);

var $YidMk = parcelRequire("YidMk");

var $14jIa = parcelRequire("14jIa");
var $9fea598d71cce197$var$MILLISECONDS_IN_HOUR = 3600000;
var $9fea598d71cce197$var$MILLISECONDS_IN_MINUTE = 60000;
var $9fea598d71cce197$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $9fea598d71cce197$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $9fea598d71cce197$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $9fea598d71cce197$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$9fea598d71cce197$var$validateTimezone(hours)) return NaN;
        return -(hours * $9fea598d71cce197$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $9fea598d71cce197$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$9fea598d71cce197$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $9fea598d71cce197$var$MILLISECONDS_IN_HOUR + minutes * $9fea598d71cce197$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($9fea598d71cce197$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $9fea598d71cce197$var$toUtcDate(date);
        var offset = $9fea598d71cce197$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $9fea598d71cce197$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $9fea598d71cce197$var$toUtcDate(date) {
    return (0, $14jIa.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $9fea598d71cce197$var$calcOffset(date, timezoneString) {
    var tokens = (0, $YidMk.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $14jIa.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $9fea598d71cce197$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $9fea598d71cce197$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $9fea598d71cce197$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $9fea598d71cce197$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $9fea598d71cce197$var$validIANATimezoneCache = {};
function $9fea598d71cce197$var$isValidTimezoneIANAString(timeZoneString) {
    if ($9fea598d71cce197$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $9fea598d71cce197$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("YidMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b53bd11b51a1a98$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $0b53bd11b51a1a98$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $0b53bd11b51a1a98$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $0b53bd11b51a1a98$var$partsOffset(dtf, date) : $0b53bd11b51a1a98$var$hackyOffset(dtf, date);
}
var $0b53bd11b51a1a98$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $0b53bd11b51a1a98$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $0b53bd11b51a1a98$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $0b53bd11b51a1a98$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $0b53bd11b51a1a98$var$dtfCache = {};
function $0b53bd11b51a1a98$var$getDateTimeFormat(timeZone) {
    if (!$0b53bd11b51a1a98$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $0b53bd11b51a1a98$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $0b53bd11b51a1a98$var$dtfCache[timeZone];
}

});

parcelRegister("14jIa", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c757471af3a5e68$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $0c757471af3a5e68$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("hPb5g", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf9fcc1b038219f4$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $dJe12 = parcelRequire("dJe12");

var $gFzxn = parcelRequire("gFzxn");
var $cf9fcc1b038219f4$var$MILLISECONDS_IN_HOUR = 3600000;
var $cf9fcc1b038219f4$var$MILLISECONDS_IN_MINUTE = 60000;
var $cf9fcc1b038219f4$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $cf9fcc1b038219f4$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $gFzxn.default)
};
function $cf9fcc1b038219f4$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $cf9fcc1b038219f4$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $cf9fcc1b038219f4$var$splitDateString(argument);
    var parseYearResult = $cf9fcc1b038219f4$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $cf9fcc1b038219f4$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $cf9fcc1b038219f4$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $dJe12.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $cf9fcc1b038219f4$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $cf9fcc1b038219f4$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $cf9fcc1b038219f4$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $cf9fcc1b038219f4$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $cf9fcc1b038219f4$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $cf9fcc1b038219f4$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $cf9fcc1b038219f4$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $cf9fcc1b038219f4$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $cf9fcc1b038219f4$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $cf9fcc1b038219f4$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $cf9fcc1b038219f4$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$cf9fcc1b038219f4$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $cf9fcc1b038219f4$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$cf9fcc1b038219f4$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $cf9fcc1b038219f4$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$cf9fcc1b038219f4$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $cf9fcc1b038219f4$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$cf9fcc1b038219f4$var$validateWeekDate(year, week)) return new Date(NaN);
        return $cf9fcc1b038219f4$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $cf9fcc1b038219f4$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$cf9fcc1b038219f4$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $cf9fcc1b038219f4$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $cf9fcc1b038219f4$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $cf9fcc1b038219f4$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$cf9fcc1b038219f4$var$validateTime(hours)) return NaN;
        return hours % 24 * $cf9fcc1b038219f4$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $cf9fcc1b038219f4$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$cf9fcc1b038219f4$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $cf9fcc1b038219f4$var$MILLISECONDS_IN_HOUR + minutes * $cf9fcc1b038219f4$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $cf9fcc1b038219f4$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$cf9fcc1b038219f4$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $cf9fcc1b038219f4$var$MILLISECONDS_IN_HOUR + minutes * $cf9fcc1b038219f4$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $cf9fcc1b038219f4$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $cf9fcc1b038219f4$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $cf9fcc1b038219f4$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $cf9fcc1b038219f4$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $cf9fcc1b038219f4$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $cf9fcc1b038219f4$var$isLeapYearIndex(year);
        if (isLeapYear && date > $cf9fcc1b038219f4$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $cf9fcc1b038219f4$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $cf9fcc1b038219f4$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $cf9fcc1b038219f4$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $cf9fcc1b038219f4$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $cf9fcc1b038219f4$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("gFzxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c22c0aabeb22307b$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $c22c0aabeb22307b$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $c22c0aabeb22307b$export$2e2bcd8739ae039 = $c22c0aabeb22307b$var$tzPattern;

});



parcelRegister("bzFEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d3475c92a521d5$export$2e2bcd8739ae039);

var $dJe12 = parcelRequire("dJe12");

var $hPb5g = parcelRequire("hPb5g");
function $86d3475c92a521d5$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $hPb5g.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $dJe12.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});






parcelRegister("58UyI", function(module, exports) {

$parcel$export(module.exports, "CustomUserProfileClient", () => $2fe94d89052b4b13$export$4b2a86afb64f42f1);

var $cdyCC = parcelRequire("cdyCC");

var $7f4tk = parcelRequire("7f4tk");

var $7I2zi = parcelRequire("7I2zi");
class $2fe94d89052b4b13$export$4b2a86afb64f42f1 extends (0, $cdyCC.default) {
    constructor(fabricPfDirUrl, onLoadError){
        super({
            url: fabricPfDirUrl,
            cacheSize: 20,
            cacheMaxAge: 180000
        }), this.makeRequest = async (cloudId, userId)=>{
            // call old profile rest endpoint
            try {
                if ((0, $7I2zi.isCustomerAccount)(userId)) {
                    const response = await (0, $7f4tk.default)(`/rest/api/3/user?accountId=${userId}`);
                    return (0, $7I2zi.restResponseToUserData)(response);
                }
                return await this.parentMakeRequest(cloudId, userId);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const error = new Error(`Unable to fetch user: ${err.message}`, {
                    cause: err
                });
                this.onLoadError?.(err);
                throw error;
            }
        };
        this.onLoadError = onLoadError;
        this.parentMakeRequest = super.makeRequest;
    }
}

});
parcelRegister("7I2zi", function(module, exports) {

$parcel$export(module.exports, "generateUserLink", () => $9d3ef40360103f2e$export$f4673d7e11341514);
$parcel$export(module.exports, "generateTeamLink", () => $9d3ef40360103f2e$export$b163ce931504dcff);
$parcel$export(module.exports, "isTeamProfileCardEventContentRendered", () => $9d3ef40360103f2e$export$6dc006c3779708c0);
$parcel$export(module.exports, "fireLegacyTeamAnalytics", () => $9d3ef40360103f2e$export$ffbbcf55d672ec61);
$parcel$export(module.exports, "restResponseToUserData", () => $9d3ef40360103f2e$export$66691b1affeb3bc5);
$parcel$export(module.exports, "isCustomerAccount", () => $9d3ef40360103f2e$export$67a41405362363f0);
$parcel$export(module.exports, "getSpaActions", () => $9d3ef40360103f2e$export$518f47d656cb4e1a);

var $8zOmE = parcelRequire("8zOmE");

var $8vYX2 = parcelRequire("8vYX2");

const $9d3ef40360103f2e$export$f4673d7e11341514 = (userId)=>`/jira/people/${userId}`;
const $9d3ef40360103f2e$export$b163ce931504dcff = (teamId)=>`/jira/people/team/${teamId}`;
const $9d3ef40360103f2e$export$7b55c373f7e07896 = (label, profileUrl)=>({
        id: 'view-profile',
        label: label,
        callback: (event)=>{
            event.stopPropagation();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(profileUrl);
        }
    });
const $9d3ef40360103f2e$export$6dc006c3779708c0 = (analyticsPayload)=>analyticsPayload?.action === 'rendered' && analyticsPayload?.actionSubjectId === 'content';
const $9d3ef40360103f2e$export$ffbbcf55d672ec61 = (analyticsEvent)=>{
    if (analyticsEvent?.payload?.eventType === 'ui') {
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `legacyTeamProfileCard ${analyticsEvent.payload.action}}`);
        if ($9d3ef40360103f2e$export$6dc006c3779708c0(analyticsEvent?.payload)) (0, $8zOmE.fireScreenAnalytics)(analyticsEvent);
    }
};
const $9d3ef40360103f2e$export$66691b1affeb3bc5 = (userData)=>({
        avatarUrl: userData.avatarUrls?.['48x48'],
        email: userData.emailAddress,
        fullName: userData.displayName,
        isBot: false,
        isCurrentUser: false,
        status: userData.active ? 'active' : 'inactive',
        accountType: userData.accountType
    });
const $9d3ef40360103f2e$export$67a41405362363f0 = (accountId)=>accountId ? accountId.lastIndexOf('qm:', 0) === 0 : false;
const $9d3ef40360103f2e$var$getSpaViewProfileAction = (intl, accountId, onPushAction, onActionCleanup)=>({
        label: intl && intl.formatMessage((0, $8vYX2.profileCardMessages).viewProfile),
        id: 'view-profile',
        callback: ()=>{
            onPushAction(`/jira/people/${accountId}`);
            onActionCleanup && onActionCleanup();
        },
        link: `/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
const $9d3ef40360103f2e$var$getAssignedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $8vYX2.profileCardMessages).assignedIssues),
        id: 'assigned-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`assignee="${accountId || ''}" AND resolution is empty`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $9d3ef40360103f2e$var$getReportedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $8vYX2.profileCardMessages).reportedIssues),
        id: 'reported-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`reporter="${accountId || ''}" order by created DESC`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $9d3ef40360103f2e$var$getViewFiltersAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $8vYX2.profileCardMessages).viewFilters),
        id: 'view-filters',
        callback: ()=>{
            const url = `/jira/filters?owner=${encodeURIComponent(accountId)}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $9d3ef40360103f2e$export$518f47d656cb4e1a = (accountId, intl, onPushAction, actions, onActionCleanup)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $e6a2e0952e4731b8$export$23cedd3261bd8015:
                return $9d3ef40360103f2e$var$getSpaViewProfileAction(intl, accountId, onPushAction, onActionCleanup);
            case 0, $e6a2e0952e4731b8$export$6bef782d14a92db8:
                return $9d3ef40360103f2e$var$getAssignedIssuesAction(intl, accountId);
            case 0, $e6a2e0952e4731b8$export$6b36f20db7a18a86:
                return $9d3ef40360103f2e$var$getReportedIssuesAction(intl, accountId);
            case 0, $e6a2e0952e4731b8$export$56da0dd0b0aa67b9:
                return $9d3ef40360103f2e$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $9d3ef40360103f2e$var$getSpaViewProfileAction(intl, accountId, onPushAction, onActionCleanup)
    ];
};

});
parcelRegister("8vYX2", function(module, exports) {

$parcel$export(module.exports, "profileCardMessages", () => $a3966562156ba1e4$export$49f2d2ccb123fddf);

var $7VHMR = parcelRequire("7VHMR");
const $a3966562156ba1e4$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    view: {
        "id": "profilecard-next",
        "defaultMessage": "View profile"
    }
});
const $a3966562156ba1e4$export$49f2d2ccb123fddf = (0, $7VHMR.defineMessages)({
    assignedIssues: {
        "id": "profilecard-next.assigned-issues",
        "defaultMessage": "Assigned issues"
    },
    viewProfile: {
        "id": "profilecard-next.view-profile",
        "defaultMessage": "View profile"
    },
    reportedIssues: {
        "id": "profilecard-next.reported-issues",
        "defaultMessage": "Reported issues"
    },
    viewFilters: {
        "id": "profilecard-next.view-filters",
        "defaultMessage": "View filters"
    }
});

});





parcelRegister("7kyNN", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLegacyView", () => $f542927bcd31a328$export$f603724b266e8fe7);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $ecWLc = parcelRequire("ecWLc");

var $2OMDV = parcelRequire("2OMDV");

var $koeKL = parcelRequire("koeKL");

var $ih2j7 = parcelRequire("ih2j7");

var $t1z25 = parcelRequire("t1z25");

var $8L4jp = parcelRequire("8L4jp");

var $9l5Jv = parcelRequire("9l5Jv");


var $8cFNQ = parcelRequire("8cFNQ");
const $f542927bcd31a328$var$AnalyticsWrapper = (0, $2OMDV.AnalyticsEventToProps)((0, $03bf38ed90f474bb$export$a1455360a24a2234), {
    onAnalytics: 'fired'
});
const $f542927bcd31a328$export$23f88898e1cb6da9 = $f542927bcd31a328$var$AnalyticsWrapper((0, $ecWLc.default)((0, $8cFNQ.default)));
const $f542927bcd31a328$var$eventListenerOptions = {
    passive: true
};
const $f542927bcd31a328$export$f603724b266e8fe7 = ({ onGetActions: onGetActions, onProfileClick: onProfileClick })=>{
    // Required for mocking in VR Tests
    (0, $gKZoD.di)(setTimeout);
    // Hooks
    const [userData, setUserData] = (0, $5uXOq.useState)(null);
    const [referenceElement, setReferenceElement] = (0, $5uXOq.useState)(null);
    const [showProfileCard, setShowProfileCard] = (0, $5uXOq.useState)(false);
    const [offset, setOffset] = (0, $5uXOq.useState)(null);
    const showTimeoutId = (0, $5uXOq.useRef)(null);
    const cloudId = (0, $koeKL.useCloudId)();
    const { profileClient: profileClient } = (0, $9l5Jv.useProfileClient)();
    const onMouseLeaveCancelShowCard = ()=>{
        if (showTimeoutId.current) clearTimeout(showTimeoutId.current);
    };
    const onHideProfileCard = ()=>{
        setShowProfileCard(false);
        onMouseLeaveCancelShowCard();
    };
    const { setTriggerRef: setTriggerRef, setCardRef: setCardRef, unsetTriggerRef: unsetTriggerRef, unsetCardRef: unsetCardRef, getTimeoutId: getTimeoutId } = (0, $t1z25.useHideProfileCardDelayed)(true, false, onHideProfileCard);
    // Add event listener using our hook
    (0, $t1z25.useEventListener)('mouseleave', unsetTriggerRef, referenceElement, $f542927bcd31a328$var$eventListenerOptions);
    (0, $t1z25.useEventListener)('mouseleave', onMouseLeaveCancelShowCard, referenceElement, $f542927bcd31a328$var$eventListenerOptions);
    (0, $t1z25.useEventListener)('mouseenter', setTriggerRef, referenceElement, $f542927bcd31a328$var$eventListenerOptions);
    // @ts-expect-error - TS2345 - Argument of type 'Window & typeof globalThis' is not assignable to parameter of type 'HTMLElement | null'.
    (0, $t1z25.useEventListener)('scroll', onHideProfileCard, window, $f542927bcd31a328$var$eventListenerOptions);
    const clearHideCardTimeout = (timeoutId)=>{
        if (timeoutId) clearTimeout(timeoutId);
    };
    const setShowProfileCardDelayed = ()=>setTimeout(()=>setShowProfileCard(true), (0, $4f9eb78cf9cb8ede$export$5b956b542f1bc1b3));
    const setData = (data, ref, offsetValue)=>{
        clearHideCardTimeout(getTimeoutId());
        setOffset(offsetValue || '0, 8px');
        setUserData(data);
        setReferenceElement(ref);
        showTimeoutId.current = setShowProfileCardDelayed();
    };
    const api = {
        setData: setData,
        hideProfileCard: onHideProfileCard
    };
    (0, $8L4jp.default)(api);
    return showProfileCard && referenceElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ih2j7.ProfileCardLegacyWrapper), {
        onMouseEnter: setCardRef,
        onMouseLeave: unsetCardRef,
        referenceElement: referenceElement,
        offset: offset
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f542927bcd31a328$export$23f88898e1cb6da9, {
            accountId: userData?.accountId,
            cloudId: cloudId,
            handleEscapeKeydown: onHideProfileCard,
            handleClickOutside: onHideProfileCard,
            profileClient: profileClient,
            actions: onGetActions(userData?.accountId ?? '', ()=>{
                clearHideCardTimeout(getTimeoutId());
                onHideProfileCard();
            }),
            onProfileClick: onProfileClick
        }));
};

});
const $4f9eb78cf9cb8ede$export$5b956b542f1bc1b3 = 800;
const $4f9eb78cf9cb8ede$export$89a9f35a94d7f196 = 200;

parcelRegister("ecWLc", function(module, exports) {

$parcel$export(module.exports, "default", () => $af28c87cf5d9dc5d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");
function $af28c87cf5d9dc5d$export$2e2bcd8739ae039(Component) {
    return class WithOuterListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
        componentDidMount() {
            if (this.props.handleClickOutside) document.addEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) document.addEventListener('keydown', this.handleKeydown, false);
        }
        componentWillUnmount() {
            if (this.props.handleClickOutside) document.removeEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) document.removeEventListener('keydown', this.handleKeydown, false);
        }
        render() {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.handleClick = (evt)=>{
                const { handleClickOutside: handleClickOutside } = this.props;
                if (handleClickOutside) {
                    const domNode = (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).findDOMNode(this); // eslint-disable-line react/no-find-dom-node
                    if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) handleClickOutside();
                }
            }, this.handleKeydown = (evt)=>{
                const { handleEscapeKeydown: handleEscapeKeydown } = this.props;
                if (handleEscapeKeydown && evt.code === 'Escape') handleEscapeKeydown();
            };
        }
    };
}

});

parcelRegister("2OMDV", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $28422a5dfa4a4065$export$3e9ef96ba97ea9dc);

var $3TR0I = parcelRequire("3TR0I");
const $28422a5dfa4a4065$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $28422a5dfa4a4065$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $3TR0I.default)($28422a5dfa4a4065$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("ih2j7", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLegacyWrapper", () => $69aea63e0704566b$export$6ef7d4845cf112be);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $7pDxf = parcelRequire("7pDxf");

var $t1z25 = parcelRequire("t1z25");

// Updated version of popper requires tuple but provided value may be a string
const $69aea63e0704566b$var$parsePopperOffsetValue = (offset)=>{
    let offsetArray = [
        0,
        0
    ];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(offset)) return offsetArray;
    if (typeof offset === 'string') // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type '[number | null | undefined, number | null | undefined]'.
    offsetArray = offset.split(',').map((pxValue)=>parseInt(pxValue.replace('px', ''), 10));
    else if (Array.isArray(offset) && offset.length === 2) // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type '[number | null | undefined, number | null | undefined]'.
    offsetArray = offset;
    return offsetArray.some(Number.isNaN) ? [
        0,
        0
    ] : offsetArray;
};
const $69aea63e0704566b$export$6ef7d4845cf112be = ({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, referenceElement: referenceElement, offset: offset, children: children, placement: placement })=>{
    const offsetTuple = $69aea63e0704566b$var$parsePopperOffsetValue(offset);
    const modifiers = [
        {
            name: 'offset',
            options: {
                offset: offsetTuple
            }
        },
        {
            name: 'preventOverflow',
            options: {
                tether: true
            }
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7pDxf.JiraPopper), {
        referenceElement: referenceElement,
        placement: placement || (0, $t1z25.getPlacement)(referenceElement),
        modifiers: modifiers,
        messageId: "profilecard-next.common.ui.legacy-profile-card.popper",
        messageType: "transactional"
    }, ({ ref: ref, style: style, forceUpdate: forceUpdate })=>// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "profilecard-next.common.ui.legacy-profile-card.div",
            ref: ref,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...style
            },
            onMouseLeave: onMouseLeave,
            onMouseEnter: onMouseEnter
        }, children(forceUpdate)));
};

});
parcelRegister("7pDxf", function(module, exports) {

$parcel$export(module.exports, "JiraPopper", () => $5dfb0b72e9322fa3$export$23789575ac361b5d);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $e5neF = parcelRequire("e5neF");

var $10xFf = parcelRequire("10xFf");

var $jW2j1 = parcelRequire("jW2j1");
const $5dfb0b72e9322fa3$export$23789575ac361b5d = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jW2j1.ChoreographerPopper), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e5neF.Popper), rest);
};

});
parcelRegister("jW2j1", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopper", () => $577b12f0a509cc55$export$6077de4a190b560c);
// eslint-disable-next-line jira/restricted/react-component-props

var $e5neF = parcelRequire("e5neF");

var $cSWNW = parcelRequire("cSWNW");
const $577b12f0a509cc55$export$6077de4a190b560c = (0, $cSWNW.withChoreographedRender)((0, $e5neF.Popper));

});


parcelRegister("t1z25", function(module, exports) {

$parcel$export(module.exports, "useEventListener", () => $3bdcead9d38aaa77$export$7080b3e976bc91ab);
$parcel$export(module.exports, "useHideProfileCardDelayed", () => $3bdcead9d38aaa77$export$30416a530a92ed77);
$parcel$export(module.exports, "getPlacement", () => $3bdcead9d38aaa77$export$a9fe23cfa43a7b55);

var $5uXOq = parcelRequire("5uXOq");
const $3bdcead9d38aaa77$export$7080b3e976bc91ab = (eventName, handler, element, // @ts-expect-error - TS2304 - Cannot find name 'EventListenerOptionsOrUseCapture'.
options)=>{
    // Create a ref that stores handler
    const savedHandler = (0, $5uXOq.useRef)();
    // Update ref.current value if handler changes.
    // This allows our effect below to always get latest handler ...
    // ... without us needing to pass it in effect deps array ...
    // ... and potentially cause effect to re-run every render.
    (0, $5uXOq.useEffect)(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Create event listener that calls handler function stored in ref
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const eventListener = ()=>savedHandler.current && savedHandler.current();
        // Add event listener
        element && element.addEventListener(eventName, eventListener, options);
        // Remove event listener on cleanup
        return ()=>{
            element && element.removeEventListener(eventName, eventListener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
};
const $3bdcead9d38aaa77$export$30416a530a92ed77 = (initialfirst, initialSecond, callback)=>{
    const triggerRef = (0, $5uXOq.useRef)(initialfirst);
    const cardRef = (0, $5uXOq.useRef)(initialSecond);
    const timeoutId = (0, $5uXOq.useRef)(null);
    const setStateDelayed = ()=>{
        if (timeoutId.current) // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(()=>{
            if (!triggerRef.current && !cardRef.current) callback();
        }, 400);
    };
    const setTriggerRef = ()=>{
        triggerRef.current = true;
        setStateDelayed();
    };
    const unsetTriggerRef = ()=>{
        triggerRef.current = false;
        setStateDelayed();
    };
    const setCardRef = ()=>{
        cardRef.current = true;
        setStateDelayed();
    };
    const unsetCardRef = ()=>{
        cardRef.current = false;
        setStateDelayed();
    };
    const getTimeoutId = ()=>timeoutId.current;
    return {
        setTriggerRef: setTriggerRef,
        setCardRef: setCardRef,
        unsetTriggerRef: unsetTriggerRef,
        unsetCardRef: unsetCardRef,
        getTimeoutId: // @ts-expect-error - TS2322 - Type '() => unknown' is not assignable to type '() => number | null'.
        getTimeoutId
    };
};
const $3bdcead9d38aaa77$export$a9fe23cfa43a7b55 = (referenceElement)=>{
    if (referenceElement && typeof referenceElement.id === 'string' && referenceElement.id.indexOf('issue_summary') > -1) return 'left-start';
    return 'top-start';
};

});


parcelRegister("8L4jp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2145977bf6427e9b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $9B86Q = parcelRequire("9B86Q");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2145977bf6427e9b$export$2e2bcd8739ae039 = (api)=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $9B86Q.loadBridgeWeak)({
        name: 'jira/profilecard/bridge'
    }).then((bridge)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        bridge(api);
    });
};

});
parcelRegister("9B86Q", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $61b2a5aa3a2a1160$export$3cefda82396756a1);

var $ifVVd = parcelRequire("ifVVd");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $61b2a5aa3a2a1160$var$pollingSingleton = null;
const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, $ifVVd.createPollingCollection)((v)=>window.require(v), 100);
    $61b2a5aa3a2a1160$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("ifVVd", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $60e6b0d4bc46beac$export$f163446a982a8077);

var $gKZoD = parcelRequire("gKZoD");

var $aePFs = parcelRequire("aePFs");
const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gKZoD.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aePFs.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aePFs.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aePFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f3c6551bf5b1ff$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




const $03bf38ed90f474bb$export$a1455360a24a2234 = 'profileCardNextLegacyView';

parcelRegister("8cFNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ca0aae989d69173$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $izabN = parcelRequire("izabN");

var $d4xRU = parcelRequire("d4xRU");
var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $7I2zi = parcelRequire("7I2zi");
const $1ca0aae989d69173$export$6f67c636e2e30540 = ({ cloudId: cloudId, profileClient: profileClient, accountId: accountId, actions: actions, onProfileClick: onProfileClick })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const onReportingLinesClick = onProfileClick ? (user)=>onProfileClick(user.accountIdentifier) : undefined;
    const profileCardProps = {
        userId: accountId,
        cloudId: cloudId,
        actions: (0, $7I2zi.isCustomerAccount)(accountId) ? [] : actions,
        resourceClient: profileClient,
        onReportingLinesClick: onReportingLinesClick
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $izabN.default), {
        ...profileCardProps,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        addFlag: (flag)=>{
            const flagId = (0, $7HGHK.toFlagId)(flag.id);
            showFlag({
                id: flagId,
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
                        ...flag,
                        onDismissed: ()=>{
                            dismissFlag(flagId);
                        },
                        messageId: `profilecard-next.ui.profilecard-legacy.profilecard-resourced.ak-flag.${flagId}`,
                        messageType: "transactional",
                        ...props
                    })
            });
        }
    });
};
const $1ca0aae989d69173$var$ProfileCardResourced = $1ca0aae989d69173$export$6f67c636e2e30540;
var $1ca0aae989d69173$export$2e2bcd8739ae039 = $1ca0aae989d69173$var$ProfileCardResourced;

});
parcelRegister("izabN", function(module, exports) {

$parcel$export(module.exports, "default", () => $14c04d3f9300b9d4$export$2e2bcd8739ae039);
// Avoid exporting new components in this file as they will affect the bundle size of all consumers
// importing directly from @atlaskit/profilecard.

var $juq2W = parcelRequire("juq2W");


var $cdyCC = parcelRequire("cdyCC");


var $i8yut = parcelRequire("i8yut");



var $l9fp3 = parcelRequire("l9fp3");

var $awbOn = parcelRequire("awbOn");


var $ecWLc = parcelRequire("ecWLc");

var $iY9BQ = parcelRequire("iY9BQ");

var $eit7l = parcelRequire("eit7l");

var $14c04d3f9300b9d4$export$2e2bcd8739ae039 = (0, $l9fp3.default);

});
parcelRegister("i8yut", function(module, exports) {

$parcel$export(module.exports, "TeamProfileCard", () => $33d9a6ea0a2690db$export$5be70f0332137d36);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $bngFq = parcelRequire("bngFq");

var $44cng = parcelRequire("44cng");

var $bWfiu = parcelRequire("bWfiu");

var $5uGNN = parcelRequire("5uGNN");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $7rJgC = parcelRequire("7rJgC");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $cFwjb = parcelRequire("cFwjb");

var $7u0KV = parcelRequire("7u0KV");
var $6pK1R = parcelRequire("6pK1R");

var $jQ0hK = parcelRequire("jQ0hK");

var $c2pOK = parcelRequire("c2pOK");

var $6coWW = parcelRequire("6coWW");

var $5qjKn = parcelRequire("5qjKn");
const $33d9a6ea0a2690db$var$noop = ()=>{};
const $33d9a6ea0a2690db$var$styles = {
    wrapperStyles: "_2rkopd34 _v564nm7n _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bsb1gwv _1ul95x59 _4t3i1wug",
    containerStyles: "_otyrpxbi",
    avatarImageStyles: "_kqswstnw _18u01ejb",
    headerImageStyles: "_5ral1dfr _s7n4jp4b _4t3i53f4 _1bsb1osq",
    teamInformationStyles: "_18u01ejb _19pku2gc _2hwx1ejb",
    teamConnectionHeaderStyles: "_18u0u2gc _2hwxu2gc _c71lx2si _18m91wug",
    teamConnectionContainerStyles: "_18u01ejb _2hwx1ejb",
    connectionTitleStyles: "_11c81vhk _18u0pxbi _19pkpxbi _2hwxpxbi _otyr12x7 _syaz1gjq",
    viewProfileContainerStyles: "_4cvr1h6o _uwhke4h9 _15a5nqa1 _1i53muej _19bv1ejb _u5f31ejb",
    viewProfileButtonStyles: "_2rkoiti9 _189ee4h9 _1dqonqa1 _1h6dmuej _bfhk1w7a _syaz1gjq _1bsb1osq _4t3i1ul9 _19pkpxbi"
};
const $33d9a6ea0a2690db$var$TeamCardWrapper = ({ id: id, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $33d9a6ea0a2690db$var$styles.wrapperStyles,
        testId: `team-card-${id}`,
        children: children
    });
const $33d9a6ea0a2690db$var$HeaderImage = ({ srcUrl: srcUrl })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "img",
        src: srcUrl,
        xcss: $33d9a6ea0a2690db$var$styles.headerImageStyles,
        testId: "profile-header-image",
        alt: "team-header-image"
    });
const $33d9a6ea0a2690db$export$5be70f0332137d36 = ({ containerId: containerId, teamId: teamId, displayName: displayName, description: description, avatarImageUrl: avatarImageUrl, headerImageUrl: headerImageUrl, memberAvatars: memberAvatars, memberCount: memberCount, cloudId: cloudId, userId: userId, isVerified: isVerified, teamProfileUrl: teamProfileUrl, isKudosEnabled: isKudosEnabled, otherActions: otherActions })=>{
    const { teamContainers: teamContainers, loading: loading } = (0, $6pK1R.useTeamContainers)(teamId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    // Ensure that the current container is not the only connection for this team before showing the "Where we work" section
    const hasOtherTeamConnections = (0, $5uXOq.useMemo)(()=>teamContainers.filter((tc)=>tc.id === containerId).length < teamContainers.length, [
        containerId,
        teamContainers
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (createAnalyticsEvent) (0, $jQ0hK.fireEvent)(createAnalyticsEvent, {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'viewTeamProfileButton',
            attributes: {}
        });
        window.open(teamProfileUrl, '_blank');
    }, [
        createAnalyticsEvent,
        teamProfileUrl
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($33d9a6ea0a2690db$var$TeamCardWrapper, {
        id: teamId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($33d9a6ea0a2690db$var$HeaderImage, {
                srcUrl: headerImageUrl
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                space: "space.200",
                xcss: $33d9a6ea0a2690db$var$styles.containerStyles,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                        spread: "space-between",
                        alignBlock: "center",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            xcss: $33d9a6ea0a2690db$var$styles.avatarImageStyles,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFwjb.default), {
                                size: "medium",
                                src: avatarImageUrl
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                        xcss: $33d9a6ea0a2690db$var$styles.teamInformationStyles,
                        space: "space.200",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                                space: "space.050",
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                                        alignBlock: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                                                size: "medium",
                                                children: displayName
                                            }),
                                            isVerified && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uGNN.VerifiedTeamIcon), {
                                                showTooltip: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                        color: "color.text.subtlest",
                                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                            defaultMessage: "Contributing team \u2022 {count, plural, one {# member} other {# members}}",
                                            values: {
                                                count: memberCount
                                            },
                                            id: "people-and-teams.team-profile-card.member-count"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $44cng.default), {
                                    appearance: "stack",
                                    data: memberAvatars
                                })
                            }),
                            description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                color: "color.text",
                                maxLines: 3,
                                children: description
                            })
                        ]
                    }),
                    (loading || hasOtherTeamConnections) && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
                        xcss: hasOtherTeamConnections ? $33d9a6ea0a2690db$var$styles.teamConnectionHeaderStyles : $33d9a6ea0a2690db$var$styles.teamConnectionContainerStyles,
                        children: [
                            hasOtherTeamConnections && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                                xcss: $33d9a6ea0a2690db$var$styles.connectionTitleStyles,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    defaultMessage: "Where we work",
                                    id: "people-and-teams.team-profile-card.team-connections"
                                })
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7u0KV.TeamContainers), {
                                teamId: teamId,
                                onAddAContainerClick: $33d9a6ea0a2690db$var$noop,
                                userId: userId,
                                cloudId: cloudId,
                                components: {
                                    ContainerCard: (0, $6coWW.TeamConnections),
                                    TeamContainersSkeleton: (0, $5qjKn.TeamContainersSkeleton)
                                },
                                filterContainerId: containerId,
                                isDisplayedOnProfileCard: true
                            })
                        ]
                    }),
                    isKudosEnabled || otherActions ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c2pOK.ButtonSection), {
                        teamProfileUrl: teamProfileUrl,
                        isKudosEnabled: isKudosEnabled,
                        otherActions: otherActions
                    }) : teamProfileUrl && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gOkqF.default), {
                        xcss: $33d9a6ea0a2690db$var$styles.viewProfileContainerStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                            onClick: onClick,
                            xcss: $33d9a6ea0a2690db$var$styles.viewProfileButtonStyles,
                            testId: "view-profile-button",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                defaultMessage: "View profile",
                                id: "people-and-teams.team-profile-card.view-profile"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("5uGNN", function(module, exports) {

$parcel$export(module.exports, "VerifiedTeamIcon", () => $62ccb659a0f5c058$export$d7949f68d31e5edd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $jGBbV = parcelRequire("jGBbV");

var $8PSX5 = parcelRequire("8PSX5");

var $5KCCi = parcelRequire("5KCCi");

var $cJFyP = parcelRequire("cJFyP");
const $62ccb659a0f5c058$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $cJFyP.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "aria-hidden": "true",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jGBbV))), {
                    color: "var(--ds-icon-accent-blue, #1D7AFC)",
                    LEGACY_size: "medium",
                    label: tooltipContent,
                    spacing: "spacious",
                    LEGACY_fallbackIcon: (0, $8PSX5.default)
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jGBbV))), {
        color: "var(--ds-icon-accent-blue, #1D7AFC)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: label,
        LEGACY_fallbackIcon: (0, $8PSX5.default)
    });
};

});
parcelRegister("jGBbV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08303db08bddd05336395b40b61b967a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e54eca00b611caa6$var$_react = $e54eca00b611caa6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e54eca00b611caa6$var$_baseNew = $e54eca00b611caa6$var$_interopRequireDefault((parcelRequire("enEmH")));
function $e54eca00b611caa6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusVerified".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing verified content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e54eca00b611caa6$var$StatusVerifiedIcon = (props)=>/*#__PURE__*/ $e54eca00b611caa6$var$_react.default.createElement($e54eca00b611caa6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.15.444a1.713 1.713 0 0 0-2.3 0L5.7 1.486a.2.2 0 0 1-.15.055L4 1.481a1.713 1.713 0 0 0-1.763 1.48l-.21 1.536a.2.2 0 0 1-.08.139l-1.225.95c-.697.54-.87 1.52-.4 2.266l.827 1.312c.03.047.04.104.027.159l-.328 1.515A1.713 1.713 0 0 0 2 12.831l1.477.474a.2.2 0 0 1 .123.103l.723 1.372c.41.78 1.346 1.12 2.162.787l1.436-.586a.2.2 0 0 1 .16 0l1.436.586a1.713 1.713 0 0 0 2.162-.787l.723-1.372a.2.2 0 0 1 .123-.103l1.477-.474a1.713 1.713 0 0 0 1.15-1.993l-.328-1.515a.2.2 0 0 1 .028-.159l.827-1.312a1.71 1.71 0 0 0-.4-2.266l-1.225-.95a.2.2 0 0 1-.08-.14l-.21-1.536A1.713 1.713 0 0 0 12 1.481l-1.55.06a.2.2 0 0 1-.15-.055zm3.176 5.036-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$e54eca00b611caa6$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
var $e54eca00b611caa6$var$_default = module.exports.default = $e54eca00b611caa6$var$StatusVerifiedIcon;

});

parcelRegister("8PSX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $49a04c34dba77105$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $49a04c34dba77105$var$VerifiedIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        })
    });
/**
 * __VerifiedIcon__
 */ const $49a04c34dba77105$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $49a04c34dba77105$var$VerifiedIconGlyph
    });
var $49a04c34dba77105$export$2e2bcd8739ae039 = $49a04c34dba77105$var$VerifiedIcon;

});

parcelRegister("cJFyP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5fbb80e95a063e02$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5fbb80e95a063e02$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
        defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
        description: 'Tooltip text for the verified team icon'
    }
});

});


parcelRegister("7u0KV", function(module, exports) {

$parcel$export(module.exports, "TeamContainers", () => $f59f11cc60745e49$export$73c2d2b9b49926f5);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $bngFq = parcelRequire("bngFq");

var $bMFGq = parcelRequire("bMFGq");

var $kW74I = parcelRequire("kW74I");

var $2GZKW = parcelRequire("2GZKW");
var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");


var $3CiMs = parcelRequire("3CiMs");

var $5H3sV = parcelRequire("5H3sV");

var $blxVb = parcelRequire("blxVb");

var $6pK1R = parcelRequire("6pK1R");

var $i9DPg = parcelRequire("i9DPg");

var $183ER = parcelRequire("183ER");

var $aSC9C = parcelRequire("aSC9C");

var $lPIeA = parcelRequire("lPIeA");

var $2nXrX = parcelRequire("2nXrX");
const $f59f11cc60745e49$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`;
const $f59f11cc60745e49$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $a7f8c6b391092279$export$7c87d337fb91a97d)})`;
const $f59f11cc60745e49$export$33f8090aba665a84 = 4;
const $f59f11cc60745e49$export$73c2d2b9b49926f5 = ({ teamId: teamId, onAddAContainerClick: onAddAContainerClick, components: components, userId: userId, cloudId: cloudId, filterContainerId: filterContainerId, isDisplayedOnProfileCard: isDisplayedOnProfileCard })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { teamContainers: teamContainers, loading: loading, unlinkError: unlinkError } = (0, $6pK1R.useTeamContainers)(teamId);
    const [_, actions] = (0, $6pK1R.useTeamContainersHook)();
    const [showAddJiraContainer, setShowAddJiraContainer] = (0, $5uXOq.useState)(false);
    const [showAddConfluenceContainer, setShowAddConfluenceContainer] = (0, $5uXOq.useState)(false);
    const [showMore, setShowMore] = (0, $5uXOq.useState)(false);
    const [isDisconnectDialogOpen, setIsDisconnectDialogOpen] = (0, $5uXOq.useState)(false);
    const [selectedContainerDetails, setSelectedContainerDetails] = (0, $5uXOq.useState)();
    const [filteredTeamContainers, setFilteredTeamContainers] = (0, $5uXOq.useState)(teamContainers);
    const { fireOperationalEvent: fireOperationalEvent, fireTrackEvent: fireTrackEvent } = (0, $3CiMs.usePeopleAndTeamAnalytics)();
    const { data: productPermissions, loading: productPermissionIsLoading } = (0, $blxVb.useProductPermissions)({
        userId: userId,
        cloudId: cloudId
    });
    (0, $5uXOq.useEffect)(()=>{
        if (isDisplayedOnProfileCard && filterContainerId) setFilteredTeamContainers(teamContainers.filter((container)=>container.id !== filterContainerId));
        else setFilteredTeamContainers(teamContainers);
    }, [
        isDisplayedOnProfileCard,
        filterContainerId,
        teamContainers
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (filteredTeamContainers.length > $f59f11cc60745e49$export$33f8090aba665a84 || isDisplayedOnProfileCard) {
            setShowAddJiraContainer(false);
            setShowAddConfluenceContainer(false);
        } else {
            const hasJiraProject = filteredTeamContainers.some((container)=>container.type === 'JiraProject');
            const hasConfluenceSpace = filteredTeamContainers.some((container)=>container.type === 'ConfluenceSpace');
            setShowAddJiraContainer(!hasJiraProject && !!productPermissions && !!(0, $5H3sV.hasProductPermission)(productPermissions, 'jira'));
            setShowAddConfluenceContainer(!hasConfluenceSpace && !!productPermissions && !!(0, $5H3sV.hasProductPermission)(productPermissions, 'confluence'));
        }
    }, [
        isDisplayedOnProfileCard,
        productPermissions,
        filteredTeamContainers
    ]);
    const handleShowMore = ()=>{
        setShowMore(!showMore);
    };
    const handleOpenDisconnectDialog = (0, $5uXOq.useCallback)((containerDetails)=>{
        setSelectedContainerDetails(containerDetails);
        setIsDisconnectDialogOpen(true);
        fireTrackEvent(createAnalyticsEvent, {
            action: (0, $3CiMs.AnalyticsAction).OPENED,
            actionSubject: 'unlinkContainerDialog',
            attributes: {
                teamId: teamId
            }
        });
    }, [
        createAnalyticsEvent,
        fireTrackEvent,
        teamId
    ]);
    const LinkedContainerCardComponent = components?.ContainerCard || (0, $aSC9C.LinkedContainerCard);
    const handleDisconnect = (0, $5uXOq.useCallback)(async (containerId)=>{
        const removedContainer = filteredTeamContainers.find((container)=>container.id === containerId);
        await actions.unlinkTeamContainers(teamId, containerId);
        setIsDisconnectDialogOpen(false);
        if (unlinkError) fireOperationalEvent(createAnalyticsEvent, {
            action: (0, $3CiMs.AnalyticsAction).FAILED,
            actionSubject: 'teamContainerUnlinked'
        });
        else fireOperationalEvent(createAnalyticsEvent, {
            action: (0, $3CiMs.AnalyticsAction).SUCCEEDED,
            actionSubject: 'teamContainerUnlinked',
            attributes: {
                containerRemoved: {
                    containerId: removedContainer?.id,
                    container: removedContainer?.type
                },
                teamId: teamId
            }
        });
    }, [
        actions,
        createAnalyticsEvent,
        fireOperationalEvent,
        filteredTeamContainers,
        teamId,
        unlinkError
    ]);
    const TeamContainersSkeletonComponent = components?.TeamContainersSkeleton || (0, $2nXrX.TeamContainersSkeleton);
    if (loading || productPermissionIsLoading) return /*#__PURE__*/ (0, $2OMIu.jsx)(TeamContainersSkeletonComponent, {
        numberOfContainers: $f59f11cc60745e49$export$33f8090aba665a84
    });
    if (filteredTeamContainers.length === 0 && !isDisplayedOnProfileCard && (!productPermissions || !(productPermissions && ((0, $5H3sV.hasProductPermission)(productPermissions, 'jira') || (0, $5H3sV.hasProductPermission)(productPermissions, 'confluence'))))) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lPIeA.NoProductAccessState), {});
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2GZKW.default), {
                        templateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                        gap: isDisplayedOnProfileCard ? 'space.0' : 'space.100',
                        children: [
                            filteredTeamContainers.slice(0, $f59f11cc60745e49$export$33f8090aba665a84).map((container)=>{
                                return /*#__PURE__*/ (0, $2OMIu.jsx)(LinkedContainerCardComponent, {
                                    containerType: container.type,
                                    containerTypeProperties: container.containerTypeProperties,
                                    title: container.name,
                                    containerIcon: container.icon || undefined,
                                    link: container.link || undefined,
                                    containerId: container.id,
                                    onDisconnectButtonClick: ()=>handleOpenDisconnectDialog({
                                            containerId: container.id,
                                            containerType: container.type,
                                            containerName: container.name
                                        })
                                }, container.id);
                            }),
                            showAddJiraContainer && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i9DPg.AddContainerCard), {
                                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Jira'),
                                containerType: "JiraProject"
                            }),
                            showAddConfluenceContainer && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i9DPg.AddContainerCard), {
                                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Confluence'),
                                containerType: "ConfluenceSpace"
                            }),
                            showMore && filteredTeamContainers.slice($f59f11cc60745e49$export$33f8090aba665a84).map((container)=>{
                                return /*#__PURE__*/ (0, $2OMIu.jsx)(LinkedContainerCardComponent, {
                                    containerType: container.type,
                                    containerTypeProperties: container.containerTypeProperties,
                                    title: container.name,
                                    containerId: container.id,
                                    containerIcon: container.icon || undefined,
                                    link: container.link || undefined,
                                    onDisconnectButtonClick: ()=>handleOpenDisconnectDialog({
                                            containerId: container.id,
                                            containerType: container.type,
                                            containerName: container.name
                                        })
                                }, container.id);
                            })
                        ]
                    }),
                    filteredTeamContainers.length > $f59f11cc60745e49$export$33f8090aba665a84 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2Eqc8.default), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
                            appearance: "subtle",
                            onClick: handleShowMore,
                            children: showMore ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...$f59f11cc60745e49$var$messages.showLess
                            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...$f59f11cc60745e49$var$messages.showMore
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kW74I.default), {
                children: isDisconnectDialogOpen && selectedContainerDetails && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $183ER.DisconnectDialogLazy), {
                    containerName: selectedContainerDetails.containerName,
                    containerType: selectedContainerDetails.containerType,
                    onClose: ()=>setIsDisconnectDialogOpen(false),
                    onDisconnect: ()=>handleDisconnect(selectedContainerDetails.containerId)
                })
            })
        ]
    });
};
const $f59f11cc60745e49$var$messages = (0, $7VHMR.defineMessages)({
    showMore: {
        id: 'ptc-directory.team-profile-page.team-containers.show-more.non-final',
        defaultMessage: 'Show more',
        description: 'Button to show more containers'
    },
    showLess: {
        id: 'ptc-directory.team-profile-page.team-containers.show-less.non-final',
        defaultMessage: 'Show less',
        description: 'Button to show less containers'
    }
});

});
var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
// Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';

parcelRegister("3CiMs", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamAnalytics", () => $d771a96248842360$export$c673a0f984c6d01b);
$parcel$export(module.exports, "AnalyticsAction", () => $d771a96248842360$export$30c16f5c43437fd7);

var $lbMXQ = parcelRequire("lbMXQ");
const $d771a96248842360$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $d771a96248842360$var$runItLater = (cb)=>{
    if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $d771a96248842360$export$c673a0f984c6d01b = ()=>{
    const [{ eventAttributes: injectedEventAttributes }] = (0, $lbMXQ.usePeopleTeamsAnalyticsSubcontext)();
    const fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
            if (!createAnalyticsEvent) return;
            $d771a96248842360$var$runItLater(()=>{
                const eventWithSubcontextAttributes = {
                    ...body.attributes,
                    ...injectedEventAttributes
                };
                createAnalyticsEvent({
                    eventType: kind,
                    ...body,
                    attributes: eventWithSubcontextAttributes
                }).fire($d771a96248842360$var$ANALYTICS_CHANNEL);
            });
        };
    return {
        fireOperationalEvent: fireEvent('operational'),
        fireScreenEvent: fireEvent('screen'),
        fireTrackEvent: fireEvent('track'),
        fireUIEvent: fireEvent('ui')
    };
};
var $d771a96248842360$export$30c16f5c43437fd7 = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["RENDERED"] = "rendered";
    AnalyticsAction["CLICKED"] = "clicked";
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    AnalyticsAction["VIEWED"] = "viewed";
    AnalyticsAction["CLOSED"] = "closed";
    AnalyticsAction["ERROR"] = "error";
    AnalyticsAction["SUBMITED"] = "submitted";
    AnalyticsAction["FETCHED"] = "fetched";
    AnalyticsAction["SENT"] = "sent";
    AnalyticsAction["OPENED"] = "opened";
    return AnalyticsAction;
}({});

});
parcelRegister("lbMXQ", function(module, exports) {

$parcel$export(module.exports, "usePeopleTeamsAnalyticsSubcontext", () => $1f37af346f421238$export$86448e866930ba8d);
$parcel$export(module.exports, "useInjectedEventAttribute", () => $1f37af346f421238$export$831917a198e22e70);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $1f37af346f421238$var$initialState = {
    eventAttributes: {}
};
const $1f37af346f421238$var$actions = {
    setEventAttributes: (eventAttributes)=>({ setState: setState, getState: getState })=>{
            const existingEventAttributes = getState().eventAttributes;
            const newEventAttributes = {
                ...existingEventAttributes,
                ...eventAttributes
            };
            Object.keys(newEventAttributes).forEach((keyString)=>{
                const key = keyString;
                if (newEventAttributes[key] === undefined) delete newEventAttributes[key];
            });
            setState({
                eventAttributes: newEventAttributes
            });
        }
};
const $1f37af346f421238$var$AnalyticsSubcontextStore = (0, $iXqE5.createStore)({
    initialState: $1f37af346f421238$var$initialState,
    actions: $1f37af346f421238$var$actions
});
const $1f37af346f421238$export$86448e866930ba8d = (0, $3sQ5x.createHook)($1f37af346f421238$var$AnalyticsSubcontextStore);
const $1f37af346f421238$export$831917a198e22e70 = (key, value)=>{
    const { setEventAttributes: setEventAttributes } = $1f37af346f421238$export$86448e866930ba8d()[1];
    (0, $5uXOq.useEffect)(()=>{
        setEventAttributes({
            [key]: value
        });
        return ()=>setEventAttributes({
                [key]: undefined
            });
    }, [
        key,
        value,
        setEventAttributes
    ]);
};

});


parcelRegister("5H3sV", function(module, exports) {

$parcel$export(module.exports, "transformPermissions", () => $c6dce29df2206902$export$7fe0bfa353103198);
$parcel$export(module.exports, "getProductPermissionRequestBody", () => $c6dce29df2206902$export$e16fe80afd1ad74c);
$parcel$export(module.exports, "hasProductPermission", () => $c6dce29df2206902$export$a2eea90ce05a9f1c);
const $c6dce29df2206902$var$PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-software',
    'jira-servicedesk',
    'jira-product-discovery'
];
const $c6dce29df2206902$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        if (permission.resourceId.includes('jira')) acc['jira'] = {
            ...acc['jira'],
            [permission.permissionId]: acc['jira']?.[permission.permissionId] || permission.permitted
        };
        else if (permission.resourceId.includes('confluence')) acc['confluence'] = {
            ...acc['confluence'],
            [permission.permissionId]: acc['confluence']?.[permission.permissionId] || permission.permitted
        };
        return acc;
    }, {});
};
const $c6dce29df2206902$export$e16fe80afd1ad74c = (cloudId, userId, permissionIds)=>{
    const body = permissionIds.reduce((acc, permissionId)=>{
        const permission = {
            permissionId: permissionId,
            resourceId: '',
            principalId: `ari:cloud:identity::user/${userId}`,
            dontRequirePrincipalInSite: true
        };
        $c6dce29df2206902$var$PRODUCTS.forEach((product)=>{
            acc.push({
                ...permission,
                resourceId: `ari:cloud:${product}::site/${cloudId}`
            });
        });
        return acc;
    }, []);
    return JSON.stringify(body);
};
const $c6dce29df2206902$export$a2eea90ce05a9f1c = (permissions, product, permissionIds)=>{
    if (!permissions[product]) return false;
    if ((!permissionIds || permissionIds.length === 0) && permissions[product]) return Object.values(permissions[product] || {}).some((value)=>value === true);
    return permissionIds?.some((permissionId)=>permissions[product]?.[permissionId]);
};

});

parcelRegister("blxVb", function(module, exports) {

$parcel$export(module.exports, "useProductPermissions", () => $87f422aa50b432d3$export$5814f9544ee53f3b);

var $5uXOq = parcelRequire("5uXOq");

var $bHOQi = parcelRequire("bHOQi");
const $87f422aa50b432d3$export$5814f9544ee53f3b = ({ userId: userId, cloudId: cloudId, permissionIds: permissionIds }, { enabled: enabled } = {
    enabled: true
})=>{
    const [state, { getPermissions: getPermissions }] = (0, $bHOQi.useProductPermissionsStore)();
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        getPermissions({
            cloudId: cloudId,
            userId: userId,
            enabled: enabled,
            permissionIds: permissionIds || [
                'manage',
                'write'
            ]
        });
    }, [
        cloudId,
        enabled,
        getPermissions,
        userId,
        permissionIds
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissions,
        error: state.error
    };
};

});
parcelRegister("bHOQi", function(module, exports) {

$parcel$export(module.exports, "useProductPermissionsStore", () => $38e80d0c12a61189$export$933ed92af1ed5de9);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5H3sV = parcelRequire("5H3sV");
const $38e80d0c12a61189$var$actions = {
    getPermissions: ({ userId: userId, cloudId: cloudId, enabled: enabled, permissionIds: permissionIds = [
        'manage',
        'write'
    ] })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading, permissions: permissions } = getState();
            if (isLoading || !userId || !cloudId || !enabled) return;
            const shouldFetch = !hasLoaded || permissionIds.some((permissionId)=>permissions.confluence?.[permissionId] === undefined || permissions.jira?.[permissionId] === undefined);
            if (!shouldFetch) return;
            try {
                setState({
                    isLoading: true
                });
                const response = await fetch('/gateway/api/permissions/bulk/permitted', {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    method: 'POST',
                    credentials: 'include',
                    body: (0, $5H3sV.getProductPermissionRequestBody)(cloudId, userId, permissionIds)
                });
                if (!response.ok) throw new Error('Failed to fetch product permissions');
                const permissions = await response.json();
                dispatch($38e80d0c12a61189$var$actions.setPermissions(permissions));
            } catch (error) {
                dispatch($38e80d0c12a61189$var$actions.setError(new Error('Failed to fetch product permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: (0, $5H3sV.transformPermissions)(permissions),
                permissionsResponse: permissions
            });
        }
};
const $38e80d0c12a61189$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {}
    },
    actions: $38e80d0c12a61189$var$actions,
    name: 'product-permissions'
});
const $38e80d0c12a61189$export$933ed92af1ed5de9 = (0, $3sQ5x.createHook)($38e80d0c12a61189$var$Store);

});


parcelRegister("6pK1R", function(module, exports) {

$parcel$export(module.exports, "useTeamContainersHook", () => $4be4896037d164a3$export$cdd1842df65e002f);
$parcel$export(module.exports, "useTeamContainers", () => $4be4896037d164a3$export$63f31a5bbbef2f9a);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $bngFq = parcelRequire("bngFq");

var $3CiMs = parcelRequire("3CiMs");

var $9C40y = parcelRequire("9C40y");
const $4be4896037d164a3$var$initialConnectedTeamsState = {
    containerId: undefined,
    isLoading: false,
    hasLoaded: false,
    teams: undefined,
    error: null,
    numberOfTeams: undefined
};
const $4be4896037d164a3$var$initialState = {
    teamContainers: [],
    loading: true,
    error: null,
    unlinkError: null,
    teamId: null,
    connectedTeams: $4be4896037d164a3$var$initialConnectedTeamsState
};
const $4be4896037d164a3$var$actions = {
    fetchTeamContainers: (teamId, fireAnalytics)=>async ({ setState: setState, getState: getState })=>{
            const { teamId: currentTeamId } = getState();
            if (currentTeamId === teamId) return;
            setState({
                loading: true,
                error: null,
                teamContainers: [],
                teamId: teamId
            });
            try {
                const containers = await (0, $9C40y.teamsClient).getTeamContainers(teamId);
                fireAnalytics((0, $3CiMs.AnalyticsAction).SUCCEEDED, 'fetchTeamContainers');
                setState({
                    teamContainers: containers,
                    loading: false,
                    error: null
                });
            } catch (err) {
                fireAnalytics((0, $3CiMs.AnalyticsAction).FAILED, 'fetchTeamContainers', err);
                setState({
                    teamContainers: [],
                    error: err,
                    loading: false
                });
            }
        },
    fetchNumberOfConnectedTeams: (containerId, fireAnalytics)=>async ({ setState: setState, getState: getState })=>{
            const { connectedTeams: { containerId: currentContainerId } } = getState();
            if (currentContainerId === containerId) return;
            setState({
                connectedTeams: {
                    ...$4be4896037d164a3$var$initialConnectedTeamsState,
                    containerId: containerId,
                    numberOfTeams: undefined
                }
            });
            try {
                const numberOfTeams = await (0, $9C40y.teamsClient).getNumberOfConnectedTeams(containerId);
                fireAnalytics({
                    action: (0, $3CiMs.AnalyticsAction).SUCCEEDED,
                    actionSubject: 'fetchNumberOfConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: numberOfTeams
                });
                setState({
                    connectedTeams: {
                        ...$4be4896037d164a3$var$initialConnectedTeamsState,
                        containerId: containerId,
                        numberOfTeams: numberOfTeams
                    }
                });
            } catch (e) {
                fireAnalytics({
                    action: (0, $3CiMs.AnalyticsAction).FAILED,
                    actionSubject: 'fetchNumberOfConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: $4be4896037d164a3$var$initialConnectedTeamsState.numberOfTeams,
                    error: e
                });
                setState({
                    connectedTeams: {
                        ...$4be4896037d164a3$var$initialConnectedTeamsState,
                        containerId: containerId,
                        error: e
                    }
                });
            }
        },
    fetchConnectedTeams: (containerId, fireAnalytics)=>async ({ setState: setState, getState: getState })=>{
            const { connectedTeams: { containerId: currentContainerId, numberOfTeams: numberOfTeams, hasLoaded: hasLoaded } } = getState();
            if (currentContainerId === containerId && hasLoaded) return;
            setState({
                connectedTeams: {
                    containerId: containerId,
                    isLoading: true,
                    hasLoaded: false,
                    teams: undefined,
                    error: null,
                    numberOfTeams: numberOfTeams
                }
            });
            try {
                const teams = await (0, $9C40y.teamsClient).getConnectedTeams(containerId);
                fireAnalytics({
                    action: (0, $3CiMs.AnalyticsAction).SUCCEEDED,
                    actionSubject: 'fetchConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: numberOfTeams
                });
                setState({
                    connectedTeams: {
                        containerId: containerId,
                        isLoading: false,
                        hasLoaded: true,
                        teams: teams,
                        error: null,
                        numberOfTeams: numberOfTeams
                    }
                });
            } catch (e) {
                fireAnalytics({
                    action: (0, $3CiMs.AnalyticsAction).FAILED,
                    actionSubject: 'fetchConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: numberOfTeams,
                    error: e
                });
                setState({
                    connectedTeams: {
                        containerId: containerId,
                        isLoading: false,
                        hasLoaded: false,
                        teams: [],
                        error: e,
                        numberOfTeams: numberOfTeams
                    }
                });
            }
        },
    unlinkTeamContainers: (teamId, containerId)=>async ({ setState: setState, getState: getState })=>{
            setState({
                unlinkError: null
            });
            try {
                const mutationResult = await (0, $9C40y.teamsClient).unlinkTeamContainer(teamId, containerId);
                if (mutationResult.deleteTeamConnectedToContainer.errors.length) // Just handle 1 error at a time should be suffcient as we disconenct only 1 container at a time
                setState({
                    unlinkError: mutationResult.deleteTeamConnectedToContainer.errors[0]
                });
                else {
                    const { teamContainers: teamContainers, connectedTeams: connectedTeams } = getState();
                    const newContainers = teamContainers.filter((container)=>container.id !== containerId);
                    if (connectedTeams.containerId === containerId) setState({
                        teamContainers: newContainers,
                        connectedTeams: $4be4896037d164a3$var$initialConnectedTeamsState
                    });
                    else setState({
                        teamContainers: newContainers
                    });
                }
            } catch (err) {
                setState({
                    unlinkError: err
                });
            }
        },
    addTeamContainer: (teamContainer)=>async ({ setState: setState, getState: getState })=>{
            const { teamContainers: teamContainers, connectedTeams: connectedTeams } = getState();
            const containerExists = teamContainers.some((container)=>container.id === teamContainer.id);
            if (containerExists) return;
            if (connectedTeams.containerId === teamContainer.id) setState({
                teamContainers: [
                    ...teamContainers,
                    teamContainer
                ],
                connectedTeams: $4be4896037d164a3$var$initialConnectedTeamsState
            });
            else setState({
                teamContainers: [
                    ...teamContainers,
                    teamContainer
                ]
            });
        }
};
const $4be4896037d164a3$var$Store = (0, $iXqE5.createStore)({
    initialState: $4be4896037d164a3$var$initialState,
    actions: $4be4896037d164a3$var$actions,
    name: 'teamContainersStore'
});
const $4be4896037d164a3$export$cdd1842df65e002f = (0, $3sQ5x.createHook)($4be4896037d164a3$var$Store);
const $4be4896037d164a3$export$63f31a5bbbef2f9a = (teamId, enable = true)=>{
    const [state, actions] = $4be4896037d164a3$export$cdd1842df65e002f();
    const { fireOperationalEvent: fireOperationalEvent } = (0, $3CiMs.usePeopleAndTeamAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireOperationalAnalytics = (0, $5uXOq.useCallback)((action, actionSubject, error)=>{
        fireOperationalEvent(createAnalyticsEvent, {
            action: action,
            actionSubject: actionSubject,
            attributes: {
                teamId: teamId,
                ...error && {
                    error: {
                        message: error.message || JSON.stringify(error),
                        stack: error.stack
                    }
                }
            }
        });
    }, [
        fireOperationalEvent,
        createAnalyticsEvent,
        teamId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (enable) actions.fetchTeamContainers(teamId, fireOperationalAnalytics);
    }, [
        teamId,
        actions,
        enable,
        fireOperationalAnalytics
    ]);
    return {
        ...state,
        addTeamContainer: actions.addTeamContainer
    };
};
const $4be4896037d164a3$export$aadc628af3b5ef88 = ()=>{
    const [state, actions] = $4be4896037d164a3$export$cdd1842df65e002f();
    const { fireOperationalEvent: fireOperationalEvent } = (0, $3CiMs.usePeopleAndTeamAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireOperationalAnalytics = (0, $5uXOq.useCallback)(({ action: action, actionSubject: actionSubject, containerId: containerId, numberOfTeams: numberOfTeams, error: error })=>{
        fireOperationalEvent(createAnalyticsEvent, {
            action: action,
            actionSubject: actionSubject,
            attributes: {
                containerId: containerId,
                numberOfTeams: numberOfTeams,
                ...error && {
                    error: {
                        message: error.message || JSON.stringify(error),
                        stack: error.stack
                    }
                }
            }
        });
    }, [
        fireOperationalEvent,
        createAnalyticsEvent
    ]);
    return {
        ...state.connectedTeams,
        fetchNumberOfConnectedTeams: (containerId)=>actions.fetchNumberOfConnectedTeams(containerId, fireOperationalAnalytics),
        fetchConnectedTeams: (containerId)=>actions.fetchConnectedTeams(containerId, fireOperationalAnalytics)
    };
};

});
parcelRegister("9C40y", function(module, exports) {

$parcel$export(module.exports, "teamsClient", () => $ec46d527f349e032$export$5ed932c3646b89c6);

var $1Xi7l = parcelRequire("1Xi7l");
class $ec46d527f349e032$export$db59823f35bf78ce {
    constructor(/**
		 * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
		 */ context){
        this._aggClient = (0, $1Xi7l.aggClient);
        if (context) this.setContext(context);
    }
    /**
	 * Sets the base URL to be used in the client requests
	 * @param {string} baseUrl - The new base URL
	 */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
    }
    /**
	 * Sets context including CloudId & OrgId to be used for all requests
	 */ setContext(context) {
        this._aggClient.setContext(context);
    }
    /**
	 * Get the containers for a given team
	 * @param {string} teamId
	 * @returns {Promise<TeamContainers>}
	 */ async getTeamContainers(teamId) {
        return this._aggClient.getTeamContainers(teamId);
    }
    /**
	 * Get the number of teams connected to a container (Confluence space or Jira project)
	 * @param {string} containerId
	 * @returns {Promise}
	 */ async getNumberOfConnectedTeams(containerId) {
        return this._aggClient.queryNumberOfTeamConnectedToContainer(containerId);
    }
    /**
	 * Get teams connected to a container (Confluence space or Jira project)
	 * @param {string} containerId
	 * @returns {Promise}
	 */ async getConnectedTeams(containerId) {
        return this._aggClient.queryTeamsConnectedToContainer(containerId);
    }
    /**
	 * Unlink a container from a team
	 * @param {string} teamId
	 * @param {string} containerId
	 * @returns {Promise<void>}
	 */ async unlinkTeamContainer(teamId, containerId) {
        return this._aggClient.unlinkTeamContainer(teamId, containerId);
    }
}
const $ec46d527f349e032$export$5ed932c3646b89c6 = new $ec46d527f349e032$export$db59823f35bf78ce();

});
parcelRegister("1Xi7l", function(module, exports) {

$parcel$export(module.exports, "aggClient", () => $6ead99c7cab7524b$export$464c991dbf0b2393);

var $5hC97 = parcelRequire("5hC97");

var $kVgV6 = parcelRequire("kVgV6");

var $cHfzg = parcelRequire("cHfzg");

var $4IpKh = parcelRequire("4IpKh");

var $1DXuu = parcelRequire("1DXuu");

var $hr6Fj = parcelRequire("hr6Fj");

var $0ChzE = parcelRequire("0ChzE");

var $lUpJt = parcelRequire("lUpJt");
class $6ead99c7cab7524b$export$b44e5dafe13af7b3 extends (0, $4IpKh.BaseGraphQlClient) {
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async getTeamContainers(teamId) {
        const teamAri = (0, $5hC97.teamIdToAri)(teamId);
        const cypherQuery = `MATCH (team:IdentityTeam {ari: '${teamAri}'})-[:team_connected_to_container]->(container) RETURN container`;
        const response = await this.makeGraphQLRequest({
            query: (0, $lUpJt.TeamContainersQuery),
            variables: {
                cypherQuery: cypherQuery
            }
        }, {
            operationName: 'TeamContainersQuery'
        });
        const containersResult = response.graphStore.cypherQuery.edges.map((edge)=>({
                id: edge.node.to.id,
                type: edge.node.to.data.__typename,
                name: edge.node.to.data.__typename === 'ConfluenceSpace' ? edge.node.to.data.confluenceSpaceName || '' : edge.node.to.data.jiraProjectName,
                icon: edge.node.to.data.__typename === 'ConfluenceSpace' ? `${edge.node.to.data.links.base}${edge.node.to.data.icon.path}` : edge.node.to.data.avatar.medium,
                createdDate: edge.node.to.data.__typename === 'ConfluenceSpace' ? new Date(edge.node.to.data.createdDate) : new Date(edge.node.to.data.created),
                link: edge.node.to.data.__typename === 'ConfluenceSpace' ? `${edge.node.to.data.links.base}${edge.node.to.data.links.webUi}` : edge.node.to.data.webUrl,
                containerTypeProperties: {
                    subType: edge.node.to.data.__typename === 'JiraProject' ? edge.node.to.data.projectType || '' : undefined,
                    name: edge.node.to.data.__typename === 'JiraProject' ? edge.node.to.data.projectTypeName || '' : undefined
                }
            }));
        return containersResult;
    }
    async unlinkTeamContainer(teamId, containerId) {
        const teamAri = (0, $5hC97.teamIdToAri)(teamId);
        const response = await this.makeGraphQLRequest({
            query: (0, $1DXuu.UnlinkContainerMutation),
            variables: {
                containerId: containerId,
                teamId: teamAri
            }
        }, {
            operationName: 'UnlinkContainerMutation'
        });
        return response.graphStore;
    }
    async queryNumberOfTeamConnectedToContainer(containerId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $hr6Fj.NumberOfTeamConnectedToContainerQuery),
            variables: {
                containerId: containerId
            }
        }, {
            operationName: 'NumberOfTeamConnectedToContainerQuery'
        });
        return response?.graphStore?.teamConnectedToContainerInverse?.edges?.length;
    }
    async queryTeamsConnectedToContainer(containerId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $0ChzE.TeamConnectedToContainerQuery),
            variables: {
                containerId: containerId
            }
        }, {
            operationName: 'TeamConnectedToContainerQuery'
        });
        return response?.graphStore?.teamConnectedToContainerInverse?.edges?.map(({ node: node })=>({
                id: node.id,
                displayName: node.displayName,
                description: node.description,
                state: node.state,
                membershipSettings: node.membershipSettings,
                organizationId: node.organizationId,
                creatorId: node.creator?.id,
                isVerified: node.isVerified,
                members: node.members?.nodes.map(({ member: member })=>({
                        id: member?.id ? (0, $kVgV6.toUserId)(member?.id) : '',
                        fullName: member?.name ?? '',
                        avatarUrl: member?.picture,
                        status: member?.accountStatus
                    })) ?? [],
                includesYou: false,
                // to-do - this needs to be computed - https://product-fabric.atlassian.net/browse/CCECO-4368
                memberCount: node.members?.nodes.length ?? 0,
                largeAvatarImageUrl: node.largeAvatarImageUrl,
                smallAvatarImageUrl: node.smallAvatarImageUrl,
                largeHeaderImageUrl: node.largeHeaderImageUrl,
                smallHeaderImageUrl: node.smallHeaderImageUrl,
                restriction: 'ORG_MEMBERS' // to-do - figure out if this should be optional (it's deprecated) - https://product-fabric.atlassian.net/browse/CCECO-4368
            }));
    }
}
const $6ead99c7cab7524b$export$464c991dbf0b2393 = new $6ead99c7cab7524b$export$b44e5dafe13af7b3((0, $cHfzg.DEFAULT_CONFIG).stargateRoot, {
    logException: ()=>{}
});

});
parcelRegister("5hC97", function(module, exports) {

$parcel$export(module.exports, "teamIdToAri", () => $11a33e5cfd5aff61$export$dd2be0859897f01f);
const $11a33e5cfd5aff61$export$e33271562ca4c847 = 'ari:cloud:identity::team/';
const $11a33e5cfd5aff61$export$dd2be0859897f01f = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($11a33e5cfd5aff61$export$e33271562ca4c847) ? teamIdOrTeamAri : `${$11a33e5cfd5aff61$export$e33271562ca4c847}${teamIdOrTeamAri}`;

});

parcelRegister("kVgV6", function(module, exports) {

$parcel$export(module.exports, "toUserId", () => $38be103a6dcea7bd$export$1d0eef1d33b05366);

var $cIGcY = parcelRequire("cIGcY");
const $38be103a6dcea7bd$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $cIGcY.USER_ARI_PREFIX));
const $38be103a6dcea7bd$export$1d0eef1d33b05366 = (ari)=>{
    if ($38be103a6dcea7bd$export$caac29844ad91f64(ari)) return ari.replace((0, $cIGcY.USER_ARI_PREFIX), '');
    throw new Error('Invalid UserARI');
};

});
parcelRegister("cIGcY", function(module, exports) {

$parcel$export(module.exports, "USER_ARI_PREFIX", () => $03b37aec443684cb$export$470b0d72e4fdc43a);
var $03b37aec443684cb$export$be86baa40543cfe6 = /*#__PURE__*/ function(JiraProjectTypes) {
    JiraProjectTypes["PRODUCT_DISCOVERY"] = "Product Discovery";
    JiraProjectTypes["SOFTWARE"] = "Software";
    JiraProjectTypes["SERVICE_DESK"] = "Service Desk";
    JiraProjectTypes["BUSINESS"] = "Business";
    JiraProjectTypes["CUSTOMER_SERVICE"] = "Customer Service";
    return JiraProjectTypes;
}({});
const $03b37aec443684cb$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $03b37aec443684cb$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';

});


parcelRegister("cHfzg", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", () => $094fbefc0d7aab64$export$c2f8e0cc249a8d8f);
const $094fbefc0d7aab64$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api'
};

});

parcelRegister("4IpKh", function(module, exports) {

$parcel$export(module.exports, "BaseGraphQlClient", () => $932a3668966bc549$export$42f6d6baced34b2d);

var $heKSh = parcelRequire("heKSh");

var $lBMVW = parcelRequire("lBMVW");

var $kXPUr = parcelRequire("kXPUr");
class $932a3668966bc549$export$42f6d6baced34b2d extends (0, $lBMVW.BaseClient) {
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = serviceUrl;
    }
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            return (0, $kXPUr.handleGraphQLRequest)(this.serviceUrl, body, options);
        } catch (error) {
            if (error instanceof (0, $heKSh.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $heKSh.DefaultError)({});
        }
    }
}

});
parcelRegister("heKSh", function(module, exports) {

$parcel$export(module.exports, "DefaultError", () => $fb50c88350b7ce17$export$c73ca302efeda3b4);
$parcel$export(module.exports, "HttpError", () => $fb50c88350b7ce17$export$65bd6083489bd8bb);
$parcel$export(module.exports, "GraphQLError", () => $fb50c88350b7ce17$export$92d6ed0888e7cb7f);
var $fb50c88350b7ce17$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
class $fb50c88350b7ce17$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
class $fb50c88350b7ce17$export$c73ca302efeda3b4 extends $fb50c88350b7ce17$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $fb50c88350b7ce17$export$c73ca302efeda3b4.prototype);
    }
}
class $fb50c88350b7ce17$export$d87f401f8106d7a2 extends $fb50c88350b7ce17$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $fb50c88350b7ce17$export$d87f401f8106d7a2.prototype);
    }
}
class $fb50c88350b7ce17$export$65bd6083489bd8bb extends $fb50c88350b7ce17$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId, path: path }){
        super(message);
        Object.setPrototypeOf(this, $fb50c88350b7ce17$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
        this.path = path;
    }
}
class $fb50c88350b7ce17$export$92d6ed0888e7cb7f extends $fb50c88350b7ce17$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $fb50c88350b7ce17$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $fb50c88350b7ce17$export$92d6ed0888e7cb7f(errorData);
        };
    }
}

});

parcelRegister("lBMVW", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $6a571b7a589348a9$export$4f22f74eddb7716a);
class $6a571b7a589348a9$export$4f22f74eddb7716a {
    constructor(config){
        this.cache = {};
        this.logException = (ex, name, context)=>{
            this.config.logException(ex, name, context);
        };
        this.config = config;
        this.context = {
            cloudId: null
        };
    }
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || null
        };
    }
    getContext() {
        return this.context;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
	 *
	 * @param localValue is used for backwards compatibility
	 * @returns
	 */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
    keyWithContext(key) {
        return `${this.getContext().cloudId}-${this.getContext().orgId ?? 'no-org-id'}-${this.getContext().userId ?? 'no-user-id'}-${key}`;
    }
    // Default expiration is 5 minutes
    cacheValue(key, value, expiryMs = 300000) {
        this.cache[this.keyWithContext(key)] = {
            data: value,
            expiration: Date.now() + expiryMs
        };
    }
    getCachedValue(key) {
        const record = this.cache[this.keyWithContext(key)];
        if (record && record.expiration > Date.now()) return record.data;
        return undefined;
    }
}

});

parcelRegister("kXPUr", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLRequest", () => $2a6c8b73b7ea2a94$export$7feffc86760ee7ce);

var $heKSh = parcelRequire("heKSh");

var $4oF7E = parcelRequire("4oF7E");

var $4jDDu = parcelRequire("4jDDu");
async function $2a6c8b73b7ea2a94$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $heKSh.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $heKSh.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}
async function $2a6c8b73b7ea2a94$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $4oF7E.withExponentialBackoff)($2a6c8b73b7ea2a94$export$93d33e3b46bf00e7, {
        initial: (0, $4oF7E.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $4oF7E.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $4oF7E.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $4oF7E.isFetchResponse)(data) && (0, $4oF7E.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result?.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $4jDDu.handleResponse)(response);
        if (status > 400 && status <= 599) throw new (0, $heKSh.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId ?? undefined
        });
    }
    return result;
}

});
parcelRegister("4oF7E", function(module, exports) {

$parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", () => $df96ac5fd047e9cf$export$8f4286bf21155381);
$parcel$export(module.exports, "is5xx", () => $df96ac5fd047e9cf$export$55b2fbd5d4a32495);
$parcel$export(module.exports, "isFetchResponse", () => $df96ac5fd047e9cf$export$81f27058be86d7ea);
$parcel$export(module.exports, "withExponentialBackoff", () => $df96ac5fd047e9cf$export$20eaa22f2295996f);
const $df96ac5fd047e9cf$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $df96ac5fd047e9cf$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
function $df96ac5fd047e9cf$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}
// tslint:disable-next-line no-any
const $df96ac5fd047e9cf$var$defaultRetryIfCallback = (a)=>!a;
const $df96ac5fd047e9cf$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $df96ac5fd047e9cf$var$defaultRetryIfCallback
};
function $df96ac5fd047e9cf$export$20eaa22f2295996f(toTry, hofOptions = $df96ac5fd047e9cf$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
const $df96ac5fd047e9cf$export$b4c0bf5325504bf3 = $df96ac5fd047e9cf$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
    initial: $df96ac5fd047e9cf$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $df96ac5fd047e9cf$export$8f4286bf21155381.JITTER,
    max: $df96ac5fd047e9cf$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>$df96ac5fd047e9cf$export$55b2fbd5d4a32495(response.status)
});

});

parcelRegister("4jDDu", function(module, exports) {

$parcel$export(module.exports, "handleResponse", () => $e995831021ac1bac$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $e995831021ac1bac$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $e995831021ac1bac$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $e995831021ac1bac$export$8c005e458e12d501.handlers = handlers;
    }
};
function $e995831021ac1bac$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $e995831021ac1bac$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});



parcelRegister("1DXuu", function(module, exports) {

$parcel$export(module.exports, "UnlinkContainerMutation", () => $1317185bd26f9e7e$export$74f3ccf149f124b);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $1317185bd26f9e7e$export$74f3ccf149f124b = (0, $1c8Um.print)((0, $5cllN.default)`
	mutation unlinkTeamToContainerMutation($teamId: ID!, $containerId: ID!) {
		graphStore @optIn(to: ["GraphStoreMutation"]) {
			deleteTeamConnectedToContainer(
				input: { relationships: [{ from: $teamId, to: $containerId }] }
			) @optIn(to: ["GraphStoreTeamConnectedToContainer"]) {
				errors {
					message
					extensions {
						statusCode
						errorType
					}
				}
				success
			}
		}
	}
`);

});

parcelRegister("hr6Fj", function(module, exports) {

$parcel$export(module.exports, "NumberOfTeamConnectedToContainerQuery", () => $2a7dc784c3643b0b$export$6c9c309d551311e);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $2a7dc784c3643b0b$export$6c9c309d551311e = (0, $1c8Um.print)((0, $5cllN.default)`
	query getNumberOfTeamsForContainer($containerId: ID!) {
		graphStore @optIn(to: "GraphStore") {
			teamConnectedToContainerInverse(id: $containerId, consistentRead: true)
				@optIn(to: "GraphStoreTeamConnectedToContainer") {
				edges {
					id
				}
			}
		}
	}
`);

});

parcelRegister("0ChzE", function(module, exports) {

$parcel$export(module.exports, "TeamConnectedToContainerQuery", () => $dbf68a2bd5948cf2$export$8e179b6008492526);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $dbf68a2bd5948cf2$export$8e179b6008492526 = (0, $1c8Um.print)((0, $5cllN.default)`
	query getTeamsForContainer($containerId: ID!) {
		graphStore @optIn(to: "GraphStore") {
			teamConnectedToContainerInverse(id: $containerId, consistentRead: true)
				@optIn(to: "GraphStoreTeamConnectedToContainer") {
				edges {
					node {
						... on TeamV2 {
							id
							description
							displayName
							creator {
								id
							}
							smallAvatarImageUrl
							smallHeaderImageUrl
							largeAvatarImageUrl
							largeHeaderImageUrl
							members {
								nodes {
									member {
										id
										name
										picture
										accountStatus
										... on AtlassianAccountUser {
											extendedProfile {
												jobTitle
											}
										}
										... on AppUser {
											appType
										}
									}
									role
									state
								}
								pageInfo {
									endCursor
									hasNextPage
								}
							}
							organizationId
							membershipSettings
							isVerified
							state
						}
					}
				}
			}
		}
	}
`);

});

parcelRegister("lUpJt", function(module, exports) {

$parcel$export(module.exports, "TeamContainersQuery", () => $3303201972cdaa15$export$f0275d326396e5f9);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");
const $3303201972cdaa15$export$f0275d326396e5f9 = (0, $1c8Um.print)((0, $5cllN.default)`
	query TeamContainersQuery($cypherQuery: String!) {
		graphStore @optIn(to: ["GraphStore"]) {
			cypherQuery(query: $cypherQuery) @optIn(to: ["GraphStoreCypherQuery"]) {
				edges {
					__typename
					node {
						from {
							id
						}
						to {
							id
							data {
								__typename
								... on ConfluenceSpace {
									id
									confluenceSpaceName: name
									type
									createdDate
									links {
										base
										webUi
									}
									icon {
										path
									}
								}
								... on JiraProject {
									id
									jiraProjectName: name
									webUrl
									created
									avatar {
										medium
									}
									projectType
									projectTypeName
								}
							}
						}
					}
				}
			}
		}
	}
`);

});




parcelRegister("i9DPg", function(module, exports) {

$parcel$export(module.exports, "AddContainerCard", () => $a2aa535ff8547201$export$7f436a9048e9eef4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $g7g8o = parcelRequire("g7g8o");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $AX5oF = parcelRequire("AX5oF");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $97V6h = parcelRequire("97V6h");
const $a2aa535ff8547201$var$styles = {
    card: "_4cvr1h6o _1bsb1osq",
    container: "_2rkoop52 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _d0altlke",
    iconWrapper: "_2rkoiti9 _12y3e4h9 _12jimuej _1qu2gq9o _syaz131l _4cvxmuej _ksodnqa1"
};
const $a2aa535ff8547201$var$AddContainerCardWrapper = ({ children: children, onClick: onClick })=>{
    const [hovered, setHovered] = (0, $5uXOq.useState)(false);
    const handleMouseEnter = ()=>setHovered(true);
    const handleMouseLeave = ()=>setHovered(false);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        backgroundColor: hovered ? 'elevation.surface.hovered' : 'elevation.surface.sunken',
        xcss: $a2aa535ff8547201$var$styles.container,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: onClick,
        children: children
    });
};
const $a2aa535ff8547201$export$7f436a9048e9eef4 = ({ containerType: containerType, onAddAContainerClick: onAddAContainerClick })=>{
    const { description: description, icon: icon, title: title } = (0, $97V6h.getContainerProperties)(containerType);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($a2aa535ff8547201$var$AddContainerCardWrapper, {
        onClick: onAddAContainerClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            space: "space.100",
            xcss: $a2aa535ff8547201$var$styles.card,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $a2aa535ff8547201$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                        label: "Add a container",
                        appearance: "subtle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g7g8o))),
                        testId: "add-icon",
                        onClick: (e)=>{
                            onAddAContainerClick(e);
                            e.stopPropagation();
                        }
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            maxLines: 1,
                            weight: "medium",
                            color: "color.text",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $AX5oF.default), {
                            gap: "space.050",
                            ...(0, $fHpHg.fg)('enable_card_alignment_fix') ? {
                                alignItems: 'center'
                            } : {},
                            children: [
                                icon,
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                    size: "small",
                                    color: "color.text.subtle",
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("g7g8o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73693506539a99d0ae3d26d395e92ac2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $030720451248870d$var$_react = $030720451248870d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $030720451248870d$var$_baseNew = $030720451248870d$var$_interopRequireDefault((parcelRequire("enEmH")));
function $030720451248870d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for creating and adding an object as a secondary/tertiary action in a menu item.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $030720451248870d$var$AddIcon = (props)=>/*#__PURE__*/ $030720451248870d$var$_react.default.createElement($030720451248870d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.25 6.75V11h1.5V6.75H11v-1.5H6.75V1h-1.5v4.25H1v1.5z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$030720451248870d$var$AddIcon.displayName = 'AddIcon';
var $030720451248870d$var$_default = module.exports.default = $030720451248870d$var$AddIcon;

});

parcelRegister("97V6h", function(module, exports) {

$parcel$export(module.exports, "getContainerProperties", () => $395440952e0648c8$export$4fa7913af1c65224);
/* get-container-properties.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $5FmWx = parcelRequire("5FmWx");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $AX5oF = parcelRequire("AX5oF");
var $k9nuy = parcelRequire("k9nuy");

var $iyaiG = parcelRequire("iyaiG");

var $ksVw7 = parcelRequire("ksVw7");

var $5W6TU = parcelRequire("5W6TU");

var $7PM8U = parcelRequire("7PM8U");
const $395440952e0648c8$var$styles = {
    iconWrapper: "_1bsb1crf _4t3i1crf",
    mediumIconWrapper: "_1bsb7vkz _4t3i7vkz"
};
const $395440952e0648c8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    addConfluenceContainerTitle: {
        id: 'ptc-directory.team-profile-page.team-containers.add-confluence-space-title.non-final',
        defaultMessage: 'Add space',
        description: 'Title of the card to add a Confluence space to a team'
    },
    confluenceContainerDescription: {
        id: 'ptc-directory.team-profile-page.team-containers.add-confluence-space-description.non-final',
        defaultMessage: 'Confluence',
        description: 'Description of the card to add a Confluence space to a team'
    },
    addJiraProjectTitle: {
        id: 'ptc-directory.team-profile-page.team-containers.add-jira-project-title.non-final',
        defaultMessage: 'Add project',
        description: 'Title of the card to add a Jira project to a team'
    },
    jiraProjectDescription: {
        id: 'ptc-directory.team-profile-page.team-containers.add-jira-project-description.non-final',
        defaultMessage: 'Jira',
        description: 'Description of the card to add a Jira project to a team'
    },
    addLoomSpaceTitle: {
        id: 'ptc-directory.team-profile-page.team-containers.add-loom-space-title.non-final',
        defaultMessage: 'Add space',
        description: 'Title of the card to add a Loom space to a team'
    },
    loomSpaceDescription: {
        id: 'ptc-directory.team-profile-page.team-containers.add-loom-space-description.non-final',
        defaultMessage: 'Loom',
        description: 'Description of the card to add a Loom space to a team'
    },
    projectContainerText: {
        id: 'ptc-directory.team-profile-page.team-containers.project-container-text.non-final',
        defaultMessage: 'project',
        description: 'Text for project type containers'
    },
    spaceContainerText: {
        id: 'ptc-directory.team-profile-page.team-containers.space-container-text.non-final',
        defaultMessage: 'space',
        description: 'Text for space type containers'
    },
    webLinkContainerTitle: {
        id: 'ptc-directory.team-profile-page.team-containers.webLink-container-text.non-final',
        defaultMessage: 'Add any web link',
        description: 'Description of the card to add a web link to a team'
    }
});
const $395440952e0648c8$var$getJiraIcon = (containerSubTypes)=>{
    switch(containerSubTypes){
        case 'PRODUCT_DISCOVERY':
            return 0, (/*@__PURE__*/$parcel$interopDefault($5W6TU));
        case 'SERVICE_DESK':
            return 0, (/*@__PURE__*/$parcel$interopDefault($7PM8U));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($ksVw7));
    }
};
const $395440952e0648c8$var$getJiraContainerProperties = (containerTypeProperties)=>{
    const { subType: subType, name: name } = containerTypeProperties || {};
    const Comp = (0, $fHpHg.fg)('enable_card_alignment_fix') ? (0, $AX5oF.default) : (0, $5sRpy.default);
    const baseProperties = {
        description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$395440952e0648c8$export$defe85febe8b728c.jiraProjectDescription
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)(Comp, {
            xcss: $395440952e0648c8$var$styles.iconWrapper,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5FmWx.default), {
                src: $395440952e0648c8$var$getJiraIcon(subType),
                alt: "",
                testId: "jira-project-container-icon"
            })
        }),
        title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$395440952e0648c8$export$defe85febe8b728c.addJiraProjectTitle
        }),
        containerTypeText: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$395440952e0648c8$export$defe85febe8b728c.projectContainerText
        })
    };
    switch(subType){
        case 'PRODUCT_DISCOVERY':
        case 'SERVICE_DESK':
            return {
                ...baseProperties,
                containerTypeText: '',
                description: name || baseProperties.description
            };
        default:
            return baseProperties;
    }
};
const $395440952e0648c8$export$4fa7913af1c65224 = (containerType, iconSize = 'small', containerTypeProperties)=>{
    const Comp = (0, $fHpHg.fg)('enable_card_alignment_fix') ? (0, $AX5oF.default) : (0, $5sRpy.default);
    switch(containerType){
        case 'ConfluenceSpace':
            return {
                description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...$395440952e0648c8$export$defe85febe8b728c.confluenceContainerDescription
                }),
                icon: /*#__PURE__*/ (0, $2OMIu.jsx)(Comp, {
                    xcss: iconSize === 'medium' ? $395440952e0648c8$var$styles.mediumIconWrapper : $395440952e0648c8$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5FmWx.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($iyaiG))),
                        alt: "",
                        testId: "confluence-space-container-icon"
                    })
                }),
                title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...$395440952e0648c8$export$defe85febe8b728c.addConfluenceContainerTitle
                }),
                containerTypeText: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...$395440952e0648c8$export$defe85febe8b728c.spaceContainerText
                })
            };
        case 'JiraProject':
            return $395440952e0648c8$var$getJiraContainerProperties(containerTypeProperties);
        case 'WebLink':
            return {
                description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                    size: "medium",
                    weight: "medium",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...$395440952e0648c8$export$defe85febe8b728c.webLinkContainerTitle
                    })
                }),
                icon: null,
                title: null,
                containerTypeText: null
            };
        default:
            return {
                description: null,
                icon: null,
                title: null,
                containerTypeText: null
            };
    }
};

});
parcelRegister("iyaiG", function(module, exports) {
module.exports = new URL("ConfluenceIcon.d49d30a0.svg", import.meta.url).toString();

});

parcelRegister("ksVw7", function(module, exports) {
module.exports = new URL("JiraIcon.61c2353c.svg", import.meta.url).toString();

});

parcelRegister("5W6TU", function(module, exports) {
module.exports = new URL("JiraProjectDiscovery.59099094.svg", import.meta.url).toString();

});

parcelRegister("7PM8U", function(module, exports) {
module.exports = new URL("JiraServiceManagement.e75af785.svg", import.meta.url).toString();

});



parcelRegister("183ER", function(module, exports) {

$parcel$export(module.exports, "DisconnectDialogLazy", () => $6730cb60995207eb$export$3f4d3ee9eb71a228);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $kc9vJ = parcelRequire("kc9vJ");

const $6730cb60995207eb$var$DisconnectDialogLazyInner = (0, $kc9vJ.lazyForPaint)(()=>(parcelRequire("6YaMB")).then(({ DisconnectDialog: DisconnectDialog })=>DisconnectDialog));
const $6730cb60995207eb$export$3f4d3ee9eb71a228 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kc9vJ.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($6730cb60995207eb$var$DisconnectDialogLazyInner, {
            ...props
        })
    });

});
parcelRegister("6YaMB", function(module, exports) {

let $5130b5f2bd2a2d61$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5130b5f2bd2a2d61$var$load("1OgAT").then(()=>parcelRequire('gkNOP'));

});


parcelRegister("aSC9C", function(module, exports) {

$parcel$export(module.exports, "LinkedContainerCard", () => $279633fba9f5ad42$export$139000e88c9ad830);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $bngFq = parcelRequire("bngFq");

var $ew55A = parcelRequire("ew55A");

var $1Seuh = parcelRequire("1Seuh");

var $gANiX = parcelRequire("gANiX");

var $8zIDr = parcelRequire("8zIDr");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $AX5oF = parcelRequire("AX5oF");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $5KCCi = parcelRequire("5KCCi");

var $3CiMs = parcelRequire("3CiMs");

var $97V6h = parcelRequire("97V6h");
const $279633fba9f5ad42$var$styles = {
    container: "_2rkoop52 _1h6dz9xs _12y3e4h9 _12jimuej _1qu2nqa1 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _syaz1fxt",
    card: "_4cvr1h6o _1bsb1osq",
    iconWrapper: "_1bsbzwfg _4t3izwfg _1ul9zwfg _1tkezwfg",
    crossIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u01wug"
};
const $279633fba9f5ad42$var$LinkedCardWrapper = ({ children: children, href: href, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, containerType: containerType, containerId: containerId })=>{
    const [hovered, setHovered] = (0, $5uXOq.useState)(false);
    const onMouseEnter = ()=>{
        handleMouseEnter();
        setHovered(true);
    };
    const { fireUIEvent: fireUIEvent } = (0, $3CiMs.usePeopleAndTeamAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const onMouseLeave = ()=>{
        handleMouseLeave();
        setHovered(false);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        backgroundColor: hovered ? 'color.background.input.hovered' : 'color.background.input',
        xcss: $279633fba9f5ad42$var$styles.container,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: "linked-container-card-inner",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8zIDr.default), {
            href: href,
            appearance: "subtle",
            onClick: ()=>{
                fireUIEvent(createAnalyticsEvent, {
                    action: (0, $3CiMs.AnalyticsAction).CLICKED,
                    actionSubject: 'container',
                    actionSubjectId: 'teamContainer',
                    attributes: {
                        containerSelected: {
                            container: containerType,
                            containerId: containerId
                        }
                    }
                });
            },
            children: children
        })
    });
};
const $279633fba9f5ad42$export$139000e88c9ad830 = ({ containerType: containerType, title: title, containerIcon: containerIcon, link: link, containerId: containerId, containerTypeProperties: containerTypeProperties, onDisconnectButtonClick: onDisconnectButtonClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { description: description, icon: icon, containerTypeText: containerTypeText } = (0, $97V6h.getContainerProperties)(containerType, 'small', containerTypeProperties);
    const [showCloseIcon, setShowCloseIcon] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireUIEvent: fireUIEvent } = (0, $3CiMs.usePeopleAndTeamAnalytics)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($279633fba9f5ad42$var$LinkedCardWrapper, {
        href: link || '#',
        handleMouseEnter: ()=>setShowCloseIcon(true),
        handleMouseLeave: ()=>setShowCloseIcon(false),
        containerType: containerType,
        containerId: containerId,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            space: "space.100",
            xcss: $279633fba9f5ad42$var$styles.card,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ew55A.default), {
                    appearance: "square",
                    size: "medium",
                    src: containerIcon,
                    testId: "linked-container-icon"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            maxLines: 1,
                            weight: "medium",
                            color: "color.text",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $AX5oF.default), {
                            gap: "space.050",
                            ...(0, $fHpHg.fg)('enable_card_alignment_fix') ? {
                                alignItems: 'center'
                            } : {},
                            children: [
                                icon,
                                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                                    space: "space.050",
                                    children: [
                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                            size: "small",
                                            color: "color.text.subtle",
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                            size: "small",
                                            color: "color.text.subtle",
                                            children: containerTypeText
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                showCloseIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $279633fba9f5ad42$var$styles.crossIconWrapper,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
                        content: formatMessage($279633fba9f5ad42$var$messages.disconnectTooltip),
                        position: "top",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                            label: `disconnect the container ${title}`,
                            appearance: "subtle",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gANiX))),
                            spacing: "compact",
                            onClick: (e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                onDisconnectButtonClick();
                                fireUIEvent(createAnalyticsEvent, {
                                    action: (0, $3CiMs.AnalyticsAction).CLICKED,
                                    actionSubject: 'button',
                                    actionSubjectId: 'containerUnlinkButton'
                                });
                            }
                        })
                    })
                })
            ]
        })
    });
};
const $279633fba9f5ad42$var$messages = (0, $7VHMR.defineMessages)({
    disconnectTooltip: {
        id: 'ptc-directory.team-containers.disconnect-button.tooltip',
        defaultMessage: 'Disconnect',
        description: 'Tooltip for the disconnect button'
    }
});

});

parcelRegister("lPIeA", function(module, exports) {

$parcel$export(module.exports, "NoProductAccessState", () => $7332473eee7a96b6$export$ecd1a08b364becd6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $bWfiu = parcelRequire("bWfiu");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");

var $j89ya = parcelRequire("j89ya");
const $7332473eee7a96b6$var$styles = {
    emptyStateContainer: "_2rkoiti9 _189ee4h9 _1h6dmuej _18zrxy5q _12y3e4h9 _12jimuej _1qu2nqa1",
    contentWrapper: "_bozgxy5q"
};
const $7332473eee7a96b6$export$ecd1a08b364becd6 = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gOkqF.default), {
        space: "space.100",
        xcss: $7332473eee7a96b6$var$styles.emptyStateContainer,
        testId: "team-containers-no-product-access-state",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j89ya.NoProductAccessIcon), {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $7332473eee7a96b6$var$styles.contentWrapper,
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...$7332473eee7a96b6$var$messages.teamContainerEmptyStateTitle
                                })
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                ...$7332473eee7a96b6$var$messages.teamContainerEmptyStateDescription
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $7332473eee7a96b6$var$messages = (0, $7VHMR.defineMessages)({
    teamContainerEmptyStateTitle: {
        id: 'ptc.team-profile-page.team-containers.empty-state.title',
        defaultMessage: 'Add the places your team works',
        description: 'Empty state title when user has no product access'
    },
    teamContainerEmptyStateDescription: {
        id: 'ptc.team-profile-page.team-containers.empty-state.description',
        defaultMessage: 'Your team can link their Jira projects, Confluence spaces here to show where they work',
        description: 'Empty state description when user has no product access'
    }
});

});
parcelRegister("j89ya", function(module, exports) {

$parcel$export(module.exports, "NoProductAccessIcon", () => $87a7cd0cf7799dc5$export$bf513868cd2f920f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $87a7cd0cf7799dc5$var$TeamContainersNoProductAccess() {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "180",
        height: "170",
        viewBox: "0 0 180 170",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M65.004 40.9222L33.3022 45.8529L38.2329 77.5546L118.928 65.004L115.791 44.8301L78.3249 50.6572L65.004 40.9222Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M120.273 73.6499L39.5776 86.2006L45.8529 126.548L126.548 113.998L120.273 73.6499Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0_5508_39188)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M129.406 142.298C120.375 151.329 105.733 151.329 96.7018 142.298C87.671 133.267 87.671 118.626 96.7018 109.595L104.878 101.419L111.419 107.959L103.243 116.135C97.8241 121.554 97.8241 130.339 103.243 135.757C108.661 141.176 117.446 141.176 122.865 135.757L131.041 127.582L137.581 134.122L129.406 142.298Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M152.298 119.406C161.329 110.375 161.329 95.7328 152.298 86.7019C143.267 77.6711 128.625 77.6711 119.594 86.7019L111.418 94.8779L117.959 101.419L126.135 93.2427C131.553 87.8242 140.339 87.8242 145.757 93.2427C151.176 98.6612 151.176 107.446 145.757 112.865L137.581 121.041L144.122 127.582L152.298 119.406Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M139.449 106.092L116.324 129.217L109.783 122.676L132.908 99.5512L139.449 106.092Z",
                        fill: "#FCA700"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M101.784 117.729L90.8252 119.434C91.8704 115.787 93.8291 112.347 96.7015 109.475L104.877 101.299L111.418 107.84L103.242 116.016C102.702 116.556 102.216 117.129 101.784 117.729ZM125.459 106.88L126.548 113.878L116.972 115.367L125.459 106.88ZM121.979 84.5L123.699 95.5589L117.959 101.299L111.418 94.7581L119.594 86.5822C120.352 85.8246 121.149 85.1305 121.979 84.5Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M147.591 62.1215C147.471 62.5353 147.38 62.9491 147.239 63.3629C146.689 65.0183 145.949 66.7017 144.779 68.2518C143.63 69.8019 141.847 71.1485 139.838 71.6886C137.837 72.2498 135.835 72.1025 134.073 71.6886C130.528 70.8329 127.687 69.1005 125.178 67.375H125.249V67.3329C125.798 67.5293 127.25 68.2798 128.639 68.855C130.013 69.4582 131.324 69.872 131.324 69.872C129.675 68.5323 127.871 67.5363 125.968 66.4982C124.079 65.4672 122.133 64.401 120.512 63.0613L120.329 63.3419C121.753 64.4922 122.986 65.5654 123.444 66.0704C120.59 64.3449 116.678 61.2517 113.154 57.871C112.266 57.0293 111.406 56.1735 110.575 55.3248C110.391 55.1355 110.081 54.8198 110.138 54.8759C110.138 54.8759 110.123 54.8619 110.088 54.8479L109.961 54.7707L109.616 54.5673C109.158 54.2938 108.707 54.0202 108.27 53.7607C107.819 53.5362 107.382 53.3188 106.952 53.1084C106.74 53.0032 106.529 52.8839 106.325 52.7997C106.113 52.7156 105.909 52.6385 105.704 52.5613C105.303 52.414 104.915 52.2246 104.541 52.1054C104.168 51.9931 103.815 51.8949 103.484 51.7967C103.576 51.6845 104.02 51.8599 104.513 51.9581C104.999 52.0703 105.535 52.2246 105.888 51.895L104.837 51.5162C104.478 51.425 104.125 51.3409 103.773 51.2497L103.244 51.1164C103.068 51.0743 102.892 51.0743 102.716 51.0533C102.363 51.0252 102.018 50.9901 101.673 50.9621C101.673 51.5022 102.434 51.3759 102.582 51.4811C102.434 51.5092 102.117 51.5232 101.659 51.5162C101.433 51.5372 101.179 51.5863 100.89 51.6214C100.601 51.6635 100.277 51.6705 99.953 51.7897C98.6068 52.0843 96.9787 52.926 95.703 54.5743C94.4555 56.2437 93.645 58.6986 93.6309 61.3289C93.6309 62.6335 93.7507 63.9872 94.1172 65.2708L94.237 65.7548L94.4062 66.2247C94.5189 66.5333 94.6176 66.856 94.7445 67.1646C95.0334 67.7538 95.2731 68.378 95.6325 68.9111C96.2598 70.0474 97.1056 71.0013 97.9725 71.843C98.4518 72.2147 98.8535 72.6566 99.361 72.9442C99.6006 73.1055 99.8402 73.2668 100.073 73.4211C100.305 73.5824 100.573 73.6806 100.813 73.8139C101.06 73.9402 101.299 74.0664 101.532 74.1856C101.778 74.2908 102.032 74.368 102.272 74.4662C102.751 74.6486 103.216 74.845 103.681 74.9361C104.147 75.0484 104.577 75.1887 104.992 75.2728C105.415 75.343 105.817 75.4061 106.177 75.4622C106.902 75.6235 107.53 75.6165 107.988 75.7077C108.453 75.7779 108.756 75.862 108.883 75.9602C109.123 76.1566 108.629 76.4021 107.072 76.7177L107.389 76.9913C104.147 77.0684 101.412 76.6476 98.1346 75.2167C97.7329 74.9081 97.6554 74.9221 97.8175 74.6977C97.7329 74.5925 97.599 74.4101 97.7117 74.347C98.1417 73.835 97.1902 73.3931 96.8448 73.0845C96.725 73.3159 96.4994 73.4071 96.2105 73.337C95.9285 73.2598 95.5762 73.0353 95.1744 72.7057C94.7515 72.3971 94.3991 71.878 93.9833 71.3449C93.7648 71.0784 93.6097 70.7628 93.4335 70.4472C93.2644 70.1245 93.0741 69.8089 92.9261 69.4582C92.6582 68.7568 92.3552 68.0554 92.2142 67.3329C92.1296 66.9752 92.0309 66.6315 91.9746 66.2948C91.9252 65.9511 91.8829 65.6215 91.8406 65.3129C91.7067 64.0644 91.7067 63.0894 91.6856 62.7247C91.1922 62.6195 91.0795 61.8619 91.2134 61.0483C91.2768 60.2277 91.5658 59.3719 91.4178 58.888C91.3755 58.9441 91.0865 59.3159 91.0512 59.365C90.9878 59.2527 90.9808 58.9371 91.0442 58.4882C91.1429 58.0463 91.2698 57.4641 91.5023 56.8188C91.9605 55.5353 92.8485 54.0483 93.8987 52.919C94.1736 52.6525 94.4414 52.386 94.6952 52.1334C94.9841 51.916 95.2519 51.7126 95.5057 51.5232C95.6325 51.425 95.7524 51.3409 95.8651 51.2497C95.992 51.1795 96.1118 51.1094 96.2246 51.0462C96.4501 50.92 96.6475 50.8007 96.8025 50.7026C97.1127 50.4851 97.31 50.3939 97.2818 50.3238C97.2536 50.2607 96.9999 50.2256 96.4924 50.3659C98.2051 49.0613 100.714 48.3809 103.244 48.5843C105.789 48.7596 108.312 49.6645 110.687 50.899C110.983 51.0603 111.272 51.2216 111.575 51.3829L112.019 51.6284C112.217 51.7406 112.485 51.8599 112.675 52.0913C113.154 52.5613 113.633 53.0382 114.12 53.5152C115.05 54.42 115.987 55.3318 116.953 56.2367C118.877 58.0533 120.886 59.8489 122.972 61.5463C125.065 63.2297 127.243 64.8149 129.506 66.0984C130.64 66.7297 131.796 67.2838 132.952 67.7257C134.115 68.1395 135.278 68.4271 136.392 68.5253C138.626 68.6586 140.508 67.873 141.629 66.2597C142.235 65.5163 142.636 64.5694 142.975 63.6576C143.144 63.1946 143.243 62.6966 143.369 62.2337C143.44 62.0092 143.475 61.7567 143.51 61.5182L143.567 61.1605L143.595 60.9852L143.609 60.894C143.609 60.894 143.609 60.894 143.602 60.887C143.637 60.908 143.687 60.887 143.708 60.9501C143.687 60.887 143.75 60.887 143.602 60.88C143.658 60.88 143.708 60.8659 143.743 60.8379C143.743 60.8239 143.771 60.8379 143.764 60.7958C143.75 60.7327 143.736 60.6625 143.722 60.5994C143.687 60.4661 143.658 60.3259 143.616 60.1856C143.433 59.6315 143.243 59.0142 142.989 58.4671C142.524 57.3589 141.995 56.4751 141.995 56.4751C141.311 55.1845 140.501 53.922 139.641 52.6735C139.641 52.6735 139.303 52.3158 138.76 51.7406C138.217 51.1585 137.47 50.3659 136.681 49.419C135.898 48.4791 135.074 47.3919 134.489 46.2206C133.904 45.0632 133.594 43.8147 133.699 42.9099C133.516 41.8157 133.615 40.6795 133.925 39.6274C134.101 39.1153 134.277 38.5893 134.538 38.1193C134.757 37.6213 135.053 37.1865 135.335 36.7376C136.497 34.97 137.949 33.4901 139.444 32.0943C139.444 32.0943 139.493 32.0592 139.556 32.0031C139.859 32.0031 140.177 32.0311 140.395 32.1153C140.36 31.975 140.48 31.989 140.494 31.9399L140.508 32.0592C140.874 31.6804 141.304 31.3437 141.769 31.0491C141.72 30.9159 141.699 30.8317 141.713 30.8247C140.007 30.3688 135.37 31.8347 134.066 30.7335L131.606 31.3157C130.612 30.8738 129.4 30.7125 129.802 30.1022C130.204 29.492 141.565 27.2265 144.709 28.2716L144.673 28.2926C144.673 28.2926 145.667 28.5171 145.639 28.3908C146.118 30.5582 146.915 33.5882 145.801 35.6363C146.069 36.3728 144.342 46.6695 142.51 43.934C142.721 42.2647 142.601 40.1815 142.721 38.5261C142.763 36.8498 142.721 34.7806 142.672 33.2305C142.672 33.2305 142.665 33.2095 142.651 33.1814C142.629 33.2235 142.615 33.2586 142.622 33.2796C140.578 34.6333 138.823 36.3728 137.675 38.2456C137.09 39.1784 136.73 40.1394 136.596 40.9951C136.469 41.8578 136.568 42.6153 136.871 43.5131C136.66 43.5412 136.554 43.7166 136.709 43.7937L136.927 43.6604C137.209 44.9721 138.076 46.0101 138.908 46.9781C139.754 47.9601 140.628 48.9561 141.333 50.4641C141.333 50.4571 141.347 49.9731 141.347 49.9591C143.109 52.0493 145.089 54.5042 146.626 57.4641C146.809 57.8359 146.992 58.2146 147.182 58.5934C147.394 59.0984 147.605 59.6104 147.817 60.1224C147.873 60.2908 147.979 60.4591 148 60.6345L147.859 61.1675L147.605 62.1074L147.591 62.1215Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                    id: "clip0_5508_39188",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "111",
                        height: "111",
                        fill: "white",
                        transform: "translate(69 59)"
                    })
                })
            })
        ]
    });
}
function $87a7cd0cf7799dc5$export$bf513868cd2f920f() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($87a7cd0cf7799dc5$var$TeamContainersNoProductAccess, {})
    });
}

});


parcelRegister("2nXrX", function(module, exports) {

$parcel$export(module.exports, "TeamContainersSkeleton", () => $ea59a0f5da0321ff$export$b4d5d8f3bbe29b5f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
var $kUuXA = parcelRequire("kUuXA");
var $gOkqF = parcelRequire("gOkqF");

var $2zHu1 = parcelRequire("2zHu1");
const $ea59a0f5da0321ff$var$styles = {
    containers: "_yv0ewxkt",
    showMoreButtonSkeleton: "_2rko1q77 _1rjc1b66 _1bsbvbgk"
};
const $ea59a0f5da0321ff$export$b4d5d8f3bbe29b5f = ({ numberOfContainers: numberOfContainers })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
        space: "space.200",
        testId: "team-containers-skeleton",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kUuXA.default), {
                xcss: $ea59a0f5da0321ff$var$styles.containers,
                gap: "space.100",
                autoFlow: "row",
                children: [
                    ...Array(numberOfContainers)
                ].map((_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2zHu1.LinkedContainerCardSkeleton), {}, index))
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                backgroundColor: "color.background.neutral",
                xcss: $ea59a0f5da0321ff$var$styles.showMoreButtonSkeleton
            })
        ]
    });
};

});
parcelRegister("kUuXA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e7b165ebeff139$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c5e7b165ebeff139$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $c5e7b165ebeff139$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $c5e7b165ebeff139$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $c5e7b165ebeff139$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $c5e7b165ebeff139$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $c5e7b165ebeff139$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $c5e7b165ebeff139$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $c5e7b165ebeff139$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $bwpsq.default)([
            $c5e7b165ebeff139$var$baseStyles.root,
            gap && $c5e7b165ebeff139$var$columnGapMap[gap],
            columnGap && $c5e7b165ebeff139$var$columnGapMap[columnGap],
            gap && $c5e7b165ebeff139$var$rowGapMap[gap],
            rowGap && $c5e7b165ebeff139$var$rowGapMap[rowGap],
            alignItems && $c5e7b165ebeff139$var$alignItemsMap[alignItems],
            alignContent && $c5e7b165ebeff139$var$alignContentMap[alignContent],
            justifyContent && $c5e7b165ebeff139$var$justifyContentMap[justifyContent],
            autoFlow && $c5e7b165ebeff139$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$c5e7b165ebeff139$var$Grid.displayName = 'Grid';
var $c5e7b165ebeff139$export$2e2bcd8739ae039 = $c5e7b165ebeff139$var$Grid;

});

parcelRegister("2zHu1", function(module, exports) {

$parcel$export(module.exports, "LinkedContainerCardSkeleton", () => $cade79b1c50293f5$export$b7a75d9378054329);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");
const $cade79b1c50293f5$var$styles = {
    container: "_2rkoiti9 _1h6dz9xs _12y3e4h9 _12jimuej _1qu2nqa1 _syaz1fxt _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    avatarSkeleton: "_2rkoglpi _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    firstLineSkeleton: "_2rko1q77 _1rjc1b66",
    secondLineSkeleton: "_2rko1q77 _1rjc1b66 _1bsbqkoa"
};
const $cade79b1c50293f5$export$b7a75d9378054329 = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $cade79b1c50293f5$var$styles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    backgroundColor: "color.background.neutral",
                    xcss: $cade79b1c50293f5$var$styles.avatarSkeleton
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                    space: "space.100",
                    grow: "fill",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            backgroundColor: "color.background.neutral",
                            xcss: $cade79b1c50293f5$var$styles.firstLineSkeleton
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            backgroundColor: "color.background.neutral",
                            xcss: $cade79b1c50293f5$var$styles.secondLineSkeleton
                        })
                    ]
                })
            ]
        })
    });
};

});



parcelRegister("c2pOK", function(module, exports) {

$parcel$export(module.exports, "ButtonSection", () => $41861b9ed2bfe8e6$export$9e37f1921390352d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bngFq = parcelRequire("bngFq");

var $liZ21 = parcelRequire("liZ21");

var $7H980 = parcelRequire("7H980");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");

var $jQ0hK = parcelRequire("jQ0hK");

var $6l5v6 = parcelRequire("6l5v6");

var $7rcxw = parcelRequire("7rcxw");
const $41861b9ed2bfe8e6$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
const $41861b9ed2bfe8e6$var$styles = {
    containerStyles: "_uwhke4h9 _15a5nqa1 _1i53muej _19bv1ejb _u5f31ejb _ca0qpxbi",
    actionContainerStyles: "_16jlkb7n"
};
const $41861b9ed2bfe8e6$export$9e37f1921390352d = ({ teamProfileUrl: teamProfileUrl, isKudosEnabled: isKudosEnabled, otherActions: otherActions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onTeamProfileClick = (0, $5uXOq.useCallback)(()=>{
        if (createAnalyticsEvent) (0, $jQ0hK.fireEvent)(createAnalyticsEvent, {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'viewTeamProfileButton',
            attributes: {}
        });
    }, [
        createAnalyticsEvent
    ]);
    const extraActions = [];
    if (isKudosEnabled) extraActions.push({
        id: $41861b9ed2bfe8e6$var$GIVE_KUDOS_ACTION_ID,
        item: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7H980.default), {
            children: formatMessage((0, $6l5v6.messages).giveKudos)
        })
    });
    if (otherActions) extraActions.push(...otherActions);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bEIgH.default), {
        xcss: $41861b9ed2bfe8e6$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2Eqc8.default), {
            space: "space.050",
            children: [
                teamProfileUrl && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                    xcss: $41861b9ed2bfe8e6$var$styles.actionContainerStyles,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $liZ21.default), {
                        onClick: onTeamProfileClick,
                        href: teamProfileUrl,
                        target: "_blank",
                        shouldFitContainer: true,
                        children: formatMessage((0, $6l5v6.messages).viewProfile)
                    })
                }),
                extraActions.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rcxw.MoreActions), {
                    actions: extraActions
                })
            ]
        })
    });
};

});
parcelRegister("6l5v6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6d4af7cfa8b28736$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $6d4af7cfa8b28736$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    viewProfile: {
        id: 'team-profile-card.team-actions.view-profile',
        defaultMessage: 'View profile',
        description: 'View profile button text'
    },
    giveKudos: {
        id: 'team-profile-card.team-actions.give-kudos',
        defaultMessage: 'Give kudos',
        description: 'Give kudos button text'
    }
});

});

parcelRegister("7rcxw", function(module, exports) {

$parcel$export(module.exports, "MoreActions", () => $36df48abf6d3d1de$export$f2f44eb5b71ba65f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $1Seuh = parcelRequire("1Seuh");

var $elaEw = parcelRequire("elaEw");

var $aOrxC = parcelRequire("aOrxC");
var $70rf1 = parcelRequire("70rf1");

var $vCqQa = parcelRequire("vCqQa");

var $0yZbT = parcelRequire("0yZbT");

var $jz4hE = parcelRequire("jz4hE");
const $36df48abf6d3d1de$export$f2f44eb5b71ba65f = ({ actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setOpen] = (0, $5uXOq.useState)(false);
    const onMoreClick = (0, $5uXOq.useCallback)((shouldBeOpen)=>{
        setOpen(shouldBeOpen);
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.default), {
        isOpen: isOpen,
        onClose: ()=>setOpen(false),
        content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $aOrxC.default), {
                spacing: "cozy",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70rf1.default), {
                    children: actions.map((action)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                            children: action.item
                        }, action.id))
                })
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($elaEw))),
                label: formatMessage((0, $jz4hE.messages).showMoreIconLabel),
                onClick: ()=>onMoreClick(!isOpen),
                isSelected: isOpen
            }),
        placement: "right-start",
        shouldRenderToParent: false
    });
};

});
parcelRegister("jz4hE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5831f190c3e03fd5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5831f190c3e03fd5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    showMoreIconLabel: {
        id: 'team-profile-card.team-actions.more-actions.show-more-icon-label',
        defaultMessage: 'Show more',
        description: 'Show more icon label'
    }
});

});



parcelRegister("6coWW", function(module, exports) {

$parcel$export(module.exports, "TeamConnections", () => $5ec6aabf6642fa45$export$e9e0251ab710cd0d);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $44qT7 = parcelRequire("44qT7");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $97V6h = parcelRequire("97V6h");

var $jQ0hK = parcelRequire("jQ0hK");
const $5ec6aabf6642fa45$var$styles = {
    containerWrapperStyles: "_1e0c1txw _4cvr1h6o",
    containerIconStyles: "_2rkoiti9 _4t3i1tcg _1bsb1tcg",
    containerTypeIconButtonStyles: "_18u01wug _4t3i7vkz _1bsb7vkz"
};
const $5ec6aabf6642fa45$export$e9e0251ab710cd0d = ({ containerType: containerType, title: title, containerIcon: containerIcon, link: link })=>{
    const { description: description, icon: icon, containerTypeText: containerTypeText } = (0, $97V6h.getContainerProperties)(containerType, 'medium');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $jQ0hK.fireEvent)(createAnalyticsEvent, {
            action: 'clicked',
            actionSubject: 'teamConnectionItem',
            actionSubjectId: 'teamProfileCard',
            attributes: {
                container: containerType
            }
        });
    }, [
        containerType,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $44qT7.default), {
        href: link,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            space: "space.100",
            xcss: $5ec6aabf6642fa45$var$styles.containerWrapperStyles,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    as: "img",
                    src: containerIcon,
                    alt: "",
                    testId: "linked-container-icon",
                    xcss: $5ec6aabf6642fa45$var$styles.containerIconStyles
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            maxLines: 1,
                            color: "color.text",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                            space: "space.050",
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    children: description
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    children: containerTypeText
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    backgroundColor: 'color.background.neutral.subtle',
                    xcss: $5ec6aabf6642fa45$var$styles.containerTypeIconButtonStyles,
                    testId: "container-type-icon",
                    children: icon
                })
            ]
        })
    });
};

});

parcelRegister("5qjKn", function(module, exports) {

$parcel$export(module.exports, "TeamContainersSkeleton", () => $a11d6aa249bf694e$export$b4d5d8f3bbe29b5f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
var $gOkqF = parcelRequire("gOkqF");

var $6lA6G = parcelRequire("6lA6G");
const $a11d6aa249bf694e$var$styles = {
    showMoreButtonSkeleton: "_2rko1q77 _1rjc1b66 _1bsbvbgk"
};
const $a11d6aa249bf694e$export$b4d5d8f3bbe29b5f = ({ numberOfContainers: numberOfContainers })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
        space: "space.200",
        testId: "profile-card-team-containers-skeleton",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gOkqF.default), {
                space: "space.100",
                children: [
                    ...Array(numberOfContainers)
                ].map((_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6lA6G.LinkedContainerCardSkeleton), {}, index))
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                backgroundColor: "color.background.neutral",
                xcss: $a11d6aa249bf694e$var$styles.showMoreButtonSkeleton
            })
        ]
    });
};

});
parcelRegister("6lA6G", function(module, exports) {

$parcel$export(module.exports, "LinkedContainerCardSkeleton", () => $173f2adb870df90a$export$b7a75d9378054329);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");
const $173f2adb870df90a$var$styles = {
    containerWrapperSkeleton: "_2rkoiti9 _1h6dz9xs _12y3e4h9 _12jimuej _1qu2nqa1 _syaz1fxt _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    containerIconSkeleton: "_2rkoiti9 _4t3i1tcg _1bsb1tcg _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    firstLineSkeleton: "_2rko1q77 _1rjc1b66",
    secondLineSkeleton: "_2rko1q77 _1rjc1b66 _1bsbqkoa",
    containerTypeIconSkeleton: "_2rkoiti9 _4t3i7vkz _1bsb7vkz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc"
};
const $173f2adb870df90a$export$b7a75d9378054329 = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
        space: "space.100",
        xcss: $173f2adb870df90a$var$styles.containerWrapperSkeleton,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $173f2adb870df90a$var$styles.containerIconSkeleton,
                backgroundColor: "color.background.neutral"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                grow: "fill",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        xcss: $173f2adb870df90a$var$styles.firstLineSkeleton,
                        backgroundColor: "color.background.neutral"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        xcss: $173f2adb870df90a$var$styles.secondLineSkeleton,
                        backgroundColor: "color.background.neutral"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $173f2adb870df90a$var$styles.containerTypeIconSkeleton,
                backgroundColor: "color.background.neutral"
            })
        ]
    });
};

});



parcelRegister("l9fp3", function(module, exports) {

$parcel$export(module.exports, "default", () => $75e045628bfbaf63$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3TR0I = parcelRequire("3TR0I");

var $lEwUf = parcelRequire("lEwUf");
var $g9EwJ = parcelRequire("g9EwJ");

var $EHfmh = parcelRequire("EHfmh");

var $2ZCVH = parcelRequire("2ZCVH");

var $jQ0hK = parcelRequire("jQ0hK");

var $gp7t8 = parcelRequire("gp7t8");

var $fW87Q = parcelRequire("fW87Q");

var $ee06t = parcelRequire("ee06t");
class $75e045628bfbaf63$var$ProfileCardResourced extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.defaultProps = {
            actions: []
        };
    }
    componentDidMount() {
        this._isMounted = true;
        this.clientFetchProfile();
    }
    componentDidUpdate(prevProps) {
        const { userId: userId, cloudId: cloudId, resourceClient: resourceClient } = this.props;
        if (userId !== prevProps.userId || cloudId !== prevProps.cloudId || resourceClient !== prevProps.resourceClient) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    handleClientSuccess(profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: profileData,
            reportingLinesData: reportingLinesData,
            isKudosEnabled: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    render() {
        const { isLoading: isLoading, hasError: hasError, error: error, data: data, reportingLinesData: reportingLinesData, isKudosEnabled: isKudosEnabled, teamCentralBaseUrl: teamCentralBaseUrl } = this.state;
        const { onReportingLinesClick: onReportingLinesClick, cloudId: cloudId, userId: userId, addFlag: addFlag } = this.props;
        const isFetchingOrNotStartToFetchYet = isLoading === true || isLoading === undefined;
        if (isFetchingOrNotStartToFetchYet) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.CardWrapper), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ee06t.default), {
                fireAnalytics: this.fireAnalytics
            })
        });
        else if (hasError) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.CardWrapper), {
            testId: "profile-card-resourced-error-state",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gp7t8.default), {
                errorType: error,
                reload: this.clientFetchProfile,
                fireAnalytics: this.fireAnalytics
            })
        });
        const newProps = {
            hasError: hasError,
            errorType: error,
            clientFetchProfile: this.clientFetchProfile,
            reportingLines: reportingLinesData,
            onReportingLinesClick: onReportingLinesClick,
            cloudId: cloudId,
            userId: userId,
            addFlag: addFlag,
            ...data,
            isKudosEnabled: isKudosEnabled,
            teamCentralBaseUrl: teamCentralBaseUrl,
            openKudosDrawer: this.openKudosDrawer
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.CardWrapper), {
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    isKudosEnabled && newProps.teamCentralBaseUrl && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                        fallback: null,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lEwUf.GiveKudosLauncherLazy), {
                            isOpen: this.state.kudosDrawerOpen,
                            recipient: {
                                type: (0, $g9EwJ.KudosType).INDIVIDUAL,
                                recipientId: this.props.userId
                            },
                            analyticsSource: "profile-card",
                            teamCentralBaseUrl: newProps.teamCentralBaseUrl,
                            cloudId: this.props.cloudId,
                            addFlag: this.props.addFlag,
                            onClose: this.closeKudosDrawer
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fW87Q.default), {
                        ...newProps,
                        actions: this.filterActions()
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this._isMounted = false, this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            reportingLinesData: undefined,
            isKudosEnabled: false,
            kudosDrawerOpen: false,
            teamCentralBaseUrl: undefined
        }, this.fireAnalytics = (payload)=>{
            // Don't fire analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $jQ0hK.fireEvent)(this.props.createAnalyticsEvent, payload);
        }, this.clientFetchProfile = ()=>{
            const { cloudId: cloudId, userId: userId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                hasError: false,
                data: null
            }, ()=>{
                const requests = Promise.all([
                    this.props.resourceClient.getProfile(cloudId, userId, this.fireAnalytics),
                    this.props.resourceClient.getReportingLines(userId),
                    this.props.resourceClient.shouldShowGiveKudos(),
                    this.props.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        }, this.filterActions = ()=>(0, $EHfmh.default)(this.props.actions, this.state.data), this.openKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: true
            });
        }, this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        };
    }
}
const $75e045628bfbaf63$export$a6d9ff68ecba3be5 = $75e045628bfbaf63$var$ProfileCardResourced;
var $75e045628bfbaf63$export$2e2bcd8739ae039 = (0, $3TR0I.default)()($75e045628bfbaf63$var$ProfileCardResourced);

});
parcelRegister("lEwUf", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $ed488193f6568e2f$export$93fe397a02fe8b76);

var $5uXOq = parcelRequire("5uXOq");

const $ed488193f6568e2f$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("f3bwH")));

});
parcelRegister("f3bwH", function(module, exports) {

let $af5013bc783b21ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $af5013bc783b21ca$var$load("cM9em"),
    $af5013bc783b21ca$var$load("fr9NE"),
    $af5013bc783b21ca$var$load("h2MrD"),
    $af5013bc783b21ca$var$load("bYT2S"),
    $af5013bc783b21ca$var$load("joDi7")
]).then(()=>parcelRequire('63Sms'));

});


parcelRegister("g9EwJ", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $130aaec98a22129d$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $130aaec98a22129d$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $130aaec98a22129d$export$7a1fc1a1b0477464);
var $130aaec98a22129d$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    return KudosType;
}({});
var $130aaec98a22129d$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $130aaec98a22129d$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($130aaec98a22129d$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("EHfmh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d9c38e0f7cf9132$export$2e2bcd8739ae039);
const $4d9c38e0f7cf9132$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $4d9c38e0f7cf9132$export$2e2bcd8739ae039 = $4d9c38e0f7cf9132$var$filterActions;

});

parcelRegister("2ZCVH", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $673c704994fbb1c9$export$6aa22a823032b784);
$parcel$export(module.exports, "ProfileImage", () => $673c704994fbb1c9$export$a7a74ab5cffd1455);
$parcel$export(module.exports, "ActionsFlexSpacer", () => $673c704994fbb1c9$export$d395c8d16f1e359d);
$parcel$export(module.exports, "KudosBlobAnimation", () => $673c704994fbb1c9$export$4a8a956251d4bf6f);
$parcel$export(module.exports, "AnimationWrapper", () => $673c704994fbb1c9$export$58517bb1b373a54c);
$parcel$export(module.exports, "AnimatedKudosButton", () => $673c704994fbb1c9$export$6196a3f52a6944fe);
$parcel$export(module.exports, "ActionButtonGroup", () => $673c704994fbb1c9$export$73d695ae27330056);
$parcel$export(module.exports, "OverflowActionButtonsWrapper", () => $673c704994fbb1c9$export$ff778e5b796745a6);
$parcel$export(module.exports, "CardContent", () => $673c704994fbb1c9$export$64ef9b8c11710c47);
$parcel$export(module.exports, "DetailsGroup", () => $673c704994fbb1c9$export$35cf684daac137ac);
$parcel$export(module.exports, "DisabledInfo", () => $673c704994fbb1c9$export$2062e7265a95a823);
$parcel$export(module.exports, "LozengeWrapper", () => $673c704994fbb1c9$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "CustomLozengeContainer", () => $673c704994fbb1c9$export$6ebf103500ba5a45);
$parcel$export(module.exports, "JobTitleLabel", () => $673c704994fbb1c9$export$d6c0e5f211c8d617);
$parcel$export(module.exports, "AppTitleLabel", () => $673c704994fbb1c9$export$4865ffa72a4d5f9);
$parcel$export(module.exports, "SpinnerContainer", () => $673c704994fbb1c9$export$a5e06607a5ac6158);
$parcel$export(module.exports, "CardContainer", () => $673c704994fbb1c9$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "DetailsLabel", () => $673c704994fbb1c9$export$138a08882ebf7289);
$parcel$export(module.exports, "DetailsLabelIcon", () => $673c704994fbb1c9$export$79d7d9b2f6a70c70);
$parcel$export(module.exports, "DetailsLabelText", () => $673c704994fbb1c9$export$b0ec2c767a0e0eab);
/* Card.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6tzHJ = parcelRequire("6tzHJ");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $k9nuy = parcelRequire("k9nuy");


var $b4a3S = parcelRequire("b4a3S");

var $efqyt = parcelRequire("efqyt");

var $bWGt6 = parcelRequire("bWGt6");
function $673c704994fbb1c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $673c704994fbb1c9$var$kudosButtonAnimationTransformationCompiled = null;
const $673c704994fbb1c9$var$styles = {
    cardWrapper: "_2rkoglpi _1bsb1gwv",
    profileImage: "_kqswstnw _154i1ejb _1ltv1ejb",
    actionsFlexSpacer: "_16jlkb7n _1o9zidpf _i0dl1wug",
    kudosBlobAnimationStyle: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _154ixy5q",
    animationWrapper: "_mkrz1rip _kqswstnw _154ize3t _1ltvze3t _94n5ze3t _1xi2ze3t",
    animatedKudosButton: "_18u0u2gc",
    actionButtonGroup: "_zulp12x7 _uiztglyw _19pkpxbi _2hwxze3t _18u0ze3t _otyrze3t _y3gnusic _1bahesu3 _1e0c1txw",
    overflowActionButtonsWrapper: "_1e0c1o8l _1bsbzwfg _4t3izwfg",
    cardContent: "_1e0c1txw _2lx21bp4 _1tkebv7e",
    detailsGroup: "_1e0c1txw _2lx21bp4 _18u01epz _19bvxy5q _1bsb18pt",
    disabledInfo: "_11c81o8v _syaz1fxt _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t",
    lozengeWrapper: "_19pkpxbi _1e0c1ule",
    customLozengeContainer: "_1e0c1txw _2lx2vrvc _1n261g80 _1bah1y6m _19pkutpp",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm",
    cardContainer: "_1reo15vq _18m915vq _kqswh2mm _12vemgnk _1lrw14bs _ca0q1ejb _19bv1ejb _u5f31ejb _n3td1ejb",
    cardContainerActiveUser: "_1itk1419",
    cardContainerDisabledUser: "_1itkkf3t",
    cardContainerWithElevation: "_2rkoglpi _16qs1cd0",
    detailsLabel: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1y6m _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t _o5721q9c",
    detailsLabelExtraTopSpace: "_19pkxy5q",
    detailsLabelIcon: "_1e0c1txw _1o9zidpf _syaz131l _1bsb7vkz _4t3i7vkz _s7n4jp4b _19pkze3t",
    detailsLabelText: "_1reo15vq _18m915vq _11c8dcr7 _1bto1l2s _syaz1fxt _19pkze3t _18u0ze3t",
    kudosBlobAnimation: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _j7hq1q51 _tip8kb7n _5sagi11n _1itkiwwe",
    jobTitleLabel: "_19pkze3t _otyrze3t _18u0utpp _2hwxze3t",
    appTitleLabel: "_2rkoglpi _syaz1fxt _u5f312x7 _19bv12x7 _1bsb1ns9 _19pk1b66 _otyrze3t _18u0utpp _2hwxze3t"
};
const $673c704994fbb1c9$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$CardWrapperLegacy, {
        "data-testid": testId,
        role: role,
        "aria-labelledby": labelledBy,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$CardWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo19"
})("background-color:", (0, $efqyt.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:360px;");
const $673c704994fbb1c9$export$a7a74ab5cffd1455 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.profileImage),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$ProfileImageLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$ProfileImageLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo18"
})({
    name: "eukccz",
    styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px)"
});
const $673c704994fbb1c9$export$d395c8d16f1e359d = ()=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.actionsFlexSpacer)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$ActionsFlexSpacerLegacy, {}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$ActionsFlexSpacerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo17"
})({
    name: "18pny36",
    styles: "flex:1 0 auto"
}); // eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation
const $673c704994fbb1c9$var$kudosButtonAnimationTransformation = (0, $f8Sb3.keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
const $673c704994fbb1c9$export$b08abf2f97b92ea5 = ()=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.kudosBlobAnimationStyle)
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$KudosBlobAnimationStyleLegacy, {
        className: "kudos-blob-animation"
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $673c704994fbb1c9$var$KudosBlobAnimationStyleLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo16"
})("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", 32 / 14, "em;animation-name:", $673c704994fbb1c9$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient(\n\t\tcircle,\n\t\tvar(--ds-background-information-pressed, #85B8FF) 0%,\n\t\tvar(--ds-background-discovery-pressed, #B8ACF6) 25%,\n\t\ttransparent 50%\n\t);overflow:hidden;");
const $673c704994fbb1c9$export$4a8a956251d4bf6f = ()=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.kudosBlobAnimationStyle)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$KudosBlobAnimationLegacy, {});
const $673c704994fbb1c9$var$KudosBlobAnimationLegacy = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$export$b08abf2f97b92ea5, {});
const $673c704994fbb1c9$export$58517bb1b373a54c = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.animationWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$AnimationWrapperLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$AnimationWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo15"
})("clip-path:inset(0px 0px 0px 0px round ", (0, $b4a3S.borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
const $673c704994fbb1c9$export$6196a3f52a6944fe = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.animatedKudosButton),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$AnimatedKudosButtonLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$AnimatedKudosButtonLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo14"
})({
    name: "18xp5qc",
    styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
});
const $673c704994fbb1c9$export$73d695ae27330056 = ({ children: children, testId: testId })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        testId: testId,
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.actionButtonGroup),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$ActionButtonGroupLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$ActionButtonGroupLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo13"
})("user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $673c704994fbb1c9$export$ff778e5b796745a6 = ({ children: children, testId: testId })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        testId: testId,
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.overflowActionButtonsWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$OverflowActionButtonsWrapperLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$OverflowActionButtonsWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo12"
})("display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $673c704994fbb1c9$export$64ef9b8c11710c47 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.cardContent),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$CardContentLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$CardContentLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo11"
})({
    name: "1jc6z0y",
    styles: "display:flex;flex-direction:column;min-height:136px"
});
const $673c704994fbb1c9$export$35cf684daac137ac = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.detailsGroup),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$DetailsGroupLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$DetailsGroupLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo10"
})({
    name: "c8pdei",
    styles: "display:flex;flex-direction:column;margin-left:116px;width:196px"
});
const $673c704994fbb1c9$export$2062e7265a95a823 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.disabledInfo),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$DisabledInfoLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$DisabledInfoLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo9"
})("font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:", (0, $efqyt.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
const $673c704994fbb1c9$export$75180efdd3f4d9c2 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.lozengeWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$LozengeWrapperLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$LozengeWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo8"
})({
    name: "m760b1",
    styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block"
});
const $673c704994fbb1c9$export$6ebf103500ba5a45 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.customLozengeContainer),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$CustomLozengeContainerLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$CustomLozengeContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)($673c704994fbb1c9$export$75180efdd3f4d9c2, {
    target: "e1ebb2vo7"
})({
    name: "15oqcei",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);>*{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
});
const $673c704994fbb1c9$export$d6c0e5f211c8d617 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.jobTitleLabel),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
            maxLines: 1,
            color: "color.text.inverse",
            children: children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$JobTitleLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$JobTitleLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1ebb2vo6"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:", (0, $efqyt.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;");
const $673c704994fbb1c9$export$4865ffa72a4d5f9 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.appTitleLabel),
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
            color: "color.text",
            size: "UNSAFE_small",
            weight: "bold",
            children: children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$AppTitleLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$AppTitleLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1ebb2vo5"
})("background:", (0, $efqyt.appLabelBgColor), ";color:", (0, $efqyt.appLabelTextColor), ";border-radius:", (0, $b4a3S.borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:var(--ds-font-weight-bold, 700);text-transform:uppercase;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;");
const $673c704994fbb1c9$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        testId: testId,
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.spinnerContainer),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$SpinnerContainerLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$SpinnerContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo4"
})({
    name: "1e8m6rx",
    styles: "align-items:center;display:flex;height:96px;justify-content:center;position:relative"
});
const $673c704994fbb1c9$export$8a23e74e5cf3ca41 = ({ children: children, isDisabledUser: isDisabledUser, withoutElevation: withoutElevation })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.cardContainer, isDisabledUser ? $673c704994fbb1c9$var$styles.cardContainerDisabledUser : $673c704994fbb1c9$var$styles.cardContainerActiveUser, !withoutElevation && $673c704994fbb1c9$var$styles.cardContainerWithElevation),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$CardContainerLegacy, {
        isDisabledUser: isDisabledUser,
        withoutElevation: withoutElevation,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$CardContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo3"
})("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient(\n\t\tto bottom,\n\t\t", (props)=>props.isDisabledUser ? (0, $efqyt.headerBgColorDisabledUser) : (0, $efqyt.headerBgColor), "\n\t\t\t0%,\n\t\t", (props)=>props.isDisabledUser ? (0, $efqyt.headerBgColorDisabledUser) : (0, $efqyt.headerBgColor), " 100%\n\t);background-repeat:no-repeat;background-size:100% 96px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $a7f8c6b391092279$export$7d3359664e8bb0e5}, 0 0 1px ${0, $a7f8c6b391092279$export$d2d3bedfb276cac0}`})`}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, $b4a3S.borderRadius)()}px`, ";overflow:hidden;");
const $673c704994fbb1c9$export$138a08882ebf7289 = ({ children: children, extraTopSpace: extraTopSpace = false })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.detailsLabel, extraTopSpace && $673c704994fbb1c9$var$styles.detailsLabelExtraTopSpace),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$DetailsLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$DetailsLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo2"
})({
    name: "vjwven",
    styles: "display:flex;align-items:center;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;&+&{margin-top:var(--ds-space-025, 2px);}"
});
const $673c704994fbb1c9$export$79d7d9b2f6a70c70 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "dt",
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.detailsLabelIcon),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$DetailsLabelIconLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$DetailsLabelIconLegacy = /*#__PURE__*/ (0, $bWGt6.default)("dt", {
    target: "e1ebb2vo1"
})("display:flex;flex-shrink:0;color:", (0, $efqyt.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
const $673c704994fbb1c9$export$b0ec2c767a0e0eab = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "dd",
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.detailsLabelText),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$DetailsLabelTextLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$DetailsLabelTextLegacy = /*#__PURE__*/ (0, $bWGt6.default)("dd", {
    target: "e1ebb2vo0"
})("overflow:hidden;text-overflow:ellipsis;color:", (0, $efqyt.labelTextColor), ";font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-050, 4px);padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");

});
parcelRegister("efqyt", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $604493a31ede6ab5$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $604493a31ede6ab5$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $604493a31ede6ab5$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $604493a31ede6ab5$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $604493a31ede6ab5$export$5c2df128da90e8de);
$parcel$export(module.exports, "appLabelBgColor", () => $604493a31ede6ab5$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $604493a31ede6ab5$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $604493a31ede6ab5$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $604493a31ede6ab5$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $604493a31ede6ab5$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $604493a31ede6ab5$export$be3c814f7ed506ed);

const $604493a31ede6ab5$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`;
const $604493a31ede6ab5$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $a7f8c6b391092279$export$a6ee3d71bc067634)})`;
const $604493a31ede6ab5$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$8754fc7e6d8b3000)})`;
const $604493a31ede6ab5$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $a7f8c6b391092279$export$3e51e8f1440314ba)})`;
const $604493a31ede6ab5$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`;
const $604493a31ede6ab5$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`;
const $604493a31ede6ab5$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`;
const $604493a31ede6ab5$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`;
const $604493a31ede6ab5$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`;
const $604493a31ede6ab5$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$c2e91cbeada39b8b)})`;
const $604493a31ede6ab5$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $a7f8c6b391092279$export$7c87d337fb91a97d)})`;
const $604493a31ede6ab5$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`;
const $604493a31ede6ab5$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$7c87d337fb91a97d)})`;

});


parcelRegister("gp7t8", function(module, exports) {

$parcel$export(module.exports, "default", () => $75dd9aaf56c3a018$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $bMFGq = parcelRequire("bMFGq");

var $hvAON = parcelRequire("hvAON");

var $4y6Pt = parcelRequire("4y6Pt");

var $fHpHg = parcelRequire("fHpHg");

var $6eFvr = parcelRequire("6eFvr");

var $97aaW = parcelRequire("97aaW");

var $jQ0hK = parcelRequire("jQ0hK");
const $75dd9aaf56c3a018$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $jQ0hK.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $97aaW.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $97aaW.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6eFvr.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $97aaW.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hvAON))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4y6Pt))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && ((0, $fHpHg.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
                onClick: reload,
                children: "Try again"
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                appearance: "link",
                onClick: reload,
                children: "Try again"
            }))
        ]
    });
};
var $75dd9aaf56c3a018$export$2e2bcd8739ae039 = $75dd9aaf56c3a018$var$ErrorMessage;

});
parcelRegister("97aaW", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $3e3fde7d702d1762$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $3e3fde7d702d1762$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $3e3fde7d702d1762$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");


var $efqyt = parcelRequire("efqyt");

var $bWGt6 = parcelRequire("bWGt6");
const $3e3fde7d702d1762$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $3e3fde7d702d1762$export$bb27b7e39840238f = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($3e3fde7d702d1762$var$styles.errorWrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($3e3fde7d702d1762$var$ErrorWrapperLegacy, {
        "data-testId": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e3fde7d702d1762$var$ErrorWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1gaqn292"
})({
    textAlign: 'center',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $efqyt.errorIconColor)
});
const $3e3fde7d702d1762$export$b065fd053267ec81 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($3e3fde7d702d1762$var$styles.errorTitle),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($3e3fde7d702d1762$var$ErrorTitleLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e3fde7d702d1762$var$ErrorTitleLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn291"
})({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $efqyt.errorTitleColor),
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $3e3fde7d702d1762$export$90d92ccfb27352c6 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($3e3fde7d702d1762$var$styles.teamErrorText),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($3e3fde7d702d1762$var$TeamErrorTextLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e3fde7d702d1762$var$TeamErrorTextLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn290"
})({
    color: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-100, 8px)"
});

});


parcelRegister("fW87Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ProfilecardInternal", () => $a49a041d2d306c27$export$64e0275ede8ab792);
$parcel$export(module.exports, "default", () => $a49a041d2d306c27$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $3TR0I = parcelRequire("3TR0I");

var $ew55A = parcelRequire("ew55A");

var $cNW3X = parcelRequire("cNW3X");

var $liZ21 = parcelRequire("liZ21");

var $6fV04 = parcelRequire("6fV04");

var $fHpHg = parcelRequire("fHpHg");

var $clxo5 = parcelRequire("clxo5");


var $3DrJx = parcelRequire("3DrJx");

var $2ZCVH = parcelRequire("2ZCVH");

var $jQ0hK = parcelRequire("jQ0hK");

var $g4Mqd = parcelRequire("g4Mqd");

var $1P8ZX = parcelRequire("1P8ZX");

var $gp7t8 = parcelRequire("gp7t8");

var $bqYcw = parcelRequire("bqYcw");

var $1VV7q = parcelRequire("1VV7q");
const $a49a041d2d306c27$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
const $a49a041d2d306c27$var$useKudos = (cloudId, userId, teamCentralBaseUrl, openKudosDrawer)=>{
    const kudosUrl = (0, $5uXOq.useMemo)(()=>{
        const recipientId = userId ? `&recipientId=${userId}` : '';
        const cloudIdParam = cloudId ? `&cloudId=${cloudId}` : '';
        return `${teamCentralBaseUrl || ''}/kudos/give?type=individual${recipientId}${cloudIdParam}`;
    }, [
        cloudId,
        teamCentralBaseUrl,
        userId
    ]);
    const kudosButtonCallback = (0, $5uXOq.useCallback)(()=>{
        if (openKudosDrawer) openKudosDrawer();
        else window.open(kudosUrl);
    }, [
        kudosUrl,
        openKudosDrawer
    ]);
    const kudosAction = (0, $5uXOq.useMemo)(()=>{
        return {
            label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $3DrJx.default).giveKudosButton
            }),
            id: $a49a041d2d306c27$var$GIVE_KUDOS_ACTION_ID,
            callback: kudosButtonCallback,
            link: kudosUrl
        };
    }, [
        kudosButtonCallback,
        kudosUrl
    ]);
    return {
        kudosAction: kudosAction,
        kudosButtonCallback: kudosButtonCallback,
        kudosUrl: kudosUrl
    };
};
const $a49a041d2d306c27$var$Wrapper = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.CardWrapper), {
        testId: "profilecard",
        role: "dialog",
        labelledBy: "profilecard-name-label",
        children: props.children
    });
const $a49a041d2d306c27$export$64e0275ede8ab792 = (props)=>{
    const [openTime] = (0, $5uXOq.useState)((0, $1P8ZX.getPageTime)());
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $jQ0hK.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsWithDuration = (0, $5uXOq.useCallback)((generator)=>{
        const elapsed = (0, $1P8ZX.getPageTime)() - openTime;
        const event = generator(elapsed);
        fireAnalytics(event);
    }, [
        fireAnalytics,
        openTime
    ]);
    const { kudosAction: kudosAction } = $a49a041d2d306c27$var$useKudos(props.cloudId, props.userId, props.teamCentralBaseUrl, props.openKudosDrawer);
    const { actions: actions = [], isCurrentUser: isCurrentUser, isKudosEnabled: isKudosEnabled, status: status = 'active' } = props;
    const realActions = (0, $5uXOq.useMemo)(()=>{
        if (isCurrentUser || !isKudosEnabled || status !== 'active') return actions;
        return actions.concat([
            kudosAction
        ]);
    }, [
        actions,
        isCurrentUser,
        isKudosEnabled,
        kudosAction,
        status
    ]);
    const { isLoading: isLoading, fullName: fullName, hasError: hasError } = props;
    const canRender = !hasError && !isLoading && !!(fullName || status === 'closed');
    (0, $5uXOq.useEffect)(()=>{
        if (canRender) fireAnalyticsWithDuration((duration)=>(0, $jQ0hK.profileCardRendered)('user', 'content', {
                duration: duration,
                numActions: realActions.length
            }));
    }, [
        canRender,
        fireAnalyticsWithDuration,
        realActions
    ]);
    if (hasError) return /*#__PURE__*/ (0, $2OMIu.jsx)($a49a041d2d306c27$var$Wrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gp7t8.default), {
            reload: props.clientFetchProfile,
            errorType: props.errorType || null,
            fireAnalytics: fireAnalytics
        })
    });
    if (isLoading) return /*#__PURE__*/ (0, $2OMIu.jsx)($a49a041d2d306c27$var$Wrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($a49a041d2d306c27$var$LoadingView, {
            fireAnalyticsWithDuration: fireAnalyticsWithDuration
        })
    });
    if (!canRender) return null;
    const isDisabledUser = status === 'inactive' || status === 'closed';
    return /*#__PURE__*/ (0, $2OMIu.jsx)($a49a041d2d306c27$var$Wrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2ZCVH.CardContainer), {
            isDisabledUser: isDisabledUser,
            withoutElevation: props.withoutElevation,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.ProfileImage), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ew55A.default), {
                        size: "xlarge",
                        src: status !== 'closed' ? props.avatarUrl : undefined,
                        borderColor: `var(--ds-shadow-overlay, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2ZCVH.CardContent), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1VV7q.ProfileCardDetails), {
                            ...props,
                            status: status,
                            fireAnalyticsWithDuration: fireAnalyticsWithDuration
                        }),
                        realActions && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.ActionsFlexSpacer), {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)($a49a041d2d306c27$var$Actions, {
                                    actions: realActions,
                                    fireAnalyticsWithDuration: fireAnalyticsWithDuration,
                                    isTriggeredUsingKeyboard: props.isTriggeredUsingKeyboard
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $a49a041d2d306c27$var$Actions = ({ actions: actions, fireAnalyticsWithDuration: fireAnalyticsWithDuration, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard })=>{
    const onActionClick = (0, $5uXOq.useCallback)((action, args, event, index)=>{
        fireAnalyticsWithDuration((duration)=>(0, $jQ0hK.actionClicked)('user', {
                duration: duration,
                hasHref: !!action.link,
                hasOnClick: !!action.callback,
                index: index,
                actionId: action.id || 'no-id-specified'
            }));
        if (action.callback && (0, $g4Mqd.isBasicClick)(event)) {
            event.preventDefault();
            action.callback(event, ...args);
        }
    }, [
        fireAnalyticsWithDuration
    ]);
    if (!actions || actions.length === 0) return null;
    const regularActions = actions.slice(0, (0, $bqYcw.ACTION_OVERFLOW_THRESHOLD));
    const overflowActions = actions.length > (0, $bqYcw.ACTION_OVERFLOW_THRESHOLD) ? actions.slice((0, $bqYcw.ACTION_OVERFLOW_THRESHOLD)) : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2ZCVH.ActionButtonGroup), {
        testId: "profilecard-actions",
        children: [
            regularActions.map((action, index)=>{
                const isKudos = action.id === $a49a041d2d306c27$var$GIVE_KUDOS_ACTION_ID;
                const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6fV04.default), {
                    isInset: true,
                    children: (0, $fHpHg.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $liZ21.default), {
                        appearance: "default",
                        onClick: (event, ...args)=>onActionClick(action, args, event, index),
                        href: action.link || '',
                        autoFocus: index === 0 && isTriggeredUsingKeyboard,
                        id: `action-button-${action.id}`,
                        "aria-labelledby": (0, $fHpHg.fg)('enable_userprofilecard_arialabelfix') ? `action-button-${action.id} profilecard-name-label` : '',
                        children: [
                            action.label,
                            isKudos && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.AnimationWrapper), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.KudosBlobAnimation), {})
                            })
                        ]
                    }, action.id || index) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cNW3X.default), {
                        appearance: "default",
                        onClick: (event, ...args)=>onActionClick(action, args, event, index),
                        href: action.link,
                        autoFocus: index === 0 && isTriggeredUsingKeyboard,
                        children: [
                            action.label,
                            isKudos && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.AnimationWrapper), {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.KudosBlobAnimation), {})
                            })
                        ]
                    }, action.id || index)
                }, `profile-card-action-focus-ring_${action.id || index}`);
                if (isKudos) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.AnimatedKudosButton), {
                    children: button
                }, `profile-card-action-kudos_${action.id || index}`);
                return button;
            }),
            overflowActions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bqYcw.OverflowProfileCardButtons), {
                actions: overflowActions,
                fireAnalyticsWithDuration: fireAnalyticsWithDuration,
                onItemClick: (action, args, event, index)=>onActionClick(action, args, event, index + (0, $bqYcw.ACTION_OVERFLOW_THRESHOLD))
            })
        ]
    });
};
const $a49a041d2d306c27$var$LoadingView = ({ fireAnalyticsWithDuration: fireAnalyticsWithDuration })=>{
    (0, $5uXOq.useEffect)(()=>{
        fireAnalyticsWithDuration((duration)=>(0, $jQ0hK.profileCardRendered)('user', 'spinner', {
                duration: duration
            }));
    }, [
        fireAnalyticsWithDuration
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.SpinnerContainer), {
        testId: "profilecard-spinner-container",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {})
    });
};
var $a49a041d2d306c27$export$2e2bcd8739ae039 = (0, $3TR0I.default)()($a49a041d2d306c27$export$64e0275ede8ab792);

});
parcelRegister("3DrJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a440b6b1eac1ef2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $8a440b6b1eac1ef2$var$messages = (0, $7VHMR.defineMessages)({
    inactiveAccountMsg: {
        id: 'pt.profile-card.inactive.account',
        defaultMessage: 'Account deactivated',
        description: 'A text in a grey lozenge shows that this user is inactive'
    },
    generalDescMsgForDisabledUser: {
        id: 'pt.profile-card.general.msg.disabled.user',
        defaultMessage: 'You can no longer collaborate with this person.',
        description: 'A first sentence of a long text explains this user is inactive/closed'
    },
    inactiveAccountDescMsgNoDate: {
        id: 'pt.profile-card.inactive.account.no.date',
        defaultMessage: 'Their account has been deactivated.',
        description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.inactive.account.has.date.this.week',
        defaultMessage: 'Their account was deactivated this week.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.inactive.account.has.date.this.month',
        defaultMessage: 'Their account was deactivated this month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.inactive.account.has.date.last.month',
        defaultMessage: 'Their account was deactivated last month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.inactive.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deactivated for a few months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.inactive.account.has.date.several.months',
        defaultMessage: 'Their account has been deactivated for several months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deactivated for more than a year.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    closedAccountMsg: {
        id: 'pt.profile-card.closed.account',
        defaultMessage: 'Account deleted',
        description: 'A text in a grey lozenge shows that this user is closed/deleted'
    },
    closedAccountDescMsgNoDate: {
        id: 'pt.profile-card.closed.account.no.date',
        defaultMessage: 'Their account has been deleted.',
        description: 'A long text explains this user is closed when we do not know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.closed.account.has.date.this.week',
        defaultMessage: 'Their account was deleted this week.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.closed.account.has.date.this.month',
        defaultMessage: 'Their account was deleted this month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.closed.account.has.date.last.month',
        defaultMessage: 'Their account was deleted last month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.closed.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deleted for a few months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.closed.account.has.date.several.months',
        defaultMessage: 'Their account has been deleted for several months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deleted for more than a year.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    disabledAccountDefaultName: {
        id: 'pt.profile-card.disabled.account.default.name',
        defaultMessage: 'Former user',
        description: 'A default name when we cannot get name of an inactive or closed user'
    },
    teamViewProfile: {
        id: 'pt.team-profile-card.team.action.view-profile',
        defaultMessage: 'View profile',
        description: "Button that takes you to view this team\u2019s profile"
    },
    memberCount: {
        id: 'pt.team-profile-card.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team'
    },
    memberCountIncludingYou: {
        id: 'pt.team-profile-card.team.member.count-including-you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team and highlight that the user is a member'
    },
    membersMoreThan50: {
        id: 'pt.team-profile-card.team.member.many',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the team has more than 50 members'
    },
    membersMoreThan50IncludingYou: {
        id: 'pt.team-profile-card.team.member.many-including-you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the team has more than 50 members and highlight that the user is a member'
    },
    teamErrorTitle: {
        id: 'pt.team-profile-card.error.title',
        defaultMessage: "We\u2019re having trouble retrieving this teams information",
        description: 'Title for an error view explaining that data for this team cannot be accessed'
    },
    teamErrorText: {
        id: 'pt.team-profile-card.error.suggestion',
        defaultMessage: 'Wait a few moments, then try again.',
        description: 'Second line suggesting how to fix the issue'
    },
    teamErrorButton: {
        id: 'pt.team-profile-card.error.refresh-button',
        defaultMessage: 'Try again',
        description: 'Text on a button that will try to get the data again when clicked'
    },
    teamForbiddenErrorStateTitle: {
        id: 'pt.team-profile-card.forbidden-error-state.title',
        defaultMessage: "We can\u2019t show you this team",
        description: 'Title for the error state that is displayed when a user lacks access to the team'
    },
    teamForbiddenErrorStateDescription: {
        id: 'pt.team-profile-card.forbidden-error-state.description',
        defaultMessage: "You don\u2019t have access to view this team.",
        description: 'Description for the error state that is displayed when a user lacks access to the team'
    },
    managerSectionHeading: {
        id: 'pt.team-profile-card.manager.heading',
        defaultMessage: 'Manager',
        description: "Title for a section on the profile card that show the user's direct manager"
    },
    directReportsSectionHeading: {
        id: 'pt.team-profile-card.directReports.heading',
        defaultMessage: 'Direct reports',
        description: "Title for a section on the profile card that show the user's direct reports"
    },
    teamProfileCardAriaLabel: {
        id: 'pt.team-profile-card.aria-label',
        defaultMessage: 'More information about this team',
        description: 'Aria label for the team profile card'
    },
    giveKudosButton: {
        id: 'pt.profile-card.give-kudos',
        defaultMessage: 'Give kudos',
        description: 'Title for the button on the profile card for a user to give a kudos'
    },
    profileCardMoreIconLabel: {
        id: 'pt.profile-card.more-icon-label',
        defaultMessage: 'More',
        description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
    },
    profileCardMoreReportingLinesLabel: {
        id: 'pt.user-profile-card.reporting-lines.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {profile} other {profiles}}',
        description: 'Label for the "more profiles" indicator in the reporting lines section of the user profile card'
    },
    profileCardMoreMembersLabel: {
        id: 'pt.team.profile-card.members.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {members} other {members}}',
        description: 'Label for the "more members" indicator in the members section of the team profile card'
    }
});
var $8a440b6b1eac1ef2$export$2e2bcd8739ae039 = $8a440b6b1eac1ef2$var$messages;

});

parcelRegister("g4Mqd", function(module, exports) {

$parcel$export(module.exports, "isBasicClick", () => $e3093b8b25a4e7a8$export$eddcd8a5b7e09991);
const $e3093b8b25a4e7a8$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

});

parcelRegister("bqYcw", function(module, exports) {

$parcel$export(module.exports, "ACTION_OVERFLOW_THRESHOLD", () => $0cf52e72084eaeca$export$3e2419a7546ad45e);
$parcel$export(module.exports, "OverflowProfileCardButtons", () => $0cf52e72084eaeca$export$9d9b53d23c0df7a1);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $1nSOt = parcelRequire("1nSOt");

var $1Seuh = parcelRequire("1Seuh");

var $j7m8K = parcelRequire("j7m8K");
var $1eETS = parcelRequire("1eETS");
var $3jAdT = parcelRequire("3jAdT");

var $elaEw = parcelRequire("elaEw");

var $fHpHg = parcelRequire("fHpHg");

var $3DrJx = parcelRequire("3DrJx");

var $2ZCVH = parcelRequire("2ZCVH");

var $jQ0hK = parcelRequire("jQ0hK");
const $0cf52e72084eaeca$export$3e2419a7546ad45e = 2;
const $0cf52e72084eaeca$export$9d9b53d23c0df7a1 = (props)=>{
    const intl = (0, $koVbs.default)();
    const [, setOpen] = (0, $5uXOq.useState)(false);
    const { actions: actions, onItemClick: onItemClick, fireAnalyticsWithDuration: fireAnalyticsWithDuration } = props;
    const numActions = actions.length + $0cf52e72084eaeca$export$3e2419a7546ad45e;
    const onOpenChange = (0, $5uXOq.useCallback)(({ isOpen: nextOpen })=>{
        setOpen((prevOpen)=>{
            if (nextOpen && !prevOpen) fireAnalyticsWithDuration((duration)=>(0, $jQ0hK.moreActionsClicked)('user', {
                    duration: duration,
                    numActions: numActions
                }));
            return nextOpen;
        });
    }, [
        numActions,
        fireAnalyticsWithDuration
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.OverflowActionButtonsWrapper), {
        testId: "profilecard-actions-overflow",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7m8K.default), {
            onOpenChange: onOpenChange,
            placement: 'bottom-end',
            trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: testId, ...providedProps })=>{
                return (0, $fHpHg.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                    type: "button",
                    ...providedProps,
                    ref: triggerRef,
                    label: intl.formatMessage((0, $3DrJx.default).profileCardMoreIconLabel),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($elaEw)))
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1nSOt.default), {
                    type: "button",
                    ...providedProps,
                    ref: triggerRef,
                    iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($elaEw))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: intl.formatMessage((0, $3DrJx.default).profileCardMoreIconLabel)
                    })
                });
            },
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3jAdT.default), {
                children: actions.map((action, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
                        onClick: (event, ...args)=>{
                            onItemClick(action, args, event, index);
                        },
                        href: action.link,
                        children: action.label
                    }, action.id))
            })
        })
    });
};

});

parcelRegister("1VV7q", function(module, exports) {

$parcel$export(module.exports, "ProfileCardDetails", () => $8b5e837c735b0606$export$c0e6870b898eb99d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $eOat1 = parcelRequire("eOat1");

var $0yZbT = parcelRequire("0yZbT");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $73UMN = parcelRequire("73UMN");

var $3DrJx = parcelRequire("3DrJx");

var $2ZCVH = parcelRequire("2ZCVH");

var $dMnCT = parcelRequire("dMnCT");

var $bMmHv = parcelRequire("bMmHv");
const $8b5e837c735b0606$var$detailedListWrapperStyles = (0, $2s57o.xcss)({
    margin: 'space.0',
    padding: 'space.0'
});
const $8b5e837c735b0606$var$fullNameLabelStyles = (0, $2s57o.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $8b5e837c735b0606$var$noMetaLabelStyles = (0, $2s57o.xcss)({
    marginTop: 'space.400',
    marginRight: '0',
    marginBottom: 'space.150',
    marginLeft: '0'
});
const $8b5e837c735b0606$var$metaLabelStyles = (0, $2s57o.xcss)({
    marginTop: 'space.150',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
});
const $8b5e837c735b0606$var$disabledAccountStyles = (0, $2s57o.xcss)({
    color: 'color.text'
});
const $8b5e837c735b0606$var$activeAccountStyles = (0, $2s57o.xcss)({
    color: 'color.text.inverse'
});
const $8b5e837c735b0606$var$renderName = (nickname, fullName, meta)=>{
    if (!fullName && !nickname) return null;
    const isNicknameRedundant = !nickname || nickname === fullName;
    const shownNickname = ` (${nickname}) `;
    const displayName = isNicknameRedundant ? fullName : `${fullName}${shownNickname}`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        xcss: [
            $8b5e837c735b0606$var$fullNameLabelStyles,
            $8b5e837c735b0606$var$activeAccountStyles,
            meta ? $8b5e837c735b0606$var$metaLabelStyles : $8b5e837c735b0606$var$noMetaLabelStyles
        ],
        testId: "profilecard-name",
        id: "profilecard-name-label",
        children: displayName
    });
};
const $8b5e837c735b0606$var$disabledAccountDesc = (statusModifiedDate, disabledAccountMessage, status = 'closed')=>{
    // consumer does not want to use built-in message
    if (disabledAccountMessage) return disabledAccountMessage;
    const date = statusModifiedDate ? new Date(statusModifiedDate * 1000) : null;
    const relativeDateKey = (0, $73UMN.default)(date);
    const msgKey = relativeDateKey ? `${status}AccountDescMsgHasDate${relativeDateKey}` : `${status}AccountDescMsgNoDate`;
    const secondSentence = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $3DrJx.default)[msgKey]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6eFvr.default), {
        as: "p",
        testId: "profilecard-disabled-account",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $3DrJx.default).generalDescMsgForDisabledUser
            }),
            " ",
            secondSentence
        ]
    });
};
const $8b5e837c735b0606$var$CustomLozenges = ({ lozenges: lozenges = [] })=>{
    if (lozenges.length === 0) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.CustomLozengeContainer), {
        children: lozenges.map(({ text: text, ...otherProps }, index)=>/*#__PURE__*/ (0, $5uXOq.createElement)((0, $eOat1.default), {
                ...otherProps,
                key: index
            }, text))
    });
};
const $8b5e837c735b0606$var$BotProfileCardDetails = (props)=>{
    const { fullName: fullName, nickname: nickname } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2ZCVH.DetailsGroup), {
        children: [
            $8b5e837c735b0606$var$renderName(nickname, fullName),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.AppTitleLabel), {
                children: "APP"
            })
        ]
    });
};
const $8b5e837c735b0606$var$DisabledProfileCardDetails = (props)=>{
    const { companyName: companyName, disabledAccountMessage: disabledAccountMessage, fullName: fullName, hasDisabledAccountLozenge: hasDisabledAccountLozenge = true, nickname: nickname, status: status, statusModifiedDate: statusModifiedDate } = props;
    const name = status === 'inactive' ? fullName || nickname : nickname || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $3DrJx.default).disabledAccountDefaultName
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2ZCVH.DetailsGroup), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                xcss: [
                    $8b5e837c735b0606$var$fullNameLabelStyles,
                    $8b5e837c735b0606$var$noMetaLabelStyles,
                    $8b5e837c735b0606$var$disabledAccountStyles
                ],
                testId: "profilecard-name",
                id: "profilecard-name-label",
                children: name
            }),
            hasDisabledAccountLozenge && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.LozengeWrapper), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eOat1.default), {
                    appearance: "default",
                    isBold: true,
                    children: status === 'inactive' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $3DrJx.default).inactiveAccountMsg
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $3DrJx.default).closedAccountMsg
                    })
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.DisabledInfo), {
                children: $8b5e837c735b0606$var$disabledAccountDesc(statusModifiedDate, disabledAccountMessage, status)
            }),
            status === 'inactive' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dMnCT.default), {
                icon: "companyName",
                children: companyName
            })
        ]
    });
};
const $8b5e837c735b0606$export$c0e6870b898eb99d = (props)=>{
    const { meta: meta, status: status } = props;
    if (props.isBot) return /*#__PURE__*/ (0, $2OMIu.jsx)($8b5e837c735b0606$var$BotProfileCardDetails, {
        ...props
    });
    if (status === 'inactive' || status === 'closed') return /*#__PURE__*/ (0, $2OMIu.jsx)($8b5e837c735b0606$var$DisabledProfileCardDetails, {
        ...props,
        status: status
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2ZCVH.DetailsGroup), {
        children: [
            $8b5e837c735b0606$var$renderName(props.nickname, props.fullName, meta),
            meta && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.JobTitleLabel), {
                children: meta
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($8b5e837c735b0606$var$CustomLozenges, {
                lozenges: props.customLozenges
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $0yZbT.default), {
                as: "dl",
                xcss: $8b5e837c735b0606$var$detailedListWrapperStyles,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dMnCT.default), {
                        icon: "email",
                        extraTopSpace: true,
                        children: props.email
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dMnCT.default), {
                        icon: "time",
                        children: props.timestring
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dMnCT.default), {
                        icon: "companyName",
                        children: props.companyName
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dMnCT.default), {
                        icon: "location",
                        children: props.location
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMmHv.default), {
                reportingLines: props.reportingLines,
                reportingLinesProfileUrl: props.reportingLinesProfileUrl,
                onReportingLinesClick: props.onReportingLinesClick,
                fireAnalyticsWithDuration: props.fireAnalyticsWithDuration
            })
        ]
    });
};

});
parcelRegister("73UMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d6808b8169877f$export$2e2bcd8739ae039);

var $kMWS1 = parcelRequire("kMWS1");

var $f0lG8 = parcelRequire("f0lG8");

var $ki4Ey = parcelRequire("ki4Ey");

var $jovBr = parcelRequire("jovBr");
function $88d6808b8169877f$export$c03bb0116ee09d4b(date, today = new Date()) {
    return !!date.getTime && (0, $jovBr.default)(date) && date.getTime() <= today.getTime();
}
function $88d6808b8169877f$export$2e2bcd8739ae039(date, today = new Date()) {
    if (!date || !$88d6808b8169877f$export$c03bb0116ee09d4b(date, today)) return null;
    if ((0, $ki4Ey.default)(date)) return 'ThisWeek';
    if ((0, $f0lG8.default)(date)) return 'ThisMonth';
    if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() - 1) return 'LastMonth';
    const diffInMonths = (0, $kMWS1.default)(today, date);
    if (diffInMonths < 6) return 'AFewMonths';
    if (diffInMonths <= 12) return 'SeveralMonths';
    return 'MoreThanAYear';
}

});

parcelRegister("dMnCT", function(module, exports) {

$parcel$export(module.exports, "default", () => $144ea7a667fc0f26$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $acmVr = parcelRequire("acmVr");

var $bEcs6 = parcelRequire("bEcs6");

var $jDYnt = parcelRequire("jDYnt");

var $lKAMh = parcelRequire("lKAMh");

var $fHpHg = parcelRequire("fHpHg");

var $2ZCVH = parcelRequire("2ZCVH");
const $144ea7a667fc0f26$var$icons = {
    location: (0, (/*@__PURE__*/$parcel$interopDefault($jDYnt))),
    time: (0, (/*@__PURE__*/$parcel$interopDefault($acmVr))),
    email: (0, (/*@__PURE__*/$parcel$interopDefault($bEcs6))),
    companyName: (0, (/*@__PURE__*/$parcel$interopDefault($lKAMh)))
};
class $144ea7a667fc0f26$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.defaultProps = {
            icon: ''
        };
    }
    render() {
        if (!this.props.children) return null;
        // @ts-ignore
        const IconElement = this.props.icon && $144ea7a667fc0f26$var$icons[this.props.icon];
        const displayIcon = IconElement ? /*#__PURE__*/ (0, $2OMIu.jsx)(IconElement, {
            label: `${this.props.icon}`,
            LEGACY_size: "small",
            color: (0, $fHpHg.fg)('compiled-migration-profilecard') ? "var(--ds-text-subtlest, #626F86)" : 'currentColor'
        }) : null;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2ZCVH.DetailsLabel), {
            extraTopSpace: this.props.extraTopSpace,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.DetailsLabelIcon), {
                    children: displayIcon
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.DetailsLabelText), {
                    children: this.props.children
                })
            ]
        });
    }
}

});
parcelRegister("bEcs6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b2014ecb862bd114df9c4eca3bb7d0c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87ad16e679cb17a1$var$_react = $87ad16e679cb17a1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87ad16e679cb17a1$var$_email = $87ad16e679cb17a1$var$_interopRequireDefault((parcelRequire("dvv9E")));

var $87ad16e679cb17a1$var$_email2 = $87ad16e679cb17a1$var$_interopRequireDefault((parcelRequire("dTO85")));
function $87ad16e679cb17a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmailIcon.
 * This component is EmailIcon, with `UNSAFE_fallbackIcon` set to "EmailIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87ad16e679cb17a1$var$EmailIcon = (props)=>/*#__PURE__*/ $87ad16e679cb17a1$var$_react.default.createElement($87ad16e679cb17a1$var$_email.default, Object.assign({
        LEGACY_fallbackIcon: $87ad16e679cb17a1$var$_email2.default
    }, props));
$87ad16e679cb17a1$var$EmailIcon.Name = 'EmailIconMigration';
var $87ad16e679cb17a1$var$_default = module.exports.default = $87ad16e679cb17a1$var$EmailIcon;

});
parcelRegister("dvv9E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d565642138875e6$var$_react = $9d565642138875e6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9d565642138875e6$var$_baseNew = $9d565642138875e6$var$_interopRequireDefault((parcelRequire("enEmH")));
function $9d565642138875e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d565642138875e6$var$EmailIcon = (props)=>/*#__PURE__*/ $9d565642138875e6$var$_react.default.createElement($9d565642138875e6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$9d565642138875e6$var$EmailIcon.displayName = 'EmailIcon';
var $9d565642138875e6$var$_default = module.exports.default = $9d565642138875e6$var$EmailIcon;

});

parcelRegister("dTO85", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1e74c1782477aa6$var$_react = $a1e74c1782477aa6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $a1e74c1782477aa6$var$_email = $a1e74c1782477aa6$var$_interopRequireDefault((parcelRequire("dvv9E")));
function $a1e74c1782477aa6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a1e74c1782477aa6$var$EmailIcon = (props)=>/*#__PURE__*/ $a1e74c1782477aa6$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $a1e74c1782477aa6$var$_email.default
    }));
$a1e74c1782477aa6$var$EmailIcon.displayName = 'EmailIcon';
var $a1e74c1782477aa6$var$_default = module.exports.default = $a1e74c1782477aa6$var$EmailIcon;

});


parcelRegister("jDYnt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::15069c31a0410504ca6fc11c34278f93>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4d07e90f5807ab9$var$_react = $e4d07e90f5807ab9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e4d07e90f5807ab9$var$_location = $e4d07e90f5807ab9$var$_interopRequireDefault((parcelRequire("krnlV")));

var $e4d07e90f5807ab9$var$_location2 = $e4d07e90f5807ab9$var$_interopRequireDefault((parcelRequire("5dLAb")));
function $e4d07e90f5807ab9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LocationIcon.
 * This component is LocationIcon, with `UNSAFE_fallbackIcon` set to "LocationIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e4d07e90f5807ab9$var$LocationIcon = (props)=>/*#__PURE__*/ $e4d07e90f5807ab9$var$_react.default.createElement($e4d07e90f5807ab9$var$_location.default, Object.assign({
        LEGACY_fallbackIcon: $e4d07e90f5807ab9$var$_location2.default
    }, props));
$e4d07e90f5807ab9$var$LocationIcon.Name = 'LocationIconMigration';
var $e4d07e90f5807ab9$var$_default = module.exports.default = $e4d07e90f5807ab9$var$LocationIcon;

});
parcelRegister("krnlV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a077d34b75af68b5a629fa3ed5b43193>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee187195fd031fd5$var$_react = $ee187195fd031fd5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ee187195fd031fd5$var$_baseNew = $ee187195fd031fd5$var$_interopRequireDefault((parcelRequire("enEmH")));
function $ee187195fd031fd5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee187195fd031fd5$var$LocationIcon = (props)=>/*#__PURE__*/ $ee187195fd031fd5$var$_react.default.createElement($ee187195fd031fd5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5c-3.627 0-5.764 4.07-3.705 7.056L8 13.93l3.705-5.373C13.765 5.57 11.627 1.5 8 1.5M3.06 9.408C.314 5.427 3.164 0 8 0s7.686 5.427 4.94 9.408l-4.323 6.268a.75.75 0 0 1-1.234 0zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/>`
    }, props));
$ee187195fd031fd5$var$LocationIcon.displayName = 'LocationIcon';
var $ee187195fd031fd5$var$_default = module.exports.default = $ee187195fd031fd5$var$LocationIcon;

});

parcelRegister("5dLAb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cd313903b186c1e$var$_react = $3cd313903b186c1e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $3cd313903b186c1e$var$_location = $3cd313903b186c1e$var$_interopRequireDefault((parcelRequire("krnlV")));
function $3cd313903b186c1e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3cd313903b186c1e$var$LocationIcon = (props)=>/*#__PURE__*/ $3cd313903b186c1e$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1 1 12 0c0 3.314-3.72 12-6 12m0-9a2.912 2.912 0 1 0 0-5.824A2.912 2.912 0 0 0 12 12"/></svg>`
    }, props, {
        newIcon: $3cd313903b186c1e$var$_location.default
    }));
$3cd313903b186c1e$var$LocationIcon.displayName = 'LocationIcon';
var $3cd313903b186c1e$var$_default = module.exports.default = $3cd313903b186c1e$var$LocationIcon;

});


parcelRegister("lKAMh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f7f55381552b3bb050a399d88ef8b3fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd5a6c2518126bf0$var$_react = $fd5a6c2518126bf0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fd5a6c2518126bf0$var$_officeBuilding = $fd5a6c2518126bf0$var$_interopRequireDefault((parcelRequire("eGfuI")));

var $fd5a6c2518126bf0$var$_officeBuilding2 = $fd5a6c2518126bf0$var$_interopRequireDefault((parcelRequire("f04Gq")));
function $fd5a6c2518126bf0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for OfficeBuildingIcon.
 * This component is OfficeBuildingIcon, with `UNSAFE_fallbackIcon` set to "OfficeBuildingIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd5a6c2518126bf0$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $fd5a6c2518126bf0$var$_react.default.createElement($fd5a6c2518126bf0$var$_officeBuilding.default, Object.assign({
        LEGACY_fallbackIcon: $fd5a6c2518126bf0$var$_officeBuilding2.default
    }, props));
$fd5a6c2518126bf0$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
var $fd5a6c2518126bf0$var$_default = module.exports.default = $fd5a6c2518126bf0$var$OfficeBuildingIcon;

});
parcelRegister("eGfuI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfe75e26330f86b48e811f0d520fc5e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab0101cfd05e872a$var$_react = $ab0101cfd05e872a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ab0101cfd05e872a$var$_baseNew = $ab0101cfd05e872a$var$_interopRequireDefault((parcelRequire("enEmH")));
function $ab0101cfd05e872a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab0101cfd05e872a$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $ab0101cfd05e872a$var$_react.default.createElement($ab0101cfd05e872a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$ab0101cfd05e872a$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $ab0101cfd05e872a$var$_default = module.exports.default = $ab0101cfd05e872a$var$OfficeBuildingIcon;

});

parcelRegister("f04Gq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aeba7d1c40ab5a92$var$_react = $aeba7d1c40ab5a92$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $aeba7d1c40ab5a92$var$_officeBuilding = $aeba7d1c40ab5a92$var$_interopRequireDefault((parcelRequire("eGfuI")));
function $aeba7d1c40ab5a92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $aeba7d1c40ab5a92$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $aeba7d1c40ab5a92$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144z"/><path d="M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/><path fill-rule="nonzero" d="M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/></g></svg>`
    }, props, {
        newIcon: $aeba7d1c40ab5a92$var$_officeBuilding.default
    }));
$aeba7d1c40ab5a92$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $aeba7d1c40ab5a92$var$_default = module.exports.default = $aeba7d1c40ab5a92$var$OfficeBuildingIcon;

});



parcelRegister("bMmHv", function(module, exports) {

$parcel$export(module.exports, "default", () => $409e03fd082ae0f1$export$2e2bcd8739ae039);
/* ReportingLinesDetails.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $ew55A = parcelRequire("ew55A");

var $44cng = parcelRequire("44cng");

var $cNW3X = parcelRequire("cNW3X");

var $fHpHg = parcelRequire("fHpHg");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $7rJgC = parcelRequire("7rJgC");

var $3DrJx = parcelRequire("3DrJx");

var $g8DR3 = parcelRequire("g8DR3");

var $jQ0hK = parcelRequire("jQ0hK");
function $409e03fd082ae0f1$var$getProfileHref(userId, profileUrl) {
    return profileUrl ? profileUrl + userId : undefined;
}
const $409e03fd082ae0f1$var$reportingLinesHeadingDefaultStyles = (0, $2s57o.xcss)({
    color: 'color.text',
    font: 'font.heading.xxsmall',
    fontWeight: 'font.weight.semibold',
    marginBottom: 'space.100'
});
const $409e03fd082ae0f1$var$reportingLinesHeadingStyles = (0, $2s57o.xcss)({
    marginBottom: '0'
});
const $409e03fd082ae0f1$var$styles = {
    reportingLinesButton: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _bfhk1w7a _irr3166n"
};
const $409e03fd082ae0f1$var$avatarGroupMaxCount = 5;
const $409e03fd082ae0f1$var$ReportingLinesDetails = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireAnalyticsWithDuration: fireAnalyticsWithDuration, reportingLines: reportingLines = {}, reportingLinesProfileUrl: reportingLinesProfileUrl, onReportingLinesClick: onReportingLinesClick } = props;
    const { managers: managers = [], reports: reports = [] } = reportingLines;
    const manager = managers.length >= 1 ? managers[0] : undefined;
    const hasReports = reports.length > 0;
    const getReportingLinesOnClick = (user, userType)=>onReportingLinesClick ? ()=>{
            fireAnalyticsWithDuration((duration)=>(0, $jQ0hK.reportingLinesClicked)({
                    duration: duration,
                    userType: userType
                }));
            onReportingLinesClick(user);
        } : undefined;
    const onReportingLinksClick = (user, userType, href)=>{
        if (href) window.location.href = href;
        if (onReportingLinesClick) onReportingLinesClick(user);
        fireAnalyticsWithDuration((duration)=>(0, $jQ0hK.reportingLinesClicked)({
                duration: duration,
                userType: userType
            }));
    };
    const showMoreButtonProps = (0, $fHpHg.fg)('platform_profilecard-enable_reporting_lines_label') ? {
        'aria-label': formatMessage((0, $3DrJx.default).profileCardMoreReportingLinesLabel, {
            count: reports.length - $409e03fd082ae0f1$var$avatarGroupMaxCount + 1
        })
    } : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            manager && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $g8DR3.ReportingLinesSection), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                        xcss: [
                            $409e03fd082ae0f1$var$reportingLinesHeadingDefaultStyles,
                            $409e03fd082ae0f1$var$reportingLinesHeadingStyles
                        ],
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $3DrJx.default).managerSectionHeading
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g8DR3.OffsetWrapper), {
                        children: (0, $fHpHg.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                            onClick: ()=>onReportingLinksClick(manager, 'manager', $409e03fd082ae0f1$var$getProfileHref(manager.accountIdentifier, reportingLinesProfileUrl)),
                            isDisabled: !onReportingLinesClick,
                            xcss: $409e03fd082ae0f1$var$styles.reportingLinesButton,
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $g8DR3.ManagerSection), {
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ew55A.default), {
                                        size: "xsmall",
                                        src: manager.pii?.picture
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g8DR3.ManagerName), {
                                        children: manager.pii?.name
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                            appearance: "subtle",
                            spacing: "none",
                            href: $409e03fd082ae0f1$var$getProfileHref(manager.accountIdentifier, reportingLinesProfileUrl),
                            onClick: getReportingLinesOnClick(manager, 'manager'),
                            isDisabled: !onReportingLinesClick,
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $g8DR3.ManagerSection), {
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ew55A.default), {
                                        size: "xsmall",
                                        src: manager.pii?.picture
                                    }),
                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g8DR3.ManagerName), {
                                        children: manager.pii?.name
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            hasReports && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $g8DR3.ReportingLinesSection), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                        xcss: $409e03fd082ae0f1$var$reportingLinesHeadingDefaultStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $3DrJx.default).directReportsSectionHeading
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $44cng.default), {
                        appearance: "stack",
                        size: "small",
                        data: reports.map((member)=>{
                            return {
                                key: member.accountIdentifier,
                                name: member.pii?.name || '',
                                src: member.pii?.picture,
                                href: $409e03fd082ae0f1$var$getProfileHref(member.accountIdentifier, reportingLinesProfileUrl),
                                onClick: getReportingLinesOnClick(member, 'direct-report')
                            };
                        }),
                        maxCount: $409e03fd082ae0f1$var$avatarGroupMaxCount,
                        testId: "profilecard-reports-avatar-group",
                        showMoreButtonProps: showMoreButtonProps
                    })
                ]
            })
        ]
    });
};
var $409e03fd082ae0f1$export$2e2bcd8739ae039 = $409e03fd082ae0f1$var$ReportingLinesDetails;

});
parcelRegister("g8DR3", function(module, exports) {

$parcel$export(module.exports, "ReportingLinesSection", () => $31b0783dbc926e0d$export$ae48ddd79a45b949);
$parcel$export(module.exports, "ManagerSection", () => $31b0783dbc926e0d$export$2992b481dad9fb03);
$parcel$export(module.exports, "ManagerName", () => $31b0783dbc926e0d$export$98f8ec89e658b052);
$parcel$export(module.exports, "OffsetWrapper", () => $31b0783dbc926e0d$export$56eae56612ce5f3);
/* ReportingLines.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");

var $bWGt6 = parcelRequire("bWGt6");
function $31b0783dbc926e0d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $31b0783dbc926e0d$var$styles = {
    reportingLinesSection: "_18u01b66 _19pku2gc",
    managerSection: "_1e0c1txw _4cvr1h6o _18u01b66 _19pk1b66 _otyr1b66 _2hwx1b66",
    managerName: "_11c81o8v _18u0u2gc",
    offsetWrapper: "_19pk1b66 _18u0r5cr"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/use-primitives -- Ignored via go/DSP-18766
const $31b0783dbc926e0d$var$ReportingLinesSectionLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e19veg8t3"
})({
    name: "1m5erzj",
    styles: "margin-left:var(--ds-space-050, 4px);margin-top:var(--ds-space-100, 8px)"
});
const $31b0783dbc926e0d$export$ae48ddd79a45b949 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($31b0783dbc926e0d$var$styles.reportingLinesSection),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($31b0783dbc926e0d$var$ReportingLinesSectionLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $31b0783dbc926e0d$var$ManagerSectionLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e19veg8t2"
})({
    display: 'flex',
    alignItems: 'center',
    margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
});
const $31b0783dbc926e0d$export$2992b481dad9fb03 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($31b0783dbc926e0d$var$styles.managerSection),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($31b0783dbc926e0d$var$ManagerSectionLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $31b0783dbc926e0d$var$ManagerNameLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e19veg8t1"
})({
    name: "1jpv77g",
    styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-left:var(--ds-space-100, 8px)"
});
const $31b0783dbc926e0d$export$98f8ec89e658b052 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($31b0783dbc926e0d$var$styles.managerName),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($31b0783dbc926e0d$var$ManagerNameLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/use-primitives -- Ignored via go/DSP-18766
const $31b0783dbc926e0d$var$OffsetWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e19veg8t0"
})({
    name: "ysolxb",
    styles: "margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-negative-050, -4px)"
});
const $31b0783dbc926e0d$export$56eae56612ce5f3 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($31b0783dbc926e0d$var$styles.offsetWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($31b0783dbc926e0d$var$OffsetWrapperLegacy, {
        children: children
    });

});




parcelRegister("ee06t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c34453b94712f1bd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");

var $2ZCVH = parcelRequire("2ZCVH");

var $jQ0hK = parcelRequire("jQ0hK");
const $c34453b94712f1bd$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $jQ0hK.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {})
    });
};
var $c34453b94712f1bd$export$2e2bcd8739ae039 = $c34453b94712f1bd$var$UserLoadingState;

});


parcelRegister("awbOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e99cec1c60a950e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bngFq = parcelRequire("bngFq");

var $lEwUf = parcelRequire("lEwUf");
var $g9EwJ = parcelRequire("g9EwJ");

var $fHpHg = parcelRequire("fHpHg");

var $vCqQa = parcelRequire("vCqQa");

var $b4a3S = parcelRequire("b4a3S");

var $EHfmh = parcelRequire("EHfmh");

var $3JUaA = parcelRequire("3JUaA");

var $2ZCVH = parcelRequire("2ZCVH");

var $jQ0hK = parcelRequire("jQ0hK");


var $1WoQW = parcelRequire("1WoQW");

var $cJhcW = parcelRequire("cJhcW");

var $ee06t = parcelRequire("ee06t");
function $0e99cec1c60a950e$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1WoQW.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cJhcW.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $0e99cec1c60a950e$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isMounted = (0, $5uXOq.useRef)(false);
    const showDelay = trigger === 'click' || propsIsVisible && (0, $fHpHg.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $4f9eb78cf9cb8ede$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || propsIsVisible && (0, $fHpHg.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $4f9eb78cf9cb8ede$export$89a9f35a94d7f196);
    const showTimer = (0, $5uXOq.useRef)(0);
    const hideTimer = (0, $5uXOq.useRef)(0);
    const [visible, setVisible] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(undefined);
    const [hasError, setHasError] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $5uXOq.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $5uXOq.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $5uXOq.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $5uXOq.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const triggerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $jQ0hK.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $5uXOq.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $5uXOq.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $5uXOq.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $5uXOq.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $jQ0hK.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $jQ0hK.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $jQ0hK.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $fHpHg.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $5uXOq.useCallback)(()=>{
        return (0, $EHfmh.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)($0e99cec1c60a950e$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $2OMIu.jsx)($0e99cec1c60a950e$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $3JUaA.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        children: children
                    });
                },
                zIndex: (0, $b4a3S.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $fHpHg.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lEwUf.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $g9EwJ.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $0e99cec1c60a950e$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ee06t.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("3JUaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $517aa9ed7fa78ed1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $517aa9ed7fa78ed1$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($517aa9ed7fa78ed1$var$messages.label, {
        fullName: fullName
    }) : formatMessage($517aa9ed7fa78ed1$var$messages.fallbackLabel);
};
const $517aa9ed7fa78ed1$var$messages = (0, $7VHMR.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $517aa9ed7fa78ed1$export$2e2bcd8739ae039 = $517aa9ed7fa78ed1$var$getLabelMessage;

});

parcelRegister("1WoQW", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $2d94818ecf652245$export$4b013ffffcb40af8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $jQ0hK = parcelRequire("jQ0hK");

var $bD4ui = parcelRequire("bD4ui");

var $gp7t8 = parcelRequire("gp7t8");

var $lAOSH = parcelRequire("lAOSH");

var $hSaWA = parcelRequire("hSaWA");
const $2d94818ecf652245$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $jQ0hK.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $5uXOq.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $bD4ui.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const getCreator = (0, $5uXOq.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient
    ]);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lAOSH.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gp7t8.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hSaWA.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        })
    });
};

});
parcelRegister("bD4ui", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $b80a0045e9a58980$export$3761e66a04602cbd);
const $b80a0045e9a58980$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $b80a0045e9a58980$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($b80a0045e9a58980$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("lAOSH", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $6ee38d671b08bb58$export$2c6604b50c274e6f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
const $6ee38d671b08bb58$var$styles = (0, $2s57o.xcss)({
    width: '360px'
});
const $6ee38d671b08bb58$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        xcss: $6ee38d671b08bb58$var$styles,
        children: children
    });
};

});

parcelRegister("hSaWA", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $3a31370de5ff877d$export$ed0ca9c1d49ea0bf);

var $5uXOq = parcelRequire("5uXOq");

const $3a31370de5ff877d$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("hdPQS")));

});
parcelRegister("hdPQS", function(module, exports) {

let $c89bdf4194ef3e86$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c89bdf4194ef3e86$var$load("cM9em"),
    $c89bdf4194ef3e86$var$load("fr9NE"),
    $c89bdf4194ef3e86$var$load("h2MrD"),
    $c89bdf4194ef3e86$var$load("bYT2S"),
    $c89bdf4194ef3e86$var$load("2YJE7")
]).then(()=>parcelRequire('kr9eS'));

});



parcelRegister("cJhcW", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $becb744ba4eb9463$export$403d297463f226af);

var $5uXOq = parcelRequire("5uXOq");

const $becb744ba4eb9463$export$403d297463f226af = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("fW87Q"))));

});


parcelRegister("iY9BQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $01c3c01eb98a26a5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $ew55A = parcelRequire("ew55A");

var $44cng = parcelRequire("44cng");

var $i95f5 = parcelRequire("i95f5");

var $bMFGq = parcelRequire("bMFGq");
var $1Seuh = parcelRequire("1Seuh");
var $liZ21 = parcelRequire("liZ21");

var $cNW3X = parcelRequire("cNW3X");

var $6fV04 = parcelRequire("6fV04");

var $elaEw = parcelRequire("elaEw");

var $44qT7 = parcelRequire("44qT7");
var $aOrxC = parcelRequire("aOrxC");

var $5uGNN = parcelRequire("5uGNN");

var $fHpHg = parcelRequire("fHpHg");

var $vCqQa = parcelRequire("vCqQa");

var $5sLH0 = parcelRequire("5sLH0");
var $k9nuy = parcelRequire("k9nuy");

var $b4a3S = parcelRequire("b4a3S");

var $5KCCi = parcelRequire("5KCCi");

var $3DrJx = parcelRequire("3DrJx");

var $2ZCVH = parcelRequire("2ZCVH");

var $97aaW = parcelRequire("97aaW");

var $6g0KK = parcelRequire("6g0KK");

var $jQ0hK = parcelRequire("jQ0hK");

var $g4Mqd = parcelRequire("g4Mqd");

var $d5N9J = parcelRequire("d5N9J");

var $851Yl = parcelRequire("851Yl");

var $kMZDI = parcelRequire("kMZDI");
const $01c3c01eb98a26a5$var$LARGE_MEMBER_COUNT = 50;
const $01c3c01eb98a26a5$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
const $01c3c01eb98a26a5$var$avatarGroupMaxCount = 9;
function $01c3c01eb98a26a5$var$onMemberClick(callback, userId, analytics, index, hasHref) {
    return (event)=>{
        analytics((duration)=>(0, $jQ0hK.teamAvatarClicked)({
                duration: duration,
                hasHref: hasHref,
                hasOnClick: !!callback,
                index: index
            }));
        if (callback) callback(userId, event);
    };
}
const $01c3c01eb98a26a5$var$TeamMembers = ({ analytics: analytics, generateUserLink: generateUserLink, members: members, onUserClick: onUserClick, includingYou: includingYou, isTriggeredByKeyboard: isTriggeredByKeyboard })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const count = members ? members.length : 0;
    const message = includingYou ? count >= $01c3c01eb98a26a5$var$LARGE_MEMBER_COUNT ? (0, $3DrJx.default).membersMoreThan50IncludingYou : (0, $3DrJx.default).memberCountIncludingYou : count >= $01c3c01eb98a26a5$var$LARGE_MEMBER_COUNT ? (0, $3DrJx.default).membersMoreThan50 : (0, $3DrJx.default).memberCount;
    // Use a ref to track whether this is currently open, so we can fire events
    // iff the more section is being opened (not closed).
    const isMoreMembersOpen = (0, $5uXOq.useRef)(false);
    const avatarRef = (0, $5uXOq.useRef)(null);
    const ref = (element)=>{
        if (isTriggeredByKeyboard) {
            avatarRef.current = element;
            avatarRef.current?.focus();
        }
    };
    const onMoreClick = (0, $5uXOq.useCallback)(()=>{
        const { current: isOpen } = isMoreMembersOpen;
        if (!isOpen) analytics((duration)=>(0, $jQ0hK.moreMembersClicked)({
                duration: duration,
                memberCount: count
            }));
        isMoreMembersOpen.current = !isOpen;
    }, [
        analytics,
        count
    ]);
    const showMoreButtonProps = {
        onClick: onMoreClick,
        ...(0, $fHpHg.fg)('platform_profilecard-enable_reporting_lines_label') ? {
            'aria-label': formatMessage((0, $3DrJx.default).profileCardMoreMembersLabel, {
                count: count - $01c3c01eb98a26a5$var$avatarGroupMaxCount + 1
            })
        } : {}
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.MemberCount), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...message,
                    values: {
                        count: count
                    }
                })
            }),
            members && members.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.AvatarSection), {
                children: (0, $fHpHg.fg)('enable_team_profilecard_toggletip_a11y_fix') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $44cng.default), {
                    appearance: "stack",
                    data: members.map((member, index)=>{
                        const href = generateUserLink?.(member.id);
                        const onClick = $01c3c01eb98a26a5$var$onMemberClick(onUserClick, member.id, analytics, index, !!generateUserLink);
                        return {
                            key: member.id,
                            name: member.fullName,
                            src: member.avatarUrl,
                            href: href,
                            onClick: onClick
                        };
                    }),
                    maxCount: $01c3c01eb98a26a5$var$avatarGroupMaxCount,
                    showMoreButtonProps: showMoreButtonProps,
                    testId: "profilecard-avatar-group",
                    overrides: {
                        Avatar: {
                            render: (Component, props, index)=>index === 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ew55A.default), {
                                    ref: ref,
                                    ...props,
                                    testId: "first-member"
                                }) : /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                                    ...props
                                })
                        }
                    }
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $44cng.default), {
                    appearance: "stack",
                    data: members.map((member, index)=>{
                        const href = generateUserLink?.(member.id);
                        const onClick = $01c3c01eb98a26a5$var$onMemberClick(onUserClick, member.id, analytics, index, !!generateUserLink);
                        return {
                            key: member.id,
                            name: member.fullName,
                            src: member.avatarUrl,
                            href: href,
                            onClick: onClick
                        };
                    }),
                    maxCount: $01c3c01eb98a26a5$var$avatarGroupMaxCount,
                    showMoreButtonProps: showMoreButtonProps,
                    testId: "profilecard-avatar-group"
                })
            })
        ]
    });
};
function $01c3c01eb98a26a5$var$onActionClick(action, analytics, index) {
    return (event, ...args)=>{
        analytics((duration)=>(0, $jQ0hK.actionClicked)('team', {
                duration: duration,
                hasHref: !!action.link,
                hasOnClick: !!action.callback,
                index: index,
                actionId: action.id || ''
            }));
        if (action.callback && (0, $g4Mqd.isBasicClick)(event)) {
            event.preventDefault();
            action.callback(event, ...args);
        }
    };
}
const $01c3c01eb98a26a5$var$ActionButton = ({ action: action, analytics: analytics, index: index })=>{
    const isGiveKudosActionButton = action.id === $01c3c01eb98a26a5$var$GIVE_KUDOS_ACTION_ID;
    const actionButton = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6fV04.default), {
        isInset: true,
        children: (0, $fHpHg.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $liZ21.default), {
            onClick: $01c3c01eb98a26a5$var$onActionClick(action, analytics, index),
            href: action.link || '',
            shouldFitContainer: true,
            children: [
                action.label,
                isGiveKudosActionButton && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.AnimationWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.KudosBlobAnimation), {})
                })
            ]
        }, action.id || index) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cNW3X.default), {
            onClick: $01c3c01eb98a26a5$var$onActionClick(action, analytics, index),
            href: action.link,
            shouldFitContainer: true,
            children: [
                action.label,
                isGiveKudosActionButton && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.AnimationWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.KudosBlobAnimation), {})
                })
            ]
        }, action.id || index)
    });
    if (isGiveKudosActionButton) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.AnimatedKudosButton), {
        children: actionButton
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.WrappedButton), {
        children: actionButton
    });
};
const $01c3c01eb98a26a5$var$ExtraActions = ({ actions: actions, analytics: analytics })=>{
    const [isOpen, setOpen] = (0, $5uXOq.useState)(false);
    const count = actions.length;
    const onMoreClick = (0, $5uXOq.useCallback)((shouldBeOpen)=>{
        if (shouldBeOpen) // Only fire this event when OPENING the dropdown
        analytics((duration)=>(0, $jQ0hK.moreActionsClicked)('team', {
                duration: duration,
                numActions: count + 2
            }));
        setOpen(shouldBeOpen);
    }, [
        analytics,
        count
    ]);
    if (!count) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.MoreButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.default), {
            isOpen: isOpen,
            onClose: ()=>setOpen(false),
            placement: "bottom-start",
            content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $aOrxC.default), {
                    children: actions.map((action, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $44qT7.default), {
                            onClick: $01c3c01eb98a26a5$var$onActionClick(action, analytics, index + 2),
                            href: action.link,
                            children: action.label
                        }, action.id || index))
                }),
            trigger: (triggerProps)=>{
                return (0, $fHpHg.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                    testId: "more-actions-button",
                    ...triggerProps,
                    isSelected: isOpen,
                    onClick: ()=>onMoreClick(!isOpen),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($elaEw))),
                    label: "actions"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                    testId: "more-actions-button",
                    ...triggerProps,
                    isSelected: isOpen,
                    onClick: ()=>onMoreClick(!isOpen),
                    iconAfter: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($elaEw))), {
                        spacing: "spacious",
                        label: "actions",
                        color: "currentColor"
                    })
                });
            },
            zIndex: (0, $b4a3S.layers).modal(),
            shouldRenderToParent: (0, $fHpHg.fg)('enable_appropriate_reading_order_in_profile_card')
        })
    });
};
const $01c3c01eb98a26a5$var$ButtonSection = ({ actions: actions, analytics: analytics })=>{
    if (!actions) return null;
    const extraActions = actions.slice(2);
    const initialActions = actions.slice(0, 2);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6g0KK.ActionButtons), {
        children: [
            initialActions.map((action, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)($01c3c01eb98a26a5$var$ActionButton, {
                    action: action,
                    analytics: analytics,
                    index: index
                }, index)),
            extraActions && /*#__PURE__*/ (0, $2OMIu.jsx)($01c3c01eb98a26a5$var$ExtraActions, {
                actions: extraActions,
                analytics: analytics
            })
        ]
    });
};
const $01c3c01eb98a26a5$var$TeamProfilecardContent = ({ actions: actions, analytics: analytics, team: team, viewingUserId: viewingUserId, generateUserLink: generateUserLink, onUserClick: onUserClick, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick, isTriggeredByKeyboard: isTriggeredByKeyboard })=>{
    const allActions = [
        {
            label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $3DrJx.default).teamViewProfile
            }),
            link: viewProfileLink,
            callback: viewProfileOnClick,
            id: 'view-profile'
        },
        ...actions || []
    ];
    const includingYou = team.members && team.members.some((member)=>member.id === viewingUserId);
    (0, $5uXOq.useEffect)(()=>{
        analytics((duration)=>(0, $jQ0hK.profileCardRendered)('team', 'content', {
                duration: duration,
                numActions: allActions.length,
                memberCount: team.members?.length,
                includingYou: includingYou,
                descriptionLength: team.description.length,
                titleLength: team.displayName.length
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6g0KK.CardWrapper), {
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.CardHeader), {
                image: team.largeHeaderImageUrl || team.smallHeaderImageUrl,
                label: team.displayName
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6g0KK.CardContent), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
                        content: team.displayName,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.TeamName), {
                                    children: team.displayName
                                }),
                                team.isVerified && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uGNN.VerifiedTeamIcon), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)($01c3c01eb98a26a5$var$TeamMembers, {
                        analytics: analytics,
                        members: team.members,
                        generateUserLink: generateUserLink,
                        includingYou: includingYou,
                        onUserClick: onUserClick,
                        isTriggeredByKeyboard: isTriggeredByKeyboard
                    }),
                    team.description.trim() && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.DescriptionWrapper), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.Description), {
                            children: team.description
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)($01c3c01eb98a26a5$var$ButtonSection, {
                        actions: allActions,
                        analytics: analytics
                    })
                ]
            })
        ]
    });
};
const $01c3c01eb98a26a5$var$ErrorMessage = ({ analytics: analytics, clientFetchProfile: clientFetchProfile, isLoading: isLoading })=>{
    const hasRetry = !!clientFetchProfile;
    (0, $5uXOq.useEffect)(()=>{
        analytics((duration)=>(0, $jQ0hK.profileCardRendered)('team', 'error', {
                duration: duration,
                hasRetry: hasRetry
            }));
    }, [
        analytics,
        hasRetry
    ]);
    const retry = (0, $5uXOq.useCallback)(()=>{
        analytics((duration)=>(0, $jQ0hK.errorRetryClicked)({
                duration: duration
            }));
        if (clientFetchProfile) clientFetchProfile();
    }, [
        analytics,
        clientFetchProfile
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $97aaW.ErrorWrapper), {
        testId: "team-profilecard-error",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d5N9J.ErrorIllustration), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                as: "p",
                weight: "semibold",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $3DrJx.default).teamErrorTitle
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $97aaW.TeamErrorText), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $3DrJx.default).teamErrorText
                })
            }),
            clientFetchProfile && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.ActionButtons), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.WrappedButton), {
                    children: (0, $fHpHg.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
                        testId: "client-fetch-profile-button",
                        shouldFitContainer: true,
                        onClick: retry,
                        isLoading: isLoading,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $3DrJx.default).teamErrorButton
                        })
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i95f5.default), {
                        testId: "client-fetch-profile-button",
                        shouldFitContainer: true,
                        onClick: retry,
                        isLoading: isLoading,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $3DrJx.default).teamErrorButton
                        })
                    })
                })
            })
        ]
    });
};
const $01c3c01eb98a26a5$var$TeamProfileCard = (props)=>{
    const { analytics: analytics, clientFetchProfile: clientFetchProfile, hasError: hasError, isLoading: isLoading, team: team, errorType: errorType } = props;
    if (hasError) {
        if (errorType?.reason === 'TEAMS_FORBIDDEN') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $851Yl.default), {
            analytics: analytics
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.CardWrapper), {
            testId: "team-profilecard",
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($01c3c01eb98a26a5$var$ErrorMessage, {
                analytics: analytics,
                clientFetchProfile: clientFetchProfile,
                isLoading: isLoading
            })
        });
    }
    if (isLoading) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kMZDI.default), {
        analytics: analytics
    });
    if (team) return /*#__PURE__*/ (0, $2OMIu.jsx)($01c3c01eb98a26a5$var$TeamProfilecardContent, {
        ...props,
        team: team
    });
    return null;
};
var $01c3c01eb98a26a5$export$2e2bcd8739ae039 = $01c3c01eb98a26a5$var$TeamProfileCard;

});
parcelRegister("6g0KK", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $5f2b9e73ca8b4dfc$export$6aa22a823032b784);
$parcel$export(module.exports, "TeamForbiddenErrorStateWrapper", () => $5f2b9e73ca8b4dfc$export$66ecf3d3b7b1c016);
$parcel$export(module.exports, "CardHeader", () => $5f2b9e73ca8b4dfc$export$5665775b26e26c5d);
$parcel$export(module.exports, "CardContent", () => $5f2b9e73ca8b4dfc$export$64ef9b8c11710c47);
$parcel$export(module.exports, "TeamName", () => $5f2b9e73ca8b4dfc$export$8fe6f0aed18a58c7);
$parcel$export(module.exports, "MemberCount", () => $5f2b9e73ca8b4dfc$export$1cbd03a20253b620);
$parcel$export(module.exports, "AvatarSection", () => $5f2b9e73ca8b4dfc$export$82a6f3ee677bdbfe);
$parcel$export(module.exports, "DescriptionWrapper", () => $5f2b9e73ca8b4dfc$export$2bf1f2b0d31b60fc);
$parcel$export(module.exports, "Description", () => $5f2b9e73ca8b4dfc$export$393edc798c47379d);
$parcel$export(module.exports, "ActionButtons", () => $5f2b9e73ca8b4dfc$export$88c65d2d98aab183);
$parcel$export(module.exports, "WrappedButton", () => $5f2b9e73ca8b4dfc$export$44e087c32db6077d);
$parcel$export(module.exports, "MoreButton", () => $5f2b9e73ca8b4dfc$export$7f94856880993f27);
$parcel$export(module.exports, "LoadingWrapper", () => $5f2b9e73ca8b4dfc$export$43a792a870d28db2);
$parcel$export(module.exports, "AccessLockSVGWrapper", () => $5f2b9e73ca8b4dfc$export$71bcd744fda975e5);
/* TeamCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $bWfiu = parcelRequire("bWfiu");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $k9nuy = parcelRequire("k9nuy");


var $b4a3S = parcelRequire("b4a3S");

var $efqyt = parcelRequire("efqyt");

var $dCOB1 = parcelRequire("dCOB1");

var $bWGt6 = parcelRequire("bWGt6");
function $5f2b9e73ca8b4dfc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5f2b9e73ca8b4dfc$var$styles = {
    cardtriggerwrapper: "_1e0c1kw7",
    cardwrapper: "_2rkoglpi _1bsbnklw _kqswh2mm",
    teamforbiddenerrorstatewrapper: "_1bsbnklw _kqswh2mm",
    cardheader: "_4t3i1qr7 _1bsb1osq",
    cardcontent: "_1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1tke1l8a",
    teamname: "_11c8lodh _1reo15vq _18m915vq _1p1dglyw _c71lckbl _1e0ccj1k",
    membercount: "_syaz1wmz _19pk1b66",
    avatarsection: "_19pkpxbi _18u01i6y",
    descriptionwrapper: "_19pkpxbi _4cvr1h6o _1e0c1txw",
    description: "_1reo15vq _18m915vq _c71l1wqb _1e0ccj1k",
    actionbuttons: "_1bsb1osq _1e0c1txw _1bah1yb4 _19pk1ejb _2hwx10v4 _otyridpf _18u0x0bf",
    wrappedbutton: "_i0dlidpf _16jlkb7n _18u0u2gc",
    morebutton: "_18u0u2gc",
    loadingwrapper: "_y3gn1h6o _19pk1jfw _otyr1jfw",
    accesslocksvgwrapper: "_otyr1ejb"
};
const $5f2b9e73ca8b4dfc$export$a443be8291b92497 = ()=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.cardtriggerwrapper)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$CardTriggerWrapperLegacy, {}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$CardTriggerWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q14"
})({
    name: "ck88l6",
    styles: "display:inherit"
});
const $5f2b9e73ca8b4dfc$export$6aa22a823032b784 = ({ testId: testId, children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.cardwrapper),
        backgroundColor: "elevation.surface.overlay",
        testId: testId,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$CardWrapperLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$CardWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q13"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $efqyt.bgColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $b4a3S.borderRadius)()}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: '320px',
    position: 'relative',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale'
});
const $5f2b9e73ca8b4dfc$export$66ecf3d3b7b1c016 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.teamforbiddenerrorstatewrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$TeamForbiddenErrorStateWrapperLegacy, {
        "data-testid": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$TeamForbiddenErrorStateWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q12"
})({
    name: "14xkrbi",
    styles: "width:320px;position:relative"
});
const $5f2b9e73ca8b4dfc$export$5665775b26e26c5d = ({ image: image, isLoading: isLoading, label: label })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? isLoading || !image ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.cardheader),
        backgroundColor: "color.background.neutral"
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dCOB1.CoverImage), {
        alt: label || '',
        src: image
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$CardHeaderLegacy, {
        image: image,
        isLoading: isLoading
    }); // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$CardHeaderLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q11"
})("background-color:", (props)=>props.isLoading ? `var(--ds-background-neutral, ${0, $a7f8c6b391092279$export$9fdfb749e33cdf97})` : props.image ? '' : (0, $efqyt.teamHeaderBgColor), ";background-image:", (props)=>props.image ? `url(${props.image})` : '', ";background-repeat:no-repeat;background-position:center;background-size:cover;box-sizing:content-box;height:128px;");
const $5f2b9e73ca8b4dfc$export$64ef9b8c11710c47 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.cardcontent),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$CardContentLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$CardContentLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q10"
})({
    name: "1rjz27l",
    styles: "display:flex;flex-direction:column;padding:var(--ds-space-300, 24px);min-height:104px"
});
const $5f2b9e73ca8b4dfc$export$8fe6f0aed18a58c7 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? (0, $fHpHg.fg)('enable_profilecard_h2tag_a11y_fix') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.teamname),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
            size: "medium",
            as: "h2",
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.teamname),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$TeamNameLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$TeamNameLegacy = /*#__PURE__*/ (0, $bWGt6.default)("h6", {
    target: "e14jp07q9"
})({
    name: "1ms0od4",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);text-transform:none;overflow:hidden;max-height:48px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical"
});
const $5f2b9e73ca8b4dfc$export$1cbd03a20253b620 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.membercount),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$MemberCountLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$MemberCountLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q8"
})({
    color: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-050, 4px)"
});
const $5f2b9e73ca8b4dfc$export$82a6f3ee677bdbfe = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.avatarsection),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$AvatarSectionLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/use-primitives -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$AvatarSectionLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q7"
})({
    name: "li9rw7",
    styles: "margin-top:var(--ds-space-200, 16px);margin-left:var(--ds-space-negative-025, -2px)"
});
const $5f2b9e73ca8b4dfc$export$2bf1f2b0d31b60fc = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.descriptionwrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$DescriptionWrapperLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$DescriptionWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q6"
})({
    name: "vi4bqq",
    styles: "margin-top:var(--ds-space-200, 16px);align-items:center;display:flex"
});
const $5f2b9e73ca8b4dfc$export$393edc798c47379d = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.description),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
            maxLines: 3,
            ...props
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$DescriptionLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$DescriptionLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e14jp07q5"
})({
    name: "yog5y2",
    styles: "overflow:hidden;max-height:60px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical"
});
const $5f2b9e73ca8b4dfc$export$88c65d2d98aab183 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.actionbuttons),
        backgroundColor: "elevation.surface.overlay",
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$ActionButtonsLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$ActionButtonsLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q4"
})({
    width: 'calc(100% + 8px)',
    display: 'flex',
    justifyContent: 'space-between',
    margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-negative-300, -24px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
    backgroundColor: "var(--ds-surface-overlay, hsla(0, 100%, 100%, 0.2))"
});
const $5f2b9e73ca8b4dfc$export$44e087c32db6077d = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.wrappedbutton),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$WrappedButtonLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$WrappedButtonLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q3"
})({
    name: "1svotkm",
    styles: "flex-basis:0;flex-grow:1;margin-left:var(--ds-space-100, 8px)"
});
const $5f2b9e73ca8b4dfc$export$7f94856880993f27 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.morebutton),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$MoreButtonLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/use-primitives -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$MoreButtonLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q2"
})({
    name: "9kivhj",
    styles: "margin-left:var(--ds-space-100, 8px)"
});
const $5f2b9e73ca8b4dfc$export$43a792a870d28db2 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.loadingwrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$LoadingWrapperLegacy, {
        "data-testid": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$LoadingWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q1"
})({
    name: "o13o72",
    styles: "text-align:center;margin-top:var(--ds-space-500, 40px)"
});
const $5f2b9e73ca8b4dfc$export$71bcd744fda975e5 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.accesslocksvgwrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$AccessLockSVGWrapperLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/use-primitives -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$AccessLockSVGWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q0"
})({
    name: "ifz8jz",
    styles: "margin-bottom:var(--ds-space-300, 24px)"
});

});
parcelRegister("dCOB1", function(module, exports) {

$parcel$export(module.exports, "CoverImage", () => $dda6dae762a2b7aa$export$a65e282337ff0f53);
/* CoverImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
const $dda6dae762a2b7aa$var$styles = {
    container: "_1reo15vq _18m915vq _1bsb1osq _4t3i1qr7 _kqswh2mm _13liglpi _qrwqglpi _1e0c1txw _1bah1h6o _4cvr1h6o",
    image: "_1bsbnklw _4t3i1wug"
};
const $dda6dae762a2b7aa$export$a65e282337ff0f53 = ({ src: src, alt: alt = '' })=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const imgRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        ref: containerRef,
        xcss: $dda6dae762a2b7aa$var$styles.container,
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
            as: "img",
            ref: imgRef,
            src: src,
            alt: alt,
            xcss: $dda6dae762a2b7aa$var$styles.image
        })
    });
};

});


parcelRegister("d5N9J", function(module, exports) {

$parcel$export(module.exports, "ErrorIllustration", () => $1aac1358ccdd9f3e$export$e0319f52fc2380b1);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $1aac1358ccdd9f3e$export$e0319f52fc2380b1 = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "42",
        height: "53",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M0.649902 0H163.93V212H0.649902V0Z",
                        fill: "var(--ds-surface-overlay, white)",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
                        fill: "url(#paint0_linear)"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                        opacity: "0.6",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                opacity: "0.6",
                                d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
                                fill: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                opacity: "0.6",
                                d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
                                fill: "#C1C7D0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                            opacity: "0.6",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                opacity: "0.6",
                                d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
                                fill: "#B3BAC5"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            opacity: "0.6",
                            d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
                            fill: "#B3BAC5"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            opacity: "0.6",
                            d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
                            fill: "#B3BAC5"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)("linearGradient", {
                        id: "paint0_linear",
                        x1: "26.1692",
                        y1: "228.621",
                        x2: "138.408",
                        y2: "116.382",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.297",
                                stopColor: "#C6CBD4",
                                stopOpacity: "0.8812"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.6301",
                                stopColor: "#D3D7DE",
                                stopOpacity: "0.748"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "0.9795",
                                stopColor: "#E9EBEF",
                                stopOpacity: "0.6082"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("stop", {
                                offset: "1",
                                stopColor: "#EBECF0",
                                stopOpacity: "0.6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                        id: "clip0",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M0.649902 0H163.93V212H0.649902V0Z",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("851Yl", function(module, exports) {

$parcel$export(module.exports, "default", () => $25dc5864fe35b4b7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $3s0xG = parcelRequire("3s0xG");

var $3DrJx = parcelRequire("3DrJx");

var $6g0KK = parcelRequire("6g0KK");

var $jQ0hK = parcelRequire("jQ0hK");

var $7ljVj = parcelRequire("7ljVj");
var $25dc5864fe35b4b7$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    const intl = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        analytics((duration)=>(0, $jQ0hK.profileCardRendered)('team', 'error', {
                duration: duration
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.TeamForbiddenErrorStateWrapper), {
        testId: "team-profilecard-forbidden-error-state",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3s0xG.default), {
            header: intl.formatMessage((0, $3DrJx.default).teamForbiddenErrorStateTitle),
            description: intl.formatMessage((0, $3DrJx.default).teamForbiddenErrorStateDescription),
            renderImage: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.AccessLockSVGWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ljVj.default), {})
                })
        })
    });
};

});
parcelRegister("7ljVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5864b4a82dafec0c$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $5864b4a82dafec0c$var$AccessLockSVG = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "191",
        height: "222",
        viewBox: "0 0 191 222",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M122.7 119.9H49.4V36.9998C49.8906 27.6107 53.9659 18.7679 60.7854 12.2956C67.6048 5.82318 76.6481 2.21484 86.05 2.21484C95.4519 2.21484 104.495 5.82318 111.315 12.2956C118.134 18.7679 122.209 27.6107 122.7 36.9998V119.9ZM61.4 107.9H110.7V36.9998C110.301 30.7336 107.53 24.8546 102.951 20.5583C98.3722 16.2619 92.3289 13.8706 86.05 13.8706C79.7711 13.8706 73.7279 16.2619 69.149 20.5583C64.5701 24.8546 61.7993 30.7336 61.4 36.9998V107.9Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H19.1C18.348 59.2976 17.605 59.4639 16.9262 59.7874C16.2474 60.111 15.6503 60.5834 15.1794 61.1697C14.7085 61.7559 14.3758 62.4408 14.2063 63.1734C14.0367 63.906 14.0346 64.6675 14.2 65.401C17.9782 81.0252 15.9154 97.4916 8.4 111.701C2.5112 123.071 -0.389112 135.752 -0.0282299 148.551C0.332652 161.351 3.94288 173.848 10.463 184.868C16.9831 195.888 26.1988 205.069 37.2436 211.548C48.2884 218.026 60.7993 221.589 73.6 221.901H91.5C101.565 222.141 111.577 220.365 120.946 216.679C130.315 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601Z",
                        fill: "#FF991F"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H36.9C36.154 59.3157 35.4203 59.494 34.7507 59.8232C34.0812 60.1523 33.492 60.6244 33.0247 61.2061C32.5574 61.7878 32.2235 62.4649 32.0464 63.1897C31.8694 63.9146 31.8535 64.6694 32 65.401C35.8087 81.0131 33.7816 97.4789 26.3 111.701C20.3828 123.006 17.4891 135.648 17.9 148.401C18.9 188.401 51.5 220.901 91.5 221.901C101.565 222.141 111.577 220.365 120.946 216.679C130.314 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501Z",
                        fill: "#FFAB00"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M93.4001 214H91.7001C80.2465 213.718 69.0525 210.53 59.1692 204.735C49.2859 198.939 41.0377 190.727 35.1991 180.87C29.3605 171.012 26.1231 159.832 25.7909 148.38C25.4587 136.928 28.0426 125.579 33.3001 115.4C41.036 100.558 43.5711 83.5517 40.5001 67.0996H146.2C143.017 83.4736 145.522 100.444 153.3 115.2C158.352 124.82 160.962 135.534 160.9 146.4C160.926 155.276 159.199 164.07 155.818 172.277C152.436 180.484 147.467 187.942 141.195 194.223C134.923 200.505 127.472 205.485 119.27 208.879C111.068 212.273 102.276 214.013 93.4001 214Z",
                        fill: "#FFC400"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                        style: {
                            mixBlendMode: 'multiply'
                        },
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            d: "M152.8 178.6L84.5 119.6L80.8 123.9L149.9 183.5L152.8 178.6Z",
                            fill: "#FFE380"
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M90.4 170.601C88.3452 170.598 86.3155 170.15 84.4509 169.287C82.5862 168.424 80.9312 167.166 79.5999 165.601C78.2601 164.053 77.2786 162.229 76.7254 160.259C76.1722 158.288 76.0611 156.219 76.4 154.201L78.3 141.601C75.4643 138.69 73.5294 135.023 72.7277 131.039C71.926 127.055 72.2917 122.925 73.7808 119.144C75.2699 115.363 77.8191 112.093 81.122 109.726C84.4249 107.359 88.3411 105.996 92.4 105.801H93.4C98.996 105.801 104.363 108.024 108.32 111.981C112.277 115.938 114.5 121.305 114.5 126.901C114.496 132.416 112.302 137.703 108.4 141.601L110.4 154.201C110.692 156.226 110.548 158.291 109.979 160.257C109.41 162.222 108.428 164.044 107.1 165.601C105.769 167.166 104.114 168.424 102.249 169.287C100.384 170.15 98.3547 170.598 96.3 170.601H90.4Z",
                        fill: "#FFAB00"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M106.6 126.9C106.586 128.711 106.196 130.499 105.456 132.151C104.716 133.803 103.641 135.284 102.3 136.5C101.574 137.222 101.032 138.107 100.719 139.081C100.405 140.056 100.33 141.091 100.5 142.1L102.6 155.4C102.728 156.305 102.662 157.226 102.405 158.103C102.147 158.979 101.706 159.79 101.109 160.482C100.512 161.173 99.7741 161.729 98.9446 162.112C98.1152 162.494 97.2134 162.695 96.3 162.7H90.4C89.4866 162.695 88.5848 162.494 87.7554 162.112C86.926 161.729 86.188 161.173 85.5912 160.482C84.9944 159.79 84.5526 158.979 84.2954 158.103C84.0382 157.226 83.9715 156.305 84.1 155.4L86.2 142C86.3747 140.983 86.2925 139.937 85.9607 138.959C85.6289 137.981 85.058 137.102 84.3 136.4C82.8962 135.116 81.7988 133.532 81.0892 131.767C80.3795 130.001 80.0756 128.099 80.2 126.2C80.2928 122.699 81.7726 119.379 84.3137 116.969C86.8548 114.559 90.2492 113.258 93.75 113.35C97.2509 113.443 100.571 114.923 102.981 117.464C105.391 120.005 106.693 123.399 106.6 126.9Z",
                        fill: "#253858"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M149.2 130.901H93.4C92.8286 130.992 92.2443 130.959 91.6872 130.802C91.1302 130.645 90.6138 130.37 90.1736 129.994C89.7334 129.619 89.3799 129.152 89.1375 128.627C88.8951 128.102 88.7695 127.53 88.7695 126.951C88.7695 126.373 88.8951 125.801 89.1375 125.275C89.3799 124.75 89.7334 124.284 90.1736 123.908C90.6138 123.532 91.1302 123.257 91.6872 123.1C92.2443 122.944 92.8286 122.91 93.4 123.001H149.2C150.14 123.151 150.995 123.631 151.613 124.355C152.23 125.079 152.57 126 152.57 126.951C152.57 127.903 152.23 128.823 151.613 129.547C150.995 130.271 150.14 130.751 149.2 130.901Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M153.1 126.901C153.075 125.875 152.656 124.897 151.93 124.172C151.204 123.446 150.226 123.027 149.2 123.001H112.4C111.829 122.91 111.244 122.944 110.687 123.1C110.13 123.257 109.614 123.532 109.174 123.908C108.733 124.284 108.38 124.75 108.137 125.275C107.895 125.801 107.77 126.373 107.77 126.951C107.77 127.53 107.895 128.102 108.137 128.627C108.38 129.152 108.733 129.619 109.174 129.994C109.614 130.37 110.13 130.645 110.687 130.802C111.244 130.959 111.829 130.992 112.4 130.901H149.2C150.243 130.875 151.235 130.442 151.964 129.695C152.693 128.947 153.1 127.945 153.1 126.901Z",
                        fill: "#2684FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M167.7 149.4C163.25 149.4 158.9 148.081 155.2 145.608C151.5 143.136 148.616 139.622 146.913 135.511C145.21 131.399 144.764 126.875 145.632 122.511C146.5 118.146 148.643 114.137 151.79 110.99C154.937 107.844 158.946 105.701 163.31 104.833C167.675 103.965 172.199 104.41 176.31 106.113C180.422 107.816 183.936 110.7 186.408 114.4C188.88 118.1 190.2 122.45 190.2 126.9C190.2 132.868 187.829 138.591 183.61 142.81C179.39 147.03 173.667 149.4 167.7 149.4ZM167.7 112.3C164.812 112.3 161.99 113.157 159.589 114.761C157.188 116.365 155.316 118.645 154.211 121.313C153.106 123.981 152.817 126.917 153.381 129.749C153.944 132.581 155.334 135.182 157.376 137.224C159.418 139.266 162.02 140.657 164.852 141.22C167.684 141.783 170.619 141.494 173.287 140.389C175.955 139.284 178.235 137.413 179.839 135.012C181.444 132.611 182.3 129.788 182.3 126.9C182.274 123.036 180.727 119.338 177.995 116.606C175.262 113.873 171.564 112.327 167.7 112.3Z",
                        fill: "#2684FF"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M67.8 165.301H55.6C55.3423 165.278 55.1009 165.166 54.918 164.983C54.7351 164.8 54.6225 164.558 54.6 164.301C54.6 164.036 54.7053 163.781 54.8929 163.594C55.0804 163.406 55.3348 163.301 55.6 163.301H67.8C68.0652 163.301 68.3196 163.406 68.5071 163.594C68.6946 163.781 68.8 164.036 68.8 164.301C68.7775 164.558 68.6649 164.8 68.482 164.983C68.2991 165.166 68.0576 165.278 67.8 165.301Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M62.7999 182.5C62.6675 182.512 62.5342 182.491 62.412 182.438C62.2897 182.386 62.1825 182.304 62.0999 182.2C61.9167 182.013 61.8141 181.761 61.8141 181.5C61.8141 181.238 61.9167 180.987 62.0999 180.8L70.4999 172.3C70.6925 172.155 70.9307 172.085 71.1708 172.102C71.4109 172.119 71.6368 172.222 71.807 172.393C71.9773 172.563 72.0804 172.789 72.0974 173.029C72.1145 173.269 72.0444 173.507 71.8999 173.7L63.4999 182.2C63.3098 182.38 63.0616 182.486 62.7999 182.5Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M79.9 189.6C79.6424 189.577 79.4009 189.464 79.218 189.282C79.0351 189.099 78.9226 188.857 78.9 188.6V175.6C78.9226 175.342 79.0351 175.1 79.218 174.918C79.4009 174.735 79.6424 174.622 79.9 174.6C80.1652 174.6 80.4196 174.705 80.6071 174.893C80.7947 175.08 80.9 175.334 80.9 175.6V188.6C80.9 188.865 80.7947 189.119 80.6071 189.307C80.4196 189.494 80.1652 189.6 79.9 189.6Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M128.8 111.301H116.7C116.565 111.317 116.428 111.302 116.299 111.257C116.17 111.213 116.054 111.14 115.957 111.043C115.861 110.947 115.788 110.83 115.743 110.702C115.699 110.573 115.684 110.436 115.7 110.301C115.7 110.036 115.805 109.781 115.993 109.594C116.18 109.406 116.435 109.301 116.7 109.301H128.8C129.065 109.301 129.32 109.406 129.507 109.594C129.695 109.781 129.8 110.036 129.8 110.301C129.816 110.436 129.801 110.573 129.757 110.702C129.712 110.83 129.639 110.947 129.543 111.043C129.446 111.14 129.33 111.213 129.201 111.257C129.072 111.302 128.935 111.317 128.8 111.301Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M113.2 102.601C112.938 102.587 112.69 102.481 112.5 102.301C112.317 102.114 112.214 101.863 112.214 101.601C112.214 101.339 112.317 101.088 112.5 100.901L121 92.5008C121.193 92.3563 121.431 92.2862 121.671 92.3033C121.911 92.3204 122.137 92.4235 122.307 92.5937C122.477 92.7639 122.58 92.9898 122.597 93.2299C122.615 93.47 122.544 93.7082 122.4 93.9008L113.9 102.301C113.812 102.399 113.704 102.477 113.583 102.528C113.462 102.58 113.331 102.605 113.2 102.601Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M104.5 100C104.235 100 103.98 99.8947 103.793 99.7072C103.605 99.5196 103.5 99.2653 103.5 99.0001V86.1C103.5 85.8348 103.605 85.5805 103.793 85.3929C103.98 85.2054 104.235 85.1 104.5 85.1C104.635 85.084 104.772 85.0988 104.901 85.1433C105.03 85.1879 105.146 85.2611 105.243 85.3574C105.339 85.4536 105.412 85.5705 105.457 85.6991C105.501 85.8278 105.516 85.9649 105.5 86.1V99.0001C105.516 99.1352 105.501 99.2723 105.457 99.401C105.412 99.5296 105.339 99.6465 105.243 99.7428C105.146 99.839 105.03 99.9122 104.901 99.9568C104.772 100.001 104.635 100.016 104.5 100Z",
                        fill: "#FFFAE5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var $5864b4a82dafec0c$export$2e2bcd8739ae039 = $5864b4a82dafec0c$var$AccessLockSVG;

});


parcelRegister("kMZDI", function(module, exports) {

$parcel$export(module.exports, "default", () => $90113ddcb9e4bff1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");

var $6g0KK = parcelRequire("6g0KK");

var $jQ0hK = parcelRequire("jQ0hK");
var $90113ddcb9e4bff1$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    (0, $5uXOq.useEffect)(()=>{
        analytics((duration)=>(0, $jQ0hK.profileCardRendered)('team', 'spinner', {
                duration: duration
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6g0KK.CardWrapper), {
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.CardHeader), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.CardContent), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.LoadingWrapper), {
                    testId: "team-profilecard-spinner",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {})
                })
            })
        ]
    });
};

});


parcelRegister("eit7l", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardTrigger", () => $267adb165158d16f$export$64983741fea6a45d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $jQ0hK = parcelRequire("jQ0hK");

var $bD4ui = parcelRequire("bD4ui");

var $7rSEd = parcelRequire("7rSEd");

var $hSaWA = parcelRequire("hSaWA");
const $267adb165158d16f$export$64983741fea6a45d = ({ trigger: trigger = 'hover', viewingUserId: viewingUserId, product: product, ...props })=>{
    const { resourceClient: resourceClient, agentId: userId, cloudId: cloudId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $jQ0hK.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const getCreator = async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'FORGE':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                const userId = (0, $bD4ui.getAAIDFromARI)(creator) || '';
                try {
                    if (!userId || !cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(cloudId, userId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${userId}`,
                        id: userId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    };
    const fetchAgentProfile = async ()=>{
        const agentInfo = await resourceClient.getRovoAgentProfile({
            type: 'agent',
            value: userId
        }, fireAnalytics);
        const agentCreatorInfo = await getCreator(agentInfo.creator_type, agentInfo.creator || undefined);
        return {
            ...agentInfo,
            creatorInfo: agentCreatorInfo
        };
    };
    const renderProfileCard = ({ profileData: profileData, error: error })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hSaWA.AgentProfileCardLazy), {
                agent: profileData,
                hasError: !!error,
                isCreatedByViewingUser: profileData?.creatorInfo && profileData?.creatorInfo?.id === viewingUserId,
                cloudId: props.cloudId,
                product: product,
                errorType: error,
                onChatClick: props.onChatClick,
                onConversationStartersClick: props.onConversationStartersClick,
                resourceClient: props.resourceClient,
                addFlag: props.addFlag
            })
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rSEd.default), {
        ...props,
        trigger: "hover",
        renderProfileCard: renderProfileCard,
        fetchProfile: fetchAgentProfile,
        fireAnalytics: fireAnalytics,
        profileCardType: "agent"
    });
};

});
parcelRegister("7rSEd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2ed6eeda6de6156$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $vCqQa = parcelRequire("vCqQa");

var $b4a3S = parcelRequire("b4a3S");

var $jQ0hK = parcelRequire("jQ0hK");

var $8I8N0 = parcelRequire("8I8N0");

var $7ra4O = parcelRequire("7ra4O");

var $bHUMf = parcelRequire("bHUMf");

var $cP2BN = parcelRequire("cP2BN");
const $c2ed6eeda6de6156$var$DELAY_MS_SHOW = 800;
const $c2ed6eeda6de6156$var$DELAY_MS_HIDE = 200;
function $c2ed6eeda6de6156$var$ProfileCardTrigger({ trigger: trigger, ariaLabelledBy: ariaLabelledBy, children: children, renderProfileCard: renderProfileCard, fetchProfile: fetchProfile, disabledAriaAttributes: disabledAriaAttributes, profileCardType: profileCardType, fireAnalytics: fireAnalytics, ...popupProps }) {
    const showDelay = trigger === 'click' ? 0 : $c2ed6eeda6de6156$var$DELAY_MS_SHOW;
    const hideDelay = trigger === 'click' ? 0 : $c2ed6eeda6de6156$var$DELAY_MS_HIDE;
    const showTimer = (0, $5uXOq.useRef)(0);
    const hideTimer = (0, $5uXOq.useRef)(0);
    const [visible, setVisible] = (0, $5uXOq.useState)(false);
    const { profileData: profileData, isLoading: isLoading, error: error, getProfileData: getProfileData } = (0, $8I8N0.useProfileInfo)({
        fetchUserProfile: fetchProfile
    });
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
        }, hideDelay);
    }, [
        hideDelay
    ]);
    const showProfilecard = (0, $5uXOq.useCallback)(async ()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                getProfileData?.();
                setVisible(true);
                if (fireAnalytics) fireAnalytics((0, $jQ0hK.cardTriggered)(profileCardType, trigger));
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        getProfileData,
        fireAnalytics,
        profileCardType,
        trigger
    ]);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.default), {
        ...popupProps,
        isOpen: !!visible,
        onClose: hideProfilecard,
        shouldUseCaptureOnOutsideClick: true,
        autoFocus: popupProps.autoFocus ?? trigger === 'click',
        zIndex: (0, $b4a3S.layers).modal(),
        shouldFitContainer: false,
        trigger: (triggerProps)=>{
            const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = triggerProps;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bHUMf.PopupTrigger), {
                ...disabledAriaAttributes ? restInnerProps : triggerProps,
                ref: triggerProps.ref,
                hideProfilecard: hideProfilecard,
                showProfilecard: showProfilecard,
                children: children,
                ariaLabelledBy: ariaLabelledBy,
                trigger: trigger
            });
        },
        content: ()=>// eslint-disable-next-line jsx-a11y/no-static-element-interactions
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onFocus: showProfilecard,
                children: isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cP2BN.ProfileCardWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ra4O.LoadingState), {
                        fireAnalytics: fireAnalytics,
                        profileType: profileCardType
                    })
                }) : renderProfileCard({
                    profileData: profileData,
                    error: error
                })
            })
    });
}
var $c2ed6eeda6de6156$export$2e2bcd8739ae039 = $c2ed6eeda6de6156$var$ProfileCardTrigger;

});
parcelRegister("8I8N0", function(module, exports) {

$parcel$export(module.exports, "useProfileInfo", () => $bc7c8c30f5886c4a$export$6cace87f7d7a9738);

var $5uXOq = parcelRequire("5uXOq");
const $bc7c8c30f5886c4a$export$6cace87f7d7a9738 = ({ fetchUserProfile: fetchUserProfile })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [profileData, setProfileData] = (0, $5uXOq.useState)();
    const getProfileData = async ()=>{
        setIsLoading(true);
        try {
            const profileData = await fetchUserProfile?.();
            setProfileData(profileData);
            setIsLoading(false);
        } catch (error) {
            setError(error);
            setIsLoading(false);
        }
    };
    return {
        profileData: profileData,
        isLoading: isLoading,
        error: error,
        getProfileData: getProfileData
    };
};

});

parcelRegister("7ra4O", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $0e0e0cda6228c500$export$62aa48085237e36f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");

var $2ZCVH = parcelRequire("2ZCVH");

var $jQ0hK = parcelRequire("jQ0hK");
const $0e0e0cda6228c500$export$62aa48085237e36f = ({ fireAnalytics: fireAnalytics, profileType: profileType })=>{
    (0, $5uXOq.useEffect)(()=>{
        if (fireAnalytics) fireAnalytics((0, $jQ0hK.profileCardRendered)(profileType, 'spinner'));
    }, [
        fireAnalytics,
        profileType
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {})
    });
};

});

parcelRegister("bHUMf", function(module, exports) {

$parcel$export(module.exports, "PopupTrigger", () => $d60ebd70f0b0083a$export$95d4acdbab2fc6ef);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $d60ebd70f0b0083a$var$PopupTriggerInner = ({ children: children, trigger: trigger, showProfilecard: showProfilecard, hideProfilecard: hideProfilecard, ariaLabelledBy: ariaLabelledBy, ...props }, ref)=>{
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            showProfilecard();
        }
    }, [
        showProfilecard
    ]);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        // Prevent the click event from propagating to parent containers.
        event.stopPropagation();
        showProfilecard();
    }, [
        showProfilecard
    ]);
    const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        ...containerListeners,
        ref: ref,
        "aria-labelledby": ariaLabelledBy,
        children: children
    });
};
const $d60ebd70f0b0083a$export$95d4acdbab2fc6ef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef($d60ebd70f0b0083a$var$PopupTriggerInner);

});

parcelRegister("cP2BN", function(module, exports) {

$parcel$export(module.exports, "ProfileCardWrapper", () => $cf50c787c9c29ca2$export$59abd6feb7dc8540);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
const $cf50c787c9c29ca2$var$styles = (0, $2s57o.xcss)({
    width: '360px'
});
const $cf50c787c9c29ca2$export$59abd6feb7dc8540 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        xcss: $cf50c787c9c29ca2$var$styles,
        children: children
    });
};

});




parcelRegister("d4xRU", function(module, exports) {

$parcel$export(module.exports, "default", () => $61381db0e069bc03$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $3KRpp = parcelRequire("3KRpp");
const $61381db0e069bc03$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $61381db0e069bc03$export$2e2bcd8739ae039 = $61381db0e069bc03$var$AkFlag;

});
parcelRegister("3KRpp", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $ef767762d5402ccf$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $ef767762d5402ccf$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $ef767762d5402ccf$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $ef767762d5402ccf$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $ef767762d5402ccf$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $ef767762d5402ccf$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $ef767762d5402ccf$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $ef767762d5402ccf$export$a2c3479950310d7d);

var $5uXOq = parcelRequire("5uXOq");

var $iNWLk = parcelRequire("iNWLk");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, $b7Svb.lazyForPaint)(()=>(parcelRequire("iYvi5")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, $b7Svb.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("iYvi5")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, $b7Svb.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("ktXXH")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, $b7Svb.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("ktXXH")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNWLk.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));

});
parcelRegister("iYvi5", function(module, exports) {

let $dd061a425b165709$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dd061a425b165709$var$load("hPzOn"),
    $dd061a425b165709$var$load("h2MrD"),
    $dd061a425b165709$var$load("bYT2S"),
    $dd061a425b165709$var$load("cM9em"),
    $dd061a425b165709$var$load("fr9NE"),
    $dd061a425b165709$var$load("4yB9l")
]).then(()=>parcelRequire('8ZHDV'));

});

parcelRegister("ktXXH", function(module, exports) {

let $ee95073ee99eb1d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee95073ee99eb1d5$var$load("Fkef4").then(()=>parcelRequire('5pz6a'));

});








//# sourceMappingURL=async-profilecard.5b97d38b.js.map
